/* Built by harness/build-scene-pages.cjs from src/scene-pages/sound.js + music.js + core.js + quest-id.js + tally-store.js. Edit the source, then rebuild. */
/* sound.js: every sound in the scene pages demo, made in the browser with Web Audio (no files, so nothing for the
   page's CSP to block). Nothing plays until the reader presses something: call FFSound.wake() inside a tap.
   FFSound.<name>(opts) plays one; FFSound.muted / setMuted(bool) (remembered per browser when storage allows). */
(() => {
  if (window.FFSound) return;
  let ctx = null, out = null, noise = null, muted = false;
  try { muted = localStorage.getItem('ffd-muted') === '1'; } catch (e) { /* storage blocked: start unmuted */ }
  const R = (a, b) => a + Math.random() * (b - a);
  function wake() {
    try {
      if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
        const comp = ctx.createDynamicsCompressor(); comp.threshold.value = -16; comp.ratio.value = 4;
        out = ctx.createGain(); out.gain.value = muted ? 0 : 0.5;
        out.connect(comp); comp.connect(ctx.destination);
        noise = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
        const d = noise.getChannelData(0);
        for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
      }
      if (ctx.state === 'suspended') ctx.resume();
      return ctx;
    } catch (e) { return null; }
  }
  const T = (dt) => ctx.currentTime + 0.005 + (dt || 0);
  /* a filtered noise burst */
  function nz(t, o) {
    const s = ctx.createBufferSource(); s.buffer = noise; s.loop = true;
    const f = ctx.createBiquadFilter(); f.type = o.type || 'bandpass'; f.frequency.setValueAtTime(o.f, t); f.Q.value = o.q || 1;
    if (o.f2) f.frequency.exponentialRampToValueAtTime(o.f2, t + (o.d || 0.1));
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(o.g, t + (o.a || 0.002)); g.gain.exponentialRampToValueAtTime(0.0001, t + (o.d || 0.1));
    let n = s.connect(f).connect(g);
    if (ctx.createStereoPanner) { const p = ctx.createStereoPanner(); p.pan.value = o.pan || 0; n = n.connect(p); }
    n.connect(out); s.start(t, R(0, 1.5)); s.stop(t + (o.d || 0.1) + 0.05);
  }
  /* a tone with an envelope; o.f2 glides the pitch */
  function tn(t, o) {
    const s = ctx.createOscillator(); s.type = o.type || 'sine'; s.frequency.setValueAtTime(o.f, t);
    if (o.f2) s.frequency.exponentialRampToValueAtTime(o.f2, t + (o.d || 0.3));
    if (o.det) s.detune.value = o.det;
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(o.g, t + (o.a || 0.01)); g.gain.exponentialRampToValueAtTime(0.0001, t + (o.d || 0.3));
    let n = s.connect(g);
    if (o.lp) { const f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = o.lp; n = n.connect(f); }
    n.connect(out); s.start(t); s.stop(t + (o.d || 0.3) + 0.05);
  }
  const play = (fn) => (o) => { if (!wake() || muted) return; try { fn(o || {}); } catch (e) { /* never break the page for a sound */ } };
  const S = {
    /* a crowd of hands: dense at first, thinning out; k 1 is a room, 2 is a roar */
    applause: play((o) => {
      const k = o.k || 1, dur = 0.9 + 0.45 * k, n = Math.round(40 * k * dur), t0 = T();
      for (let i = 0; i < n; i++) { const p = Math.pow(Math.random(), 1.6); nz(t0 + p * dur, { f: R(800, 2600), q: R(0.7, 1.6), g: 0.15 * Math.min(1.6, k) * (1 - p * 0.75) * R(0.45, 1), d: R(0.035, 0.08), pan: R(-0.7, 0.7) }); }
      nz(t0, { type: 'lowpass', f: 420, q: 0.5, g: 0.05 * k, a: 0.08, d: dur * 0.9 });
    }),
    /* dice on a wooden table: a few clacks that slow down, n dice */
    dice: play((o) => {
      const n = o.n || 1, t0 = T();
      for (let d = 0; d < n; d++) {
        let t = t0 + d * 0.09, gap = 0.05;
        for (let i = 0; i < 7; i++) { nz(t, { f: R(1800, 3600), q: 3, g: 0.2 * (1 - i / 9), d: 0.025, pan: R(-0.4, 0.4) }); tn(t, { type: 'triangle', f: R(500, 900), g: 0.05 * (1 - i / 8), d: 0.04 }); t += gap; gap *= 1.35; }
      }
    }),
    /* the total lands: a soft wooden knock */
    land: play(() => { const t = T(); nz(t, { type: 'lowpass', f: 300, q: 1.2, g: 0.3, d: 0.08 }); tn(t, { type: 'triangle', f: 160, g: 0.12, d: 0.12 }); }),
    /* a passed check: two warm notes */
    pass: play(() => { const t = T(); [523.3, 784].forEach((f, i) => tn(t + i * 0.08, { f, g: 0.07, d: 0.7, type: 'triangle', lp: 3000 })); }),
    /* a failed check: a low dull step down */
    miss: play(() => { const t = T(); tn(t, { f: 220, f2: 150, g: 0.1, d: 0.5, type: 'triangle', lp: 900 }); nz(t, { type: 'lowpass', f: 200, g: 0.12, d: 0.2 }); }),
    /* a natural 20: a bright rising chord with shimmer */
    crit: play(() => { const t = T(); [523.3, 659.3, 784, 1046.5, 1318.5].forEach((f, i) => tn(t + i * 0.045, { f, g: 0.07, d: 1.3, type: i % 2 ? 'sine' : 'triangle' })); for (let i = 0; i < 8; i++) tn(t + 0.2 + i * 0.05, { f: R(2400, 4200), g: 0.02, d: 0.3 }); }),
    /* a natural 1: a crack and a sour low note */
    fumble: play(() => { const t = T(); nz(t, { type: 'highpass', f: 1800, g: 0.35, d: 0.12 }); tn(t + 0.02, { f: 130, f2: 92, g: 0.14, d: 0.8, type: 'sawtooth', lp: 600 }); tn(t + 0.02, { f: 138, f2: 97, g: 0.1, d: 0.8, type: 'sawtooth', lp: 600 }); }),
    /* a quill line: a short dry scratch */
    pen: play(() => { const t = T(); for (let i = 0; i < 5; i++) nz(t + i * 0.035, { type: 'highpass', f: R(3500, 6000), g: R(0.04, 0.08), d: 0.03 }); }),
    /* a hammer on a nail: a thud and a small ring */
    hammer: play(() => { const t = T(); nz(t, { type: 'lowpass', f: 260, q: 1.5, g: 0.45, d: 0.1 }); tn(t, { f: 1900, g: 0.04, d: 0.25 }); tn(t, { f: 2870, g: 0.02, d: 0.18 }); }),
    /* paper torn off a board */
    rip: play(() => { const t = T(); for (let i = 0; i < 14; i++) nz(t + i * R(0.012, 0.022), { type: 'bandpass', f: R(1500, 5000), q: 0.8, g: R(0.05, 0.13), d: 0.03 }); }),
    /* paper lifting off glue */
    rustle: play(() => { const t = T(); for (let i = 0; i < 9; i++) nz(t + i * R(0.018, 0.034), { type: 'highpass', f: R(2400, 4800), q: 0.7, g: R(0.05, 0.11), d: R(0.03, 0.07) }); }),
    /* paper settling */
    pat: play(() => nz(T(), { type: 'lowpass', f: 700, q: 0.8, g: 0.07, d: 0.06 })),
    /* a small bright chime: something found */
    chime: play(() => { const t = T(); tn(t, { f: 1318.5, g: 0.08, d: 1.3 }); tn(t + 0.07, { f: 1975.5, g: 0.06, d: 1.1 }); tn(t + 0.14, { f: 2637, g: 0.035, d: 0.9, type: 'triangle' }); }),
    /* a coin: two metal partials that wobble, then a bounce or two */
    coin: play((o) => {
      const t = T(), b = o.bounces == null ? 2 : o.bounces;
      for (let i = 0; i <= b; i++) { const tt = t + (o.flight || 0) + i * 0.13 * Math.pow(0.6, i), g = 0.08 * Math.pow(0.55, i); tn(tt, { f: 3150, g, d: 0.35 }); tn(tt, { f: 4720, g: g * 0.6, d: 0.25 }); tn(tt, { f: 2200, g: g * 0.4, d: 0.4, det: 8 }); }
    }),
    /* a coin ringing on its edge: a long shimmering whirr */
    spin: play((o) => { const t = T(), d = o.d || 1.6; for (let i = 0; i < 18; i++) { const p = i / 18; tn(t + p * d, { f: 2900 + p * 900, g: 0.025 * (1 - p * 0.5), d: 0.12 }); } }),
    /* a candle lighting: a soft whoomp */
    candle: play((o) => { const t = T(); nz(t, { type: 'bandpass', f: 500, f2: 1800, q: 0.7, g: 0.12, a: 0.03, d: 0.35 }); if (o.warm !== false) tn(t + 0.05, { f: o.red ? 196 : 392, g: 0.04, d: 0.6, type: 'triangle' }); }),
    /* a heartbeat: two low thumps */
    heart: play(() => { const t = T(); [0, 0.22].forEach((dt, i) => { tn(t + dt, { f: 62, f2: 40, g: i ? 0.22 : 0.32, d: 0.18 }); nz(t + dt, { type: 'lowpass', f: 120, g: 0.12, d: 0.12 }); }); }),
    /* a heavy door or chair: a low creak */
    creak: play(() => { const t = T(); for (let i = 0; i < 6; i++) tn(t + i * 0.06, { f: R(160, 260), g: 0.03, d: 0.08, type: 'sawtooth', lp: 900 }); }),
    /* a latch: a click and a knock */
    latch: play(() => { const t = T(); nz(t, { type: 'highpass', f: 3000, g: 0.15, d: 0.02 }); nz(t + 0.06, { type: 'lowpass', f: 350, g: 0.2, d: 0.07 }); }),
    /* a card or tile turning over */
    flip: play(() => { const t = T(); nz(t, { type: 'bandpass', f: 1200, f2: 3000, q: 1, g: 0.08, d: 0.09 }); }),
    /* a soft tap for any button */
    tap: play(() => { const t = T(); tn(t, { f: 880, g: 0.035, d: 0.08, type: 'triangle' }); }),
    /* the words shown whole at a tap: a page's soft turn, quieter than a tap */
    leaf: play(() => { const t = T(); nz(t, { type: 'bandpass', f: 1500, f2: 3400, q: 0.9, g: 0.045, a: 0.006, d: 0.07 }); }),
    /* a soft whoosh: something moving past */
    whoosh: play((o) => nz(T(), { type: 'bandpass', f: 400, f2: 2400, q: 0.6, g: o.g || 0.12, a: 0.12, d: o.d || 0.45 })),
    /* a crate lid knocked open, with a little sparkle */
    pop: play(() => { const t = T(); nz(t, { type: 'lowpass', f: 320, q: 1.4, g: 0.32, d: 0.09 }); tn(t, { f: 196, g: 0.12, d: 0.14, type: 'triangle' }); [2093, 2637, 3136].forEach((f, i) => tn(t + 0.06 + i * 0.05, { f, g: 0.025, d: 0.35 })); }),
    /* lights coming up: a soft rising run */
    lights: play(() => { const t = T(); [523.3, 659.3, 784, 1046.5].forEach((f, i) => tn(t + i * 0.07, { f, g: 0.04, d: 0.6 })); }),
    /* a cart over cobbles */
    cart: play((o) => { const t0 = T(), sec = o.d || 1.1; for (let t = 0; t < sec; t += R(0.05, 0.09)) nz(t0 + t, { type: 'lowpass', f: R(180, 340), q: 2, g: R(0.14, 0.26) * (1 - t / sec * 0.4), d: R(0.05, 0.1), pan: -0.4 + 0.5 * t / sec }); }),
    /* a sword touched, a scar traced: a thin cold ring */
    ring: play(() => { const t = T(); tn(t, { f: 1760, g: 0.04, d: 1.4 }); tn(t, { f: 2637, g: 0.02, d: 1.0, det: 6 }); }),
    /* gold counted onto a table */
    gold: play((o) => { const t = T(), n = o.n || 6; for (let i = 0; i < n; i++) { const tt = t + i * R(0.05, 0.09); tn(tt, { f: R(2600, 3600), g: 0.05, d: 0.18 }); nz(tt, { type: 'highpass', f: 4000, g: 0.04, d: 0.02 }); } }),
    /* a murmur of a room, short */
    murmur: play((o) => { const t = T(), d = o.d || 1.2; for (let i = 0; i < 10; i++) nz(t + R(0, d * 0.8), { type: 'bandpass', f: R(250, 700), q: 3, g: R(0.03, 0.06), a: 0.08, d: R(0.2, 0.4), pan: R(-0.6, 0.6) }); }),
    /* a bird's wings */
    wings: play(() => { const t = T(); for (let i = 0; i < 6; i++) nz(t + i * 0.09, { type: 'bandpass', f: 900, q: 0.8, g: 0.08 * (1 - i / 7), a: 0.02, d: 0.07 }); })
  };
  S.wake = wake;
  Object.defineProperty(S, 'muted', { get: () => muted });
  S.setMuted = (m) => {
    muted = !!m;
    try { localStorage.setItem('ffd-muted', muted ? '1' : '0'); } catch (e) { /* fine */ }
    if (out) out.gain.value = muted ? 0 : 0.5;
    document.dispatchEvent(new CustomEvent('ffsound:mute', { detail: { muted } }));
  };
  window.FFSound = S;
})();

/* music.js: Jan's nine records for the scene pages (in the runtime every scene page loads, after sound.js). It began as
   the library jukebox's player (Jan, 2026-10-07: "they can change the songs but they cant control it"); since Jan's
   "all the scenes in background music too" (same day) every scene page plays one record softly under its own sounds
   (core.js, the section's Background music setting), and the library's jukebox still drives it as FFD.parts['library/music'].

   One AudioContext (adopted from the Enter gate when it made one, inside the tap or after its sound test, so iOS lets it
   play), one music bus with a low-pass and an analyser, and a voice per record: an <audio> element (crossOrigin
   anonymous, lazy) through its own gain. Fades are equal-power curves scheduled on AudioParams, so a busy frame never
   makes them step. Each record loops between its own measured points with a twin voice crossing the seam over 2.5 s,
   because the masters have composed fades that element.loop would dip through. One mute for music and the room's sounds
   ('ffd-muted', FFSound.setMuted). A hidden tab fades out and pauses, and the music comes back over 0.7 s.

   When the browser refuses sound (no tap yet): play() rejects with NotAllowedError, the player records it (music.blocked)
   and fires 'ffd:music-blocked' on document once, and the reader's next click, touchend or key anywhere (or music.kick()
   from a page's own listener) plays what was refused and fires 'ffd:music-unblocked'. A muted reader gets no event; turning
   sound on (inside that click) plays the record.
   iPhones, and Android's in-app browsers (Instagram, Facebook), gate each <audio> element on its own: an element plays
   from a timer only after a play() inside a tap. The loop's twin starts about 2:40 in, far from any tap, so the player
   keeps elements that already played (or were played and paused inside a tap, music.bless) and gives the twin one of
   those. If a twin is refused anyway, the old voice dips and goes back to the loop's head on its own element, so the
   record never stops after one loop.

   FFD.music(api) -> music   (FFD.parts['library/music'] is the same function)
     music.start(id)            the first record (adopts window.__ffdGate when the gate started it; a gate playing another
                                record crosses to this one, never both; the record already playing is left alone)
     music.tryStart(id)         start(id), then a Promise<boolean>: true once it sounds (element playing, context running);
                                false when the browser refused it or 300 ms went by. On false the record waits for kick().
     music.kick()               inside a click, touchend or keydown: resumes the context, plays every voice the browser
                                refused, starts the waiting record, wakes FFSound, clears blocked
     music.blocked              true while the browser is refusing the record
     music.play(id, fadeSec)    cross to another record      music.needle()   the old record dips like a lifted needle
     music.duck(on)  music.lpTo(hz, sec)  music.level() 0..1  music.time() seconds into the record
     music.prefetch(id)  music.muted  music.setMuted(bool)  music.on  music.id  music.debug()  music.close()
   api (all optional): urls (id -> URL, default URLS), names (id -> record name, default NAMES), art (lock-screen picture
   URL), album (the lock screen's album, default 'FramedFantasy'), level (the music bus, default 0.85).
   FFD.music.TRACKS, URLS and NAMES are the nine records; FFD.music.live lists the open players (for tests). */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  FFD.parts = FFD.parts || {};
  /* where each master starts, where its loop runs, and its level trim (dB), measured from Jan's files */
  const TRACK = {
    quiet: { at: 0.96, loop: [3.2, 161.5], trim: 0 },
    hearth: { at: 0.69, loop: [2.4, 178.1], trim: -1.3 },
    after: { at: 0.07, loop: [0.1, 138.5], trim: 0 },
    regal: { at: 0.38, loop: [3.2, 186.2], trim: -0.4 },
    bog: { at: 0.95, loop: [4.1, 184.8], trim: -2.8 },
    tinker: { at: 0, loop: [2.0, 136.8], trim: -0.3 },
    tavern: { at: 0, loop: [0, 178.9], trim: -0.9 },
    flood: { at: 0.92, loop: [2.7, 198.7], trim: -2.0 },
    ash: { at: 0, loop: [0, 121.8], trim: -1.8 }
  };
  const SEAM = 2.5;
  /* Jan's files on the store's Shopify Files */
  const CDN = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/';
  const URLS = {
    quiet: CDN + 'Quiet_Alehouse_Loop.mp3?v=1787997451', hearth: CDN + 'Subtle_Hearthside_Echoes.mp3?v=1791341791',
    after: CDN + 'Quiet_Alehouse_Loop_4.mp3?v=1791343180', regal: CDN + 'Regal_Wayfarer.mp3?v=1787997451',
    bog: CDN + 'Murmurs_in_the_Bog.mp3?v=1787997451', tinker: CDN + 'Tinker_s_Evening_Route.mp3?v=1787997451',
    tavern: CDN + 'Shadows_in_the_Tankard_2.mp3?v=1787997452', flood: CDN + 'Blackwater_Pressure.mp3?v=1791343041',
    ash: CDN + 'Ash_in_the_Alehouse.mp3?v=1787997452'
  };
  const NAMES = {
    quiet: 'Quiet Alehouse', hearth: 'Hearthside Echoes', after: 'After Hours', regal: 'Regal Wayfarer', bog: 'Murmurs in the Bog',
    tinker: 'Tinker’s Evening Route', tavern: 'Shadows in the Tankard', flood: 'Blackwater Pressure', ash: 'Ash in the Alehouse'
  };
  /* how many played (unlocked) elements the player keeps for twins and record changes */
  const SPARE = 2, KEEP = 3;
  /* keys that never count as the reader asking for anything */
  const NOT_A_PRESS = /^(Escape|Shift|Control|Alt|AltGraph|Meta|CapsLock|Fn|OS)$/;
  const live = [];
  /* Firefox alone answers ahead of time (navigator.getAutoplayPolicy, Firefox 112+): true only when both an element and
     Web Audio may sound; null everywhere else, where only the real element's play() can tell */
  function policy() {
    try {
      if (typeof navigator.getAutoplayPolicy !== 'function') return null;
      return navigator.getAutoplayPolicy('mediaelement') === 'allowed' && navigator.getAutoplayPolicy('audiocontext') === 'allowed';
    } catch (e) { return null; }
  }
  const fire = (name, detail) => { try { document.dispatchEvent(new CustomEvent(name, { detail })); } catch (e) { /* fine */ } };

  const music = function (api) {
    api = api || {};
    const urls = Object.assign({}, URLS, api.urls || {}), names = Object.assign({}, NAMES, api.names || {});
    const BUS = typeof api.level === 'number' && api.level > 0 ? api.level : 0.85;
    let ac = null, bus = null, lp = null, an = null, buf = null, cur = null, closed = false, hiddenAt = 0;
    let muted = false, blocked = false, pending = null, blessing = 0, seamMiss = 0;
    try { muted = localStorage.getItem('ffd-muted') === '1'; } catch (e) { /* storage blocked: start unmuted */ }
    const voices = new Set(), pre = {}, spare = [];
    const trimOf = (id) => Math.pow(10, ((TRACK[id] && TRACK[id].trim) || 0) / 20);

    function wake() {
      if (ac) { if (ac.state === 'suspended') ac.resume().catch(() => {}); return ac; }
      try {
        const g = window.__ffdGate;
        ac = g && g.ac ? g.ac : new (window.AudioContext || window.webkitAudioContext)();
        bus = ac.createGain(); bus.gain.value = muted ? 0 : BUS;
        lp = ac.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 18000; lp.Q.value = 0.4;
        an = ac.createAnalyser(); an.fftSize = 256; buf = new Uint8Array(an.frequencyBinCount);
        bus.connect(lp); lp.connect(an); an.connect(ac.destination);
        try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) { /* fine */ }
        if (ac.state === 'suspended') ac.resume().catch(() => {});
      } catch (e) { ac = null; }
      return ac;
    }
    function curve(param, from, to, sec, up) {
      const n = 33, c = new Float32Array(n);
      for (let i = 0; i < n; i++) { const t = i / (n - 1); c[i] = from + (to - from) * (up ? Math.sin(t * Math.PI / 2) : 1 - Math.cos(t * Math.PI / 2)); }
      try { const t0 = ac.currentTime + 0.01; param.cancelScheduledValues(t0); param.setValueAtTime(from, t0); param.setValueCurveAtTime(c, t0, Math.max(0.05, sec)); }
      catch (e) { try { param.value = to; } catch (e2) { /* fine */ } }
    }
    const fresh = () => { const el = new Audio(); el.crossOrigin = 'anonymous'; el.preload = 'auto'; el.playsInline = true; return el; };
    /* a prefetched element first (its bytes are in), then one that already played (it may play from a timer on an iPhone) */
    function element(id) {
      if (pre[id]) { const el = pre[id]; delete pre[id]; return el; }
      const el = spare.pop() || fresh();
      el.src = urls[id] || '';
      return el;
    }
    /* keep an element that played inside a tap (or was allowed to), for later twins and records */
    function keep(el) { el.__ffdOk = true; if (!closed && spare.length < KEEP && spare.indexOf(el) < 0) spare.push(el); }
    /* inside a tap: play and pause a few empty elements so they stay allowed (a refusal here just keeps nothing) */
    function bless(n) {
      for (let i = spare.length + blessing; i < (n || SPARE); i++) {
        const el = fresh();
        let p = null;
        try { p = el.play(); } catch (e) { p = null; }
        try { el.pause(); } catch (e) { /* fine */ }
        if (!p || !p.then) break;
        blessing++;
        p.then(() => { blessing--; keep(el); }, (e) => { blessing--; if (e && e.name === 'AbortError') keep(el); });
      }
    }
    /* the element through its own gain into the bus; with no routing (old browsers) the element's volume */
    function route(v) {
      if (!ac) return;
      try {
        const had = v.el.__ffdSrc, src = had || ac.createMediaElementSource(v.el);
        if (had) { try { had.disconnect(); } catch (e) { /* fine */ } }
        v.el.__ffdSrc = src; v.gain = ac.createGain(); v.gain.gain.value = 0; src.connect(v.gain); v.gain.connect(bus);
      } catch (e) { v.gain = null; }
    }
    function watch(v) {
      const el = v.el;
      if (el.__ffdTU) el.removeEventListener('timeupdate', el.__ffdTU);
      el.__ffdTU = () => seamCheck(v);
      el.addEventListener('timeupdate', el.__ffdTU);
    }
    const mk = (id, el, prev) => ({ id, el, gain: null, seam: false, dead: false, refused: false, ok: false, prev: prev || null, offT: 0, loopT: 0, onNo: null });
    /* play a voice's element, and hear the answer: a refusal is recorded, never swallowed */
    function sound(v) {
      let p = null;
      try { p = v.el.play(); } catch (e) { p = null; }
      if (!p || !p.then) return;
      p.then(() => { v.ok = true; v.refused = false; v.prev = null; v.el.__ffdOk = true; }, (e) => { if (e && e.name === 'NotAllowedError') refused(v); });
    }
    function voice(id, el, startAt, prev) {
      const v = mk(id, el, prev);
      try { el.currentTime = startAt; } catch (e) { el.addEventListener('loadedmetadata', () => { try { el.currentTime = startAt; } catch (e2) { /* fine */ } }, { once: true }); }
      route(v); watch(v);
      voices.add(v);
      sound(v);
      return v;
    }
    function refused(v) {
      if (closed || v.dead) return;
      v.refused = true;
      if (v.prev && !v.ok && v === cur) seamMissed(v);
      else setBlocked();
      if (v.onNo) v.onNo();
    }
    function setBlocked() {
      if (blocked || closed) return;
      blocked = true;
      if (!muted) fire('ffd:music-blocked', { id: cur ? cur.id : pending });
    }
    function fadeIn(v, sec) { if (v.gain) curve(v.gain.gain, 0, trimOf(v.id), sec, true); else v.el.volume = muted ? 0 : 0.9 * trimOf(v.id); }
    function retire(v, sec) {
      if (!v || v.dead) return;
      v.dead = true;
      clearTimeout(v.loopT);
      if (v.gain) curve(v.gain.gain, v.gain.gain.value, 0, sec, false);
      v.offT = setTimeout(() => {
        v.offT = 0;
        try { v.el.pause(); v.el.removeAttribute('src'); v.el.load(); } catch (e) { /* fine */ }
        try { v.gain && v.gain.disconnect(); } catch (e) { /* fine */ }
        voices.delete(v);
        if (v.el.__ffdOk) keep(v.el);
      }, sec * 1000 + 300);
    }
    /* the loop: a twin voice starts at the loop's head and crosses the old one over the seam */
    function seamCheck(v) {
      if (closed || v !== cur || v.seam || v.dead) return;
      const T = TRACK[v.id]; if (!T) return;
      const end = Math.min(T.loop[1], (v.el.duration || 1e9) - 0.05);
      if (v.el.currentTime < end - SEAM) return;
      v.seam = true;
      const twin = voice(v.id, element(v.id), T.loop[0], v);
      fadeIn(twin, SEAM); retire(v, SEAM); cur = twin;
    }
    /* the twin was refused (an iPhone or an in-app browser with no played element to spare): the old voice comes back,
       dips, and goes back to the loop's head on its own element, which is allowed because it is already playing */
    function seamMissed(twin) {
      const v = twin.prev;
      seamMiss++;
      twin.dead = true; twin.prev = null; voices.delete(twin);
      try { twin.gain && twin.gain.disconnect(); } catch (e) { /* fine */ }
      try { twin.el.removeAttribute('src'); twin.el.load(); } catch (e) { /* fine */ }
      if (!v || !voices.has(v)) { cur = null; setBlocked(); return; }
      clearTimeout(v.offT); v.offT = 0; v.dead = false; v.seam = true; cur = v;
      const T = TRACK[v.id], back = () => { try { v.el.currentTime = T.loop[0]; } catch (e) { /* fine */ } };
      if (!v.gain) { back(); v.seam = false; return; }
      curve(v.gain.gain, v.gain.gain.value, 0, 0.4, false);
      v.loopT = setTimeout(() => {
        v.loopT = 0;
        if (closed || v.dead) return;
        back(); curve(v.gain.gain, 0, trimOf(v.id), 0.9, true); v.seam = false;
      }, 450);
    }
    /* a gate on a context this player can't route (it never should be): hush it, so the record is never doubled */
    function hush(g) {
      try { g.gain && g.gain.gain.setTargetAtTime(0, g.ac.currentTime, 0.15); } catch (e) { /* fine */ }
      setTimeout(() => { try { g.el.pause(); g.el.removeAttribute('src'); g.el.load(); } catch (e) { /* fine */ } try { g.ac && g.ac.close && g.ac.close().catch(() => {}); } catch (e) { /* fine */ } }, 700);
    }

    function start(id) {
      if (closed) return;
      const g = window.__ffdGate;
      wake();
      /* the gate may already be playing the first record (inside the Enter tap, or after its sound test): adopt that element */
      if (g && g.el && ac && g.ac === ac) {
        window.__ffdGate = null;
        const v = mk(g.id, g.el);
        v.gain = g.gain || null; v.ok = true; g.el.__ffdOk = true;
        if (!v.gain) { route(v); if (v.gain) v.gain.gain.value = 1; }
        else { try { v.gain.disconnect(); v.gain.connect(bus); } catch (e) { /* fine */ } }
        watch(v); voices.add(v);
        if (cur) retire(cur, 1.5);
        cur = v;
        bless(SPARE);
        if (g.id !== id && TRACK[id]) { play(id, 1.5); return; }
        session(id);
        return;
      }
      if (g && g.el) { window.__ffdGate = null; hush(g); }
      bless(SPARE);
      if (cur && !cur.dead && cur.id === id) { session(id); return; }
      play(id, 1.5);
    }
    function play(id, fadeSec) {
      if (closed || !TRACK[id]) return;
      wake();
      pending = null;
      const v = voice(id, element(id), TRACK[id].at);
      fadeIn(v, fadeSec || 2.4);
      if (cur) retire(cur, fadeSec || 2.4);
      cur = v;
      session(id);
    }
    function tryStart(id) {
      return new Promise((res) => {
        if (closed || !TRACK[id]) { res(false); return; }
        if (policy() === false) { pending = id; setBlocked(); res(false); return; }
        start(id);
        const v = cur;
        if (!v || v.dead) { res(false); return; }
        let done = false, t = 0;
        const fin = (ok) => {
          if (done) return;
          done = true; clearTimeout(t); v.onNo = null;
          try { ac && ac.removeEventListener('statechange', check); } catch (e) { /* fine */ }
          try { v.el.removeEventListener('playing', check); } catch (e) { /* fine */ }
          res(ok);
        };
        /* allowed: nothing refused, the element running, and the context too (never the context alone: Android's
           in-app browsers run an AudioContext while refusing every <audio>) */
        function check() {
          if (done) return;
          if (v.refused || closed) { fin(false); return; }
          if (v.el.paused) return;
          if (ac ? ac.state === 'running' : v.ok) fin(true);
        }
        v.onNo = check;
        try { v.el.addEventListener('playing', check); } catch (e) { /* fine */ }
        if (ac) {
          try { ac.addEventListener('statechange', check); } catch (e) { /* fine */ }
          try { ac.resume().then(check, () => {}); } catch (e) { /* fine */ }
        }
        t = setTimeout(() => { if (!done && ac && ac.state !== 'running') setBlocked(); fin(false); }, 300);
      });
    }
    /* call inside a click, touchend or keydown */
    function kick() {
      if (closed) return false;
      const was = blocked;
      blocked = false;
      wake();
      try { if (ac && ac.state !== 'running' && ac.state !== 'closed') ac.resume().catch(() => {}); } catch (e) { /* fine */ }
      voices.forEach((v) => {
        if (v.dead || !(v.refused || v.el.paused)) return;
        const no = v.refused;
        v.refused = false;
        sound(v);
        if (no) fadeIn(v, 1.5);
      });
      if (pending && (!cur || cur.dead)) { const id = pending; pending = null; start(id); }
      try { if (window.FFSound) FFSound.wake(); } catch (e) { /* fine */ }
      bless(SPARE);
      if (was) fire('ffd:music-unblocked', { id: cur ? cur.id : null });
      return true;
    }
    function needle() {
      if (!cur || !cur.gain || !ac) return;
      const g0 = cur.gain.gain.value; curve(cur.gain.gain, g0, g0 * 0.5, 0.35, false);
      lpTo(1200, 0.35); setTimeout(() => lpTo(18000, 0.6), 650);
    }
    function lpTo(f, sec) { if (!lp || !ac) return; try { lp.frequency.cancelScheduledValues(ac.currentTime); lp.frequency.setTargetAtTime(f, ac.currentTime, Math.max(0.02, sec / 3)); } catch (e) { /* fine */ } }
    function duck(on) { if (!bus || !ac || muted) return; try { bus.gain.cancelScheduledValues(ac.currentTime); bus.gain.setTargetAtTime(on ? BUS * 0.6 : BUS, ac.currentTime, on ? 0.07 : 0.2); } catch (e) { /* fine */ } }
    function level() {
      if (!an || !cur || muted || document.hidden) return 0.35 + 0.15 * Math.sin(performance.now() / 260);
      an.getByteFrequencyData(buf); let s = 0; for (let i = 2; i < 40; i++) s += buf[i];
      return Math.max(0, Math.min(1, s / (38 * 170)));
    }
    const time = () => (cur && cur.el ? cur.el.currentTime || 0 : 0);
    function setMuted(m, quiet) {
      muted = !!m;
      try { localStorage.setItem('ffd-muted', muted ? '1' : '0'); } catch (e) { /* fine */ }
      if (bus && ac) { try { bus.gain.cancelScheduledValues(ac.currentTime); bus.gain.setTargetAtTime(muted ? 0 : BUS, ac.currentTime, 0.08); } catch (e) { /* fine */ } }
      else voices.forEach((v) => { v.el.volume = muted ? 0 : 0.9 * trimOf(v.id); });
      if (!quiet) { try { window.FFSound && FFSound.muted !== muted && FFSound.setMuted(muted); } catch (e) { /* fine */ } }
      /* sound back on, inside the reader's click: play what the browser refused while muted */
      if (!muted && blocked) kick();
    }
    function prefetch(id) {
      if (pre[id] || !urls[id] || (cur && cur.id === id)) return;
      const c = navigator.connection; if (c && (c.saveData || /2g|3g/.test(c.effectiveType || ''))) return;
      const el = new Audio(); el.crossOrigin = 'anonymous'; el.preload = 'auto'; el.src = urls[id]; try { el.load(); } catch (e) { /* fine */ }
      pre[id] = el;
    }
    /* the lock screen: the record's name and the page, and no skip buttons (the reader can't choose) */
    function session(id) {
      try {
        if (!('mediaSession' in navigator) || !window.MediaMetadata) return;
        const album = api.album || 'FramedFantasy';
        navigator.mediaSession.metadata = new MediaMetadata({ title: names[id] || album, artist: 'FramedFantasy', album, artwork: api.art ? [{ src: api.art, sizes: '512x512' }] : [] });
        ['nexttrack', 'previoustrack', 'seekbackward', 'seekforward', 'seekto'].forEach((a) => { try { navigator.mediaSession.setActionHandler(a, null); } catch (e) { /* fine */ } });
      } catch (e) { /* fine */ }
    }
    /* a hidden tab fades out and pauses; coming back fades in. A phone may refuse to wake the context without a touch
       (iOS leaves it suspended or "interrupted"), and then the records play into silence while nothing looks refused:
       so a context still not running a moment later counts as blocked, and the reader's next touch (kick) brings the
       music back. Before this, the music could stay silent for good after a trip to another tab (Jan, 2026-10-09). */
    function onVis() {
      if (!ac || !cur) return;
      if (document.hidden) {
        hiddenAt = Date.now();
        try { bus.gain.setTargetAtTime(0, ac.currentTime, 0.06); } catch (e) { /* fine */ }
        setTimeout(() => { if (document.hidden) { voices.forEach((v) => { try { v.el.pause(); } catch (e) { /* fine */ } }); ac.suspend().catch(() => {}); } }, 220);
      } else {
        const asleep = () => { if (!closed && !document.hidden && ac && ac.state !== 'running') setBlocked(); };
        ac.resume().then(() => { if (ac.state !== 'running') asleep(); }, asleep);
        voices.forEach((v) => { if (!v.dead) sound(v); });
        try { bus.gain.cancelScheduledValues(ac.currentTime); bus.gain.setValueAtTime(0, ac.currentTime); bus.gain.linearRampToValueAtTime(muted ? 0 : BUS, ac.currentTime + 0.7); } catch (e) { /* fine */ }
        setTimeout(asleep, 600);
      }
    }
    /* the reader's presses: a refused record plays on the next one (not pointerdown, which unlocks nothing on a touch
       screen), and each keeps a couple of played elements in hand for the loop's twin */
    function onPress(e) {
      if (closed) return;
      if (e && e.type === 'keydown' && NOT_A_PRESS.test(e.key || '')) return;
      if (blocked && !muted) kick();
      else if (spare.length + blessing < SPARE) bless(SPARE);
    }
    const PRESS = ['click', 'touchend', 'keydown'], OPT = { capture: true, passive: true };
    PRESS.forEach((t) => document.addEventListener(t, onPress, OPT));
    document.addEventListener('visibilitychange', onVis);
    const onMute = (e) => { const m = !!(e && e.detail && e.detail.muted); if (m !== muted) setMuted(m, true); };
    document.addEventListener('ffsound:mute', onMute);

    const self = {
      start, tryStart, kick, play, needle, duck, lpTo, level, time, prefetch, setMuted, wake,
      get muted() { return muted; },
      get blocked() { return blocked; },
      get on() { return !!cur; },
      get id() { return cur ? cur.id : null; },
      debug() {
        let playing = 0; voices.forEach((v) => { if (!v.dead && !v.el.paused) playing++; });
        return { id: cur ? cur.id : null, voices: voices.size, playing, spare: spare.length, blocked, pending, seamMiss, ctx: ac ? ac.state : null, at: time() };
      },
      close() {
        if (closed) return;
        closed = true;
        PRESS.forEach((t) => document.removeEventListener(t, onPress, OPT));
        document.removeEventListener('visibilitychange', onVis); document.removeEventListener('ffsound:mute', onMute);
        voices.forEach((v) => retire(v, 0.4));
        Object.keys(pre).forEach((k) => { try { pre[k].removeAttribute('src'); } catch (e) { /* fine */ } });
        spare.splice(0).forEach((el) => { try { el.removeAttribute('src'); } catch (e) { /* fine */ } });
        try { if ('mediaSession' in navigator) navigator.mediaSession.metadata = null; } catch (e) { /* fine */ }
        const i = live.indexOf(self); if (i >= 0) live.splice(i, 1);
      }
    };
    live.push(self);
    return self;
  };
  music.TRACKS = TRACK; music.URLS = URLS; music.NAMES = NAMES; music.live = live;
  FFD.music = music;
  FFD.parts['library/music'] = music;
})();

/* core.js: the scene pages runtime (src/scene-pages/core.js). One file for the review demo and the live theme.
   docs/scene-pages/demo2/build.cjs copies it to the demo; harness/build-scene-pages.cjs builds it into assets/.

   A page registers itself, and FFD.mount(def, el) builds it into a root element:
     FFD.page({ id, order, section, kind: 'toy' | 'dm' | 'hall' | 'concept', title, hook, thumb: { key, set }, render(ctx) })
     FFD.mount(def, el, { medium }) -> ctx      (ctx.kill() when the reader leaves)

   THE FRAME (ctx.frame) is where a page is played. The art and the words share one screen and never scroll apart:
     on a phone the frame is the screen, the living pixel scene on top (square, or shorter on a short screen) and the
     dialogue box under it, the art fading into the box; on a wide screen the frame is the whole window under the header,
     edge to edge (on a very wide window the picture keeps a 2.2 to 1 shape and its edge colours fade out into the sides),
     and the box sits over its lower edge like an adventure game's. Speech bubbles float over whoever speaks. Dice roll over the art.
     Every scene publishes its clickable things (src/scene-pages/hot.js) and the frame lays an invisible, focusable
     button over each one, so the reader plays by clicking the picture; the chips in the box are the fallback.

     const F = ctx.frame({ key, alt, set, title, line, hots: { id: { label, tap(id, F), sound } }, onHot(id),
                           onEmit(type, data, key), tapArt(gx, gy) })
     F.ready                              Promise: the scene is mounted
     F.scene(key, { set, reset })         crossfade the art to another scene (its hotspots come with it)
     F.act(type, v)  F.set(n, v)  F.get(n)    talk to the scene on show
     F.on(type, fn) -> off                 F.once(type, ms) -> Promise(data)     scene emits
     F.hots(map, { merge })                the hotspot handlers ({ id: { label, tap, sound } }); F.lock(on) ignores taps
     F.say(lines, { who, add, gap, now }) lines one at a time in the box; resolves once they have all arrived.
                                           A line is a string or { text, cls ('say' | 'big' | 'dim' | 'gold'), who, sound }.
                                           who: { name, img (square portrait), icon (class key) }
                                           How words arrive (Jan, 2026-10-09: "the text comes in like kind of all at once and
                                           it feels buggy like when any character talks"): a new speaker's face and name settle
                                           in first; each line is laid out whole before it shows (so the box takes its final
                                           height at once and nothing below it jumps) and its words fade in one after another
                                           at a calm reading pace, with a beat after a comma and a longer one after a full stop.
                                           A long line goes faster, so no line drags. One tap anywhere on the frame (or Enter,
                                           Space) shows the rest of the page at once and does nothing else; the next tap goes
                                           on. While words arrive a clear layer takes the tap (.ffs.is-reading) and the box
                                           sits over it, so a chip already in the box still works (and shows the words);
                                           tapThrough still lets a thing squarely under the layer answer. The layer stays
                                           a moment after the last word (.ffs.is-settle) until the story's next step is up,
                                           so a tap aimed at the line never lands on what lies under it. One voice at a time:
                                           a bubble still arriving finishes before the box's words start. Choices (F.ask chips
                                           and sheets, F.next and its pill, F.actions, the ending's buttons) come only after
                                           every word on its way in (the box's and the bubbles'), rising in a short stagger;
                                           a choice ignores a pointer tap in its first moments and while the reader is still
                                           tapping through the text (a press within RUN ms of the last tap that showed words,
                                           continued or was refused), so a quick run of taps never picks for the reader.
                                           The box's height glides when it changes. Reduced motion: each line at once with a
                                           plain fade. Screen readers hear each page of lines once, whole, from a polite live
                                           region (never word by word)
                                           Tap to continue (Jan, 2026-10-04): when the box still holds lines nobody has
                                           tapped past, F.say waits for a tap before it takes them away (a small pixel ▾
                                           blinks at the end of the last line), and a box too full for the next line turns
                                           its page on a tap. now: true skips the wait (a page that knows it was just read)
     F.cont({ always })                    tap to continue between beats: resolves on the next tap anywhere on the frame
                                           (or Enter / Space), at once when nothing is waiting to be read (always: wait anyway).
                                           Called while a line still arrives, it waits for the words first (one tap shows
                                           them, the next continues)
     F.read() -> Promise                   resolves once no words are on their way in (the box's and the bubbles')
     FFD.arrive(el, text, { html, delay, tap }) -> { done, finish(), stop() }   the box's word by word arrival for a
                                           part's own element (a line the box doesn't hold); reduced motion shows it at once
     F.bark(target, text, { who, below, tone }) a speech bubble over the art: target is a hotspot id, { x, y } in grid
                                           px, or null; it sits above its target, or below it (below: true, or no room above).
                                           It stays until the reader's next tap (no timer takes it away); resolves when it goes.
                                           It takes its full size at once and its words arrive as the box's do; a tap while
                                           they arrive shows them whole and the bubble stays for one more tap
     F.next(label, { hot, solid, quiet, chip }) one action; resolves on a press, or on a tap of the hotspot(s) in hot.
                                           With hot, the button is a pill written on that thing in the picture (Jan: "have
                                           them press something on the screen itself where the art is"); chip: true puts
                                           it in the box instead, and it falls back to the box if the thing isn't on show
     F.ask(options, { cols, sheet, prompt, used }) choice chips (a sheet over the art when they're many or long); resolves
                                           { index, label, value }. An option may carry hot: id (tapping it in the art picks it)
     F.actions(list, { hint, used }) -> { el, btn(i), show(i, on), label(i, t), disable(on), used(i, on), remove() }
                                           a lasting row of chips
                                           used (Jan, 2026-10-04: "when you pick an option it should grey it out, they can still
                                           open it"): true greys a picked option with a small tick, here and whenever an option
                                           with the same key shows again in this frame; it still works. An option's own used:
                                           true / false overrides the row's, and key: '…' names it (the label otherwise)
     F.tool({ label, html, text, onClick }) -> button   an extra round tool in the art's corner (a clue book, a clock)
     F.roll({ dice: [{ sides, skin }], bonus, dc, stakes, label, hot, now, onThrow }) -> Promise({ total, rolls, nat, pass, crit, fumble })
                                           now: true throws at once (no Roll chip; for a die tapped in the art)
                                           the stakes in the box, then real 3D dice over the art and the total over the art
     F.char({ prompt, button, fresh, guest }) -> Promise(char)   who the reader plays. With a character saved (FFD.char)
                                           it resolves at once, no question: a small "Playing as {Name}" plate shows over
                                           the art with a Change button, and a 44 px "playing as" chip joins the corner tools
                                           left of the sound (it stays, so switching is always one tap away). With nothing
                                           saved (or fresh: true) the form opens as a sheet, as before, plus a race list and
                                           a shape (Masculine, In between, Feminine). Change opens one switch sheet: the
                                           Quest hero (FFD.quest.hero()), the Hall heroes the ledger saved (FFD.quest.heroes()),
                                           each tagged by where it came from ('From the Quest' or 'In the Hall', from the
                                           copy's via and each row's fromQuest), Someone else (the form) and, for a hero
                                           that came by itself, "Not you?"
                                           (FFD.quest.forget()). guest: true (bounty's "A player's character") opens an empty
                                           form and returns that character without saving it; this frame's {Name} lines then
                                           speak of the guest until the next F.char or F.as(null)
     F.as(char | null)                     the character this frame's {Name} lines speak of (null: FFD.char again)
     F.change() -> Promise(char | null)    opens the switch sheet (what the plate and the chip do); never over the page's
                                           own open sheet
     F.sheet(build(el, close), { title }) -> Promise   any sheet over the art (an item card, a long form)
     F.result(text, small)  F.hideResult()   a big caption over the art (the coin's "Tails.")
     F.hint(ids)                           make the clickable things sparkle (the frame's lantern button does it too)
     F.beacon(ids, on)                     a soft breathing ring on things the reader should tap next. F.next, F.ask and
                                           F.roll light it on their hot targets by themselves after about 2 s
                                           ({ beacon: false } turns that off, { beaconAfter: ms } retimes it)
     F.end({ lines, leadIn, takenLeadIn, again, save, campaign, medium, shared }) -> Promise('again')   the ending: lines, one
                                           Quest button, play again; shared: [{ n, plus, text: '{n} calls lost by everyone so far' }]
                                           shows what every player's runs add up to (see FFD.tally). A reader who took the Quest
                                           (FFD.quest.took()) gets "Back to Zhaunil’s library" as the main button instead (while
                                           the library is published) and a quiet "Play the Quest with another hero" (utm_medium
                                           again); leadIn, which sells the Quest, gives way to takenLeadIn (none by default).
                                           The ending's main button always carries .is-quest, which pages wait for
     F.busy(on)  F.clear()  F.toCss(gx, gy)  F.spotCss(id)  F.el  F.art  F.box
     F.quiet(on)                           (or ctx.frame({ quiet: true })) the box shows only while it holds lines or
                                           actions; on a phone the art fills one screen and the box floats over its foot
     F.talk(lines, so) -> Promise          F.say, then wait for the reader's tap, then F.clear (a quiet box goes)
     F.cancel() -> Promise                 opt in (only the library uses it): drop whatever the box waits on. A line still
                                           coming stops, a tap to continue resolves without a tap, an F.ask resolves
                                           { index: -1, cancelled: true }, an F.next resolves 'cancel' (F.roll then null), an
                                           open sheet closes with null, and the box's words and chips fade (about 180 ms, at
                                           once under reduced motion). A page that never calls it behaves as before
     F.epoch()                             a number that grows with every F.cancel (F.talk uses it to stop after one)
     ctx.frame({ tapThrough: true | fn })  opt in (the library): while a line waits for its tap, a tap squarely on a thing
                                           in the picture reaches that thing first (inside its drawn shape, and only when
                                           the story isn't waiting on it); the dialogue then goes on unless the page gave way
                                           (F.cancel). A function also hears taps on anything else under that layer (el, e).
                                           The keyboard is unchanged: Enter or Space continues
     ctx.frame({ home: false })            no book in the corner back to the library (FFD.libraryHref, FFD.leaveTo)
     ctx.frame({ hint: false })            no "Show what you can touch" button in the corner (the library: everything is
                                           found by looking, Jan 2026-10-07); F.hint() still works when a page calls it

   Other blocks on ctx (all optional; most pages need only the frame and a little reference text under it):
     ctx.head({ title, line })  ctx.prose(paras, { dropCap, parent })  ctx.lines(lines, { parent })
     ctx.choice(options, { cols, parent })  ctx.charCard({ prompt, button, parent })  ctx.saveCard({ button, draw, parent })
     ctx.questLink({ leadIn, parent })  ctx.faq(items, { parent })  ctx.sign()  ctx.notes(items)  ctx.block(cls)
     ctx.wait(ms)  ctx.onKill(fn)  ctx.alive()  ctx.fx.shake(el, px) / flash(color, el) / sparks(el, o) / pop(el, text)
     ctx.sound (FFSound)  ctx.fmt(str)  ctx.h (element helper)
     ctx.music(id, fadeSec = 2.5)          on a page with background music (the section's data-ffd-music), cross to another
                                           of Jan's records; before the music has started, it sets the record that starts.
                                           A page without music (or the library, whose jukebox plays) ignores it (false)
   ctx.charCard({ prompt, button, guest }) follows F.char's rules: a saved character shows its done card at once, with
   Change. ctx.questLink for a reader who took the Quest shows the way back to the library and the quiet Quest link.
   FFD.live = true on the store hides ctx.notes; FFD.questTarget ('_self' on the store) sets where Quest links open.
   Pronoun tokens in any string: {Name} {class} {Class} {they} {They} {them} {their} {Their} {theirs} {is} {was} {has} {s}

   WHO THE READER PLAYS: FFD.char, kept in 'ffd-char'. v2 { v: 2, src: 'quest' | 'hall' | 'typed' | 'picked', name, cls,
   clsLabel, pr, prText, race, raceKey, body ('m' | 'f' | 'n'), look: { skin, hair, hairStyle, build, age, beard, feats[] },
   heroId, at }; a v1 record (name, cls, clsLabel, pr, prText) reads the same. quest-id.js (FFD.quest, when it is there)
   fills it from the Quest or the Hall; the form writes src 'typed', a pick in the switch sheet src 'picked'. Read it when
   you use it, never from a copy taken when the page began: every change fires 'ffd:char' { char, prev, by } on document.
     FFD.me(c = FFD.char) -> { cls, body, race, raceKey, feats, skin, hair, hairStyle, build, age, beard, key }
                                           what a painter needs to draw the reader (F.set('me', FFD.me()) beside 'cls');
                                           key is a stable string that changes when the drawing should
     FFD.races() -> { top, more }          the Quest's race names (its TOP_RACES first)
     FFD.ledgerIntent() -> boolean         for the library, on arrival: true once when the reader tapped a scene page's
                                           ledger line in this tab within 10 minutes (sessionStorage 'ffd-ledger-intent';
                                           read once and removed). That line shows only while LEDGER_DOOR is on (below)
   THE EGG KIT (Easter eggs on every page). Nothing here leaves the browser, and every storage access is guarded:
     FFD.day()                             the reader's own date, 'YYYY-MM-DD'. A clock set back never gives a new day (the
                                           library deck's rollDay rule: under 36 hours back changes nothing)
     FFD.visitDays(page)                   on how many different days this page was opened (counted on mount, 'ffd-eggs')
     FFD.burst(key, ms = 1500)             taps on key inside the last ms, this one included (memory only)
     FFD.egg(page) -> { get(k, def), set(k, v), inc(k, n), once(k), daily(k) }   the page's own memory ('ffd-eggs-<page>').
                                           once: true the first time this page load; daily: true the first time today
     FFD.when() -> { h, m, wd, night (20:00 to 06:00), late (23:00 to 04:00), midnight (hour 0), weekend }
     FFD.now()                             the clock all of these read (window.FFD_NOW, a number or a function, sets a test clock)
   Everything respects prefers-reduced-motion. Nothing here sends anything anywhere. */
(() => {
  'use strict';
  if (window.FFD && window.FFD.core) return;
  const FFD = window.FFD = Object.assign(window.FFD || {}, { core: 1, pages: (window.FFD && window.FFD.pages) || [] });
  const RM = FFD.RM = () => { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } };
  const WIDE = () => { try { return matchMedia('(min-width: 720px)').matches; } catch (e) { return false; } };
  FFD.QUEST_URL = FFD.QUEST_URL || 'https://framedfantasy.com/pages/dnd-character-quest';
  FFD.questHref = (campaign, medium) => FFD.QUEST_URL + '?utm_source=scene-page&utm_medium=' + encodeURIComponent(medium || 'page') + '&utm_campaign=' + encodeURIComponent(campaign || 'scene');
  try { FFD.char = JSON.parse(localStorage.getItem('ffd-char') || 'null'); } catch (e) { FFD.char = null; }

  /* ---------- the scene painter loads once (window.FFD_SCENES_SRC overrides the path) ---------- */
  FFD.ready = new Promise((res, rej) => {
    const go = () => {
      if (window.FFNoteScenes) return res(window.FFNoteScenes);
      const s = document.createElement('script');
      s.src = window.FFD_SCENES_SRC || 'js/scenes.js'; s.async = true;
      s.onload = () => (window.FFNoteScenes ? res(window.FFNoteScenes) : rej(new Error('scenes missing')));
      s.onerror = () => rej(new Error('scenes failed'));
      document.head.appendChild(s);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go, { once: true }); else go();
  });
  FFD.ready.catch(() => {});

  /* ---------- small helpers ---------- */
  function h(tag, a, ...kids) {
    const e = document.createElement(tag);
    if (a) for (const k of Object.keys(a)) {
      const v = a[k];
      if (v == null || v === false) continue;
      if (k === 'class') e.className = v;
      else if (k === 'text') e.textContent = v;
      else if (k === 'html') e.innerHTML = v;
      else if (k === 'style') e.style.cssText = v;
      else if (k.startsWith('on') && typeof v === 'function') e.addEventListener(k.slice(2), v);
      else e.setAttribute(k, v === true ? '' : v);
    }
    for (const c of kids.flat()) if (c != null && c !== false) e.append(c.nodeType ? c : document.createTextNode(String(c)));
    return e;
  }
  FFD.h = h;
  const PRON = {
    he: { they: 'he', them: 'him', their: 'his', theirs: 'his', themself: 'himself', is: 'is', was: 'was', has: 'has', s: 's' },
    she: { they: 'she', them: 'her', their: 'her', theirs: 'hers', themself: 'herself', is: 'is', was: 'was', has: 'has', s: 's' },
    they: { they: 'they', them: 'them', their: 'their', theirs: 'theirs', themself: 'themself', is: 'are', was: 'were', has: 'have', s: '' }
  };
  function pron(c) {
    if (!c) return PRON.they;
    if (PRON[c.pr]) return PRON[c.pr];
    const n = c.name || 'them';
    return { they: c.prText || n, them: n, their: n + '’s', theirs: n + '’s', themself: n, is: 'is', was: 'was', has: 'has', s: 's' };
  }
  const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  const esc = (v) => String(v).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  /* fmt fills the tokens; fmtH does the same for a string that goes in as HTML, escaping what the reader typed */
  function fmtH(str, c) {
    c = c || FFD.char;
    if (!c) return fmt(str, c);
    /* the class too: a Hall hero's class is the player's own free words ({Class} and {class} put it in a line) */
    const safe = Object.assign({}, c, { name: c.name != null ? esc(c.name) : c.name, prText: c.prText != null ? esc(c.prText) : c.prText, clsLabel: c.clsLabel != null ? esc(c.clsLabel) : c.clsLabel });
    return fmt(str, safe);
  }
  FFD.fmtH = fmtH;
  FFD.esc = esc;
  function fmt(str, c) {
    if (str == null) return '';
    c = c || FFD.char;
    const p = pron(c), name = (c && c.name) || 'your character';
    return String(str)
      .replace(/\{Name\}/g, name).replace(/\{name\}/g, name)
      .replace(/\{Class\}/g, (c && c.clsLabel) || 'Adventurer').replace(/\{class\}/g, ((c && c.clsLabel) || 'adventurer').toLowerCase())
      .replace(/\{They\}/g, cap(p.they)).replace(/\{they\}/g, p.they)
      .replace(/\{Them\}/g, cap(p.them)).replace(/\{them\}/g, p.them)
      .replace(/\{Their\}/g, cap(p.their)).replace(/\{their\}/g, p.their)
      .replace(/\{theirs\}/g, p.theirs).replace(/\{themself\}/g, p.themself)
      .replace(/\{is\}/g, p.is).replace(/\{was\}/g, p.was).replace(/\{has\}/g, p.has).replace(/\{s\}/g, p.s);
  }
  FFD.fmt = fmt;
  /* the frame fills tokens through these, so F.as(c) can name someone other than FFD.char there */
  const fmtFor = fmt, fmtHFor = fmtH;
  FFD.classes = () => {
    try { if (window.QOArt) return QOArt.classList().filter((c) => c.key !== 'other'); } catch (e) { /* fall through */ }
    return ['Barbarian', 'Bard', 'Cleric', 'Druid', 'Fighter', 'Monk', 'Paladin', 'Ranger', 'Rogue', 'Sorcerer', 'Warlock', 'Wizard'].map((l) => ({ key: l.toLowerCase(), label: l }));
  };
  FFD.icon = (cls, size) => { try { return window.QOArt ? QOArt.classIconURL(cls || 'other', size || 64) : ''; } catch (e) { return ''; } };
  FFD.symbol = (key, size) => { try { return window.QOArt ? QOArt.symbolURL(key, size || 64) : ''; } catch (e) { return ''; } };
  FFD.rand = (n) => {
    const f = window.FFD_FORCE;
    if (Array.isArray(f) && f.length) return Math.max(1, Math.min(n, f.shift() | 0));
    try { const a = new Uint32Array(1); crypto.getRandomValues(a); return 1 + (a[0] % n); } catch (e) { return 1 + Math.floor(Math.random() * n); }
  };
  const S = () => window.FFSound || null;
  const wake = () => { const s = S(); if (s) s.wake(); };
  const snd = (name, o) => { const s = S(); if (s && typeof s[name] === 'function') s[name](o); };
  const buzz = (p) => { try { navigator.vibrate && navigator.vibrate(p); } catch (e) { /* not on this device */ } };
  FFD.buzz = buzz;

  /* ---------- who the reader plays (see the head of this file) ----------
     FFD.quest comes from quest-id.js, which the review demo doesn't copy: every call goes through Q() */
  const Q = () => (FFD.quest && FFD.quest.v === 1 ? FFD.quest : null);
  const qcall = (fn, ...a) => { const q = Q(); if (!q || typeof q[fn] !== 'function') return null; try { return q[fn](...a); } catch (e) { return null; } };
  const took = () => !!qcall('took');
  /* the Quest's own lists (assets/quest-one-v2-data.js RACES, TOP_RACES and LOOK), so the form offers what the Quest does */
  const RACES = ['Human', 'Elf', 'Drow', 'Half-Elf', 'Tiefling', 'Dragonborn', 'Dwarf', 'Halfling', 'Half-Orc', 'Orc', 'Gnome', 'Aasimar', 'Goliath', 'Tabaxi', 'Firbolg',
    'Kenku', 'Genasi', 'Changeling', 'Warforged', 'Satyr', 'Harengon', 'Fairy', 'Goblin', 'Kobold', 'Lizardfolk', 'Tortle', 'Centaur', 'Aarakocra', 'Triton', 'Leonin',
    'Bugbear', 'Hobgoblin', 'Minotaur', 'Owlin', 'Yuan-ti', 'Eladrin', 'Githyanki', 'Shifter', 'Kalashtar', 'Dhampir'];
  const TOP_RACES = ['Human', 'Elf', 'Half-Elf', 'Tiefling', 'Dragonborn', 'Dwarf', 'Halfling', 'Half-Orc', 'Aasimar', 'Gnome', 'Drow', 'Tabaxi'];
  FFD.races = () => ({ top: TOP_RACES.slice(), more: RACES.filter((r) => !TOP_RACES.includes(r)) });
  const LOOKS = {
    skin: ['Warm brown', 'Pale', 'Sun-tanned', 'Deep umber', 'Ashen grey', 'Crimson', 'Green'],
    hair: ['Black', 'Dark brown', 'Copper red', 'Blonde', 'Silver-white', 'No hair', 'Dyed'],
    hairStyle: ['Long and loose', 'Braided', 'Short crop', 'Tied back', 'Shaved sides', 'Wild'],
    build: ['Tall and lean', 'Broad and strong', 'Short and quick', 'Average build', 'Heavy set', 'Wiry'],
    age: ['Young', 'In their prime', 'Seasoned', 'Old', 'Ageless']
  };
  const FEATS = ['horns', 'tail', 'wings', 'pointedears', 'tusks', 'scales', 'fur', 'none'];
  const keyOf = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 40);
  const bodyOf = (pr) => (pr === 'he' ? 'm' : pr === 'she' ? 'f' : 'n');
  const words = (v, n) => (typeof v === 'string' ? v.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, n) : '');
  function lookOf(l) {
    l = l && typeof l === 'object' ? l : {};
    const one = (k) => (LOOKS[k].includes(l[k]) ? l[k] : '');
    const feats = Array.isArray(l.feats) ? [...new Set(l.feats.filter((f) => FEATS.includes(f)))].slice(0, 8) : [];
    return { skin: one('skin'), hair: one('hair'), hairStyle: one('hairStyle'), build: one('build'), age: one('age'), beard: l.beard === true, feats };
  }
  /* an 'ffd-char' v2 record, rebuilt field by field */
  function charV2(f, src) {
    f = f || {};
    const pr = ['he', 'she', 'they', 'x'].includes(f.pr) ? f.pr : 'they', race = words(f.race, 48);
    const cls = typeof f.cls === 'string' && /^[a-z0-9]{1,24}$/.test(f.cls) ? f.cls : 'other';
    return { v: 2, src: ['quest', 'hall', 'typed', 'picked'].includes(src) ? src : 'typed', name: words(f.name, 40), cls, clsLabel: words(f.clsLabel, 48) || 'Adventurer',
      pr, prText: pr === 'x' ? words(f.prText, 12) : '', race, raceKey: keyOf(race), body: ['m', 'f', 'n'].includes(f.body) ? f.body : bodyOf(pr), look: lookOf(f.look),
      heroId: typeof f.heroId === 'string' && /^[A-Za-z0-9-]{1,64}$/.test(f.heroId) ? f.heroId : '', at: FFD.now() };
  }
  /* the one place this file changes FFD.char */
  function setChar(c) {
    const prev = FFD.char || null;
    FFD.char = c;
    try { if (c) localStorage.setItem('ffd-char', JSON.stringify(c)); else localStorage.removeItem('ffd-char'); } catch (e) { /* this page still uses it */ }
    try { document.dispatchEvent(new CustomEvent('ffd:char', { detail: { char: c, prev, by: 'core' } })); } catch (e) { /* fine */ }
  }
  const sameHero = (a, b) => !!(a && b && a.name && ((a.heroId && b.heroId && a.heroId === b.heroId) || (a.name === b.name && a.cls === b.cls)));
  /* what a painter needs to draw the reader (L6's me-look.js reads it); key changes when the drawing should */
  FFD.me = (c) => {
    if (c === undefined) c = FFD.char;
    c = c && typeof c === 'object' ? c : {};
    const cls = typeof c.cls === 'string' && /^[a-z0-9]{1,24}$/.test(c.cls) ? c.cls : 'other';
    const pr = ['he', 'she', 'they', 'x'].includes(c.pr) ? c.pr : 'they';
    const body = ['m', 'f', 'n'].includes(c.body) ? c.body : bodyOf(pr);
    const race = words(c.race, 48), raceKey = keyOf(c.raceKey) || keyOf(race), L = lookOf(c.look);
    const key = [cls, body, raceKey, keyOf(L.skin), keyOf(L.hair), keyOf(L.hairStyle), keyOf(L.build), keyOf(L.age), L.beard ? 'b' : '', L.feats.slice().sort().join('+')].join('.');
    return { cls, body, race, raceKey, feats: L.feats.slice(), skin: L.skin, hair: L.hair, hairStyle: L.hairStyle, build: L.build, age: L.age, beard: L.beard, key };
  };

  /* ---------- the egg kit (see the head of this file) ---------- */
  FFD.now = () => { const n = window.FFD_NOW; let v = n; if (typeof n === 'function') { try { v = n(); } catch (e) { v = null; } } return typeof v === 'number' && isFinite(v) ? v : Date.now(); };
  const dayKey = (t) => { const d = new Date(t); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
  const isDay = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);
  const plain = (v) => (v && typeof v === 'object' && !Array.isArray(v) ? v : {});
  /* storage, with this page's own copy standing in when the browser keeps nothing */
  const eggMem = {};
  function readK(k) {
    let raw = null, ok = true;
    try { raw = localStorage.getItem(k); } catch (e) { ok = false; }
    if (ok && raw != null) { try { return JSON.parse(raw); } catch (e) { return null; } }
    return eggMem[k] ? JSON.parse(eggMem[k]) : null;
  }
  function writeK(k, v) {
    const s = JSON.stringify(v);
    eggMem[k] = s;
    try { localStorage.setItem(k, s); return true; } catch (e) { return false; }
  }
  const eggState = () => { const v = plain(readK('ffd-eggs')); return { v: 1, day: isDay(v.day) ? v.day : '', seen: typeof v.seen === 'number' && isFinite(v.seen) ? v.seen : 0, visits: plain(v.visits) }; };
  /* cards.js rollDay: a new calendar day (later than every reading before) moves the day on; a clock set back a little
     (under 36 hours) changes nothing; a lot (a clock put right after it ran ahead) moves the day to the clock's own day */
  function rollDay(st, now) {
    const dk = dayKey(now);
    if (!st.day) st.day = dk;
    else if (now < st.seen - 36 * 3600e3) { st.day = dk; st.seen = now; }
    else if (now >= st.seen && dk > st.day) st.day = dk;
    st.seen = Math.max(st.seen, now);
    return st;
  }
  FFD.day = () => {
    const st = eggState(), was = st.day + '|' + st.seen;
    rollDay(st, FFD.now());
    if (st.day + '|' + st.seen !== was) writeK('ffd-eggs', st);
    return st.day;
  };
  const PAGE_RE = /^[a-z0-9-]{1,24}$/;
  function markVisit(page) {
    if (!PAGE_RE.test(String(page || ''))) return;
    const d = FFD.day(), st = eggState(), v = plain(st.visits[page]);
    const n = typeof v.n === 'number' && isFinite(v.n) && v.n > 0 ? Math.floor(v.n) : 0, last = isDay(v.last) ? v.last : '';
    if (last && last >= d) return;
    st.visits[page] = { n: Math.min(9999, n + 1), last: d };
    const keys = Object.keys(st.visits);
    if (keys.length > 40) keys.sort((a, b) => String(plain(st.visits[a]).last).localeCompare(String(plain(st.visits[b]).last))).slice(0, keys.length - 40).forEach((k) => { delete st.visits[k]; });
    writeK('ffd-eggs', st);
  }
  FFD.visitDays = (page) => { const v = plain(eggState().visits[String(page)]); return typeof v.n === 'number' && isFinite(v.n) && v.n > 0 ? Math.floor(v.n) : 0; };
  const bursts = {};
  FFD.burst = (key, ms) => {
    const now = FFD.now(), w = typeof ms === 'number' && ms > 0 ? ms : 1500, k = String(key);
    const a = (bursts[k] || []).filter((t) => t <= now && now - t <= w);
    a.push(now); bursts[k] = a.slice(-60);
    return a.length;
  };
  FFD.burst.clear = (key) => { if (key == null) Object.keys(bursts).forEach((k) => { delete bursts[k]; }); else delete bursts[String(key)]; };
  const eggOnce = new Set();
  FFD.egg = (page) => {
    const pid = PAGE_RE.test(String(page || '')) ? String(page) : 'page', K = 'ffd-eggs-' + pid;
    const okKey = (k) => typeof k === 'string' && /^[A-Za-z0-9_.-]{1,40}$/.test(k);
    const load = () => { const v = plain(readK(K)); return { v: 1, d: plain(v.d), dy: plain(v.dy) }; };
    const save = (st) => (JSON.stringify(st).length <= 8192 ? writeK(K, st) : false);
    const get = (k, def) => { if (!okKey(k)) return def; const st = load(); return Object.prototype.hasOwnProperty.call(st.d, k) ? st.d[k] : def; };
    const set = (k, v) => {
      if (!okKey(k)) return false;
      const st = load();
      if (v === undefined) delete st.d[k];
      else { let j; try { j = JSON.stringify(v); } catch (e) { return false; } if (j === undefined || j.length > 2048) return false; st.d[k] = JSON.parse(j); }
      return save(st);
    };
    const inc = (k, n) => { const cur = Number(get(k, 0)) || 0, next = cur + (typeof n === 'number' && isFinite(n) ? n : 1); set(k, next); return next; };
    const once = (k) => { const id = pid + ':' + String(k); if (eggOnce.has(id)) return false; eggOnce.add(id); return true; };
    const daily = (k) => {
      if (!okKey(k)) return false;
      const d = FFD.day(), st = load(), was = isDay(st.dy[k]) ? st.dy[k] : '';
      if (was && was >= d) return false;
      st.dy[k] = d; save(st);
      return true;
    };
    return { get, set, inc, once, daily };
  };
  FFD.when = () => {
    const d = new Date(FFD.now()), hh = d.getHours(), wd = d.getDay();
    return { h: hh, m: d.getMinutes(), wd, night: hh >= 20 || hh < 6, late: hh >= 23 || hh < 4, midnight: hh === 0, weekend: wd === 0 || wd === 6 };
  };

  /* ---------- effects ---------- */
  const fx = {
    shake(el, px) {
      if (!el || RM()) return;
      px = px || 6;
      el.animate([{ transform: 'translate(0,0)' }, { transform: `translate(${-px}px,1px)` }, { transform: `translate(${px}px,-1px)` },
        { transform: `translate(${-px / 2}px,0)` }, { transform: 'translate(0,0)' }], { duration: 320, easing: 'ease-out' });
    },
    /* a wash of colour: over the whole page, or over one element (the frame) when given */
    flash(color, el) {
      const f = h('div', { class: 'ffd-flash' + (el ? ' ffd-flash--in' : ''), style: 'background:' + (color || 'rgba(232,198,116,.28)') });
      (el || document.body).append(f);
      f.animate([{ opacity: RM() ? 0.4 : 1 }, { opacity: 0 }], { duration: RM() ? 300 : 520, easing: 'ease-out' }).onfinish = () => f.remove();
    },
    /* a burst of small square sparks from an element's centre (o.dx / o.dy offset it, o.x / o.y place it in client px) */
    sparks(el, o) {
      if (!el || RM()) return;
      o = o || {};
      const r = el.getBoundingClientRect();
      const cx = o.x != null ? o.x : r.left + r.width / 2 + (o.dx || 0), cy = o.y != null ? o.y : r.top + r.height / 2 + (o.dy || 0);
      const cols = o.colors || ['#f4d68a', '#e8c674', '#fff6dc', '#c9a84c'];
      for (let i = 0; i < (o.n || 18); i++) {
        const a = Math.random() * Math.PI * 2, d = (o.spread || 90) * (0.4 + Math.random() * 0.8), s = 3 + Math.round(Math.random() * 3);
        const p = h('i', { class: 'ffd-spark', style: `left:${cx}px;top:${cy}px;width:${s}px;height:${s}px;background:${cols[i % cols.length]}` });
        document.body.append(p);
        p.animate([{ transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
          { transform: `translate(calc(-50% + ${Math.cos(a) * d}px), calc(-50% + ${Math.sin(a) * d + 30}px)) scale(.4)`, opacity: 0 }],
        { duration: 600 + Math.random() * 400, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = () => p.remove();
      }
    },
    pop(el, text, cls) {
      if (!el) return;
      const r = el.getBoundingClientRect(), p = h('div', { class: 'ffd-numpop ' + (cls || ''), text, style: `left:${r.left + r.width / 2}px;top:${r.top + r.height / 2}px` });
      document.body.append(p);
      p.animate([{ transform: 'translate(-50%,-50%) scale(.6)', opacity: 0 }, { transform: 'translate(-50%,-80%) scale(1.15)', opacity: 1, offset: 0.25 },
        { transform: 'translate(-50%,-140%) scale(1)', opacity: 0 }], { duration: RM() ? 600 : 1100, easing: 'ease-out' }).onfinish = () => p.remove();
    }
  };
  FFD.fx = fx;

  /* ---------- scene emits go to whichever owner currently shows that key (FFNoteScenes.on cannot be removed) ---------- */
  const sceneOwners = {}, sceneListening = {};
  function voice(type, d) {
    if (type === 'applause') { if (!d.auto) { snd('applause', { k: d.k || 1 }); buzz([10, 50, 10, 50, 10]); } }
    else if (type === 'reveal') snd('chime');
    else if (type === 'lift') snd('rustle');
    else if (type === 'settle') snd('pat');
    else if (type === 'pop') snd('pop');
    else if (type === 'lights') snd('lights');
    else if (type === 'sound' && d && !d.auto) snd(d.name, d);
  }
  function listen(api, key) {
    if (sceneListening[key]) return;
    sceneListening[key] = true;
    api.on(key, (type, data) => { const ow = sceneOwners[key]; if (!ow) return; data = data || {}; voice(type, data); ow(type, data, key); });
  }

  /* ---------- the page context ---------- */
  /* per page: its frames, whether they show the "playing as" chip, and its background music (bed) */
  const CTXS = new WeakMap();
  const wantMe = (ctx) => { const cs = CTXS.get(ctx); if (!cs) return; cs.me = true; cs.frames.forEach((F) => { if (F._me) F._me(); }); };
  const frameElOf = (ctx) => { const cs = CTXS.get(ctx); return cs && cs.frames[0] ? cs.frames[0].el : null; };
  function makeCtx(def, root, opts) {
    opts = opts || {};
    let alive = true;
    const cleanups = [], ctx = { def, root, alive: () => alive, fx, sound: S(), h, fmt: (s) => fmt(s), char: () => FFD.char, medium: opts.medium || 'page' };
    CTXS.set(ctx, { me: false, frames: [], bed: { want: null, cue: null } });
    /* another of Jan's records on a page with background music (bed, below); before it starts, the record that starts */
    ctx.music = (id, fadeSec) => {
      const b = CTXS.get(ctx).bed, T = typeof FFD.music === 'function' && FFD.music.TRACKS;
      if (typeof id !== 'string' || !T || !T[id]) return false;
      if (b.cue) return b.cue(id, typeof fadeSec === 'number' && fadeSec >= 0 ? fadeSec : 2.5);
      b.want = id;
      return false;
    };
    ctx.kill = () => { alive = false; cleanups.splice(0).forEach((f) => { try { f(); } catch (e) { /* fine */ } }); };
    ctx.onKill = (fn) => { if (typeof fn === 'function') cleanups.push(fn); };
    ctx.wait = (ms) => new Promise((res) => { const t = setTimeout(() => { if (alive) res(); }, RM() ? Math.min(ms, 120) : ms); cleanups.push(() => clearTimeout(t)); });
    ctx.block = (cls, parent) => { const b = h('section', { class: 'ffd-block ' + (cls || '') }); (parent || root).append(b); return b; };
    ctx.head = (o) => {
      const hd = h('header', { class: 'ffd-head' }, h('h1', { class: 'ffd-title', text: fmt(o.title) }), o.line ? h('p', { class: 'ffd-line-intro', text: fmt(o.line) }) : null);
      (o.parent || root).append(hd); return hd;
    };
    ctx.prose = (paras, o) => {
      o = o || {};
      const wrap = h('div', { class: 'ffd-prose' + (o.dropCap ? ' ffd-dropcap' : '') });
      (Array.isArray(paras) ? paras : [paras]).forEach((p) => wrap.append(h('p', { html: fmtH(p) })));
      (o.parent || root).append(wrap); return wrap;
    };
    ctx.lines = (lines, o) => {
      o = o || {};
      const box = h('div', { class: 'ffd-lines' + (o.cls ? ' ' + o.cls : '') });
      (o.parent || root).append(box);
      let fast = RM();
      box.addEventListener('click', () => { fast = true; });
      return (async () => {
        for (let i = 0; i < lines.length; i++) {
          if (!alive) return box;
          const raw = lines[i], text = fmtH(typeof raw === 'string' ? raw : raw.text);
          const p = h('p', { class: 'ffd-ln' + (raw.cls ? ' ' + raw.cls : ''), html: text });
          box.append(p);
          requestAnimationFrame(() => p.classList.add('is-in'));
          if (raw.sound) snd(raw.sound);
          if (i < lines.length - 1 && !fast) {
            const gap = o.gap || Math.max(650, Math.min(1600, 420 + text.length * 17));
            await new Promise((r) => { const t = setInterval(() => { if (fast || !alive) { clearInterval(t); r(); } }, 60); setTimeout(() => { clearInterval(t); r(); }, gap); });
          }
        }
        await ctx.wait(fast ? 60 : 380);
        return box;
      })();
    };
    ctx.choice = (options, o) => {
      o = o || {};
      const box = h('div', { class: 'ffd-choices' + (o.cols === 2 && options.length % 2 === 0 ? ' ffd-choices--2' : '') });
      (o.parent || root).append(box);
      return new Promise((res) => {
        options.forEach((opt, i) => {
          const label = fmt(typeof opt === 'string' ? opt : opt.label);
          const b = h('button', { class: 'ffd-choice', type: 'button', style: `--i:${i}` },
            typeof opt === 'object' && opt.icon ? h('img', { src: opt.icon, alt: '', class: 'ffd-choice-ic' }) : null, h('span', { text: label }));
          b.addEventListener('click', () => {
            if (box.dataset.done) return;
            box.dataset.done = '1'; wake(); snd('tap');
            b.classList.add('is-picked');
            [...box.children].forEach((c) => { if (c !== b) c.classList.add('is-gone'); });
            setTimeout(() => { if (!o.keep) [...box.children].forEach((c) => { if (c !== b) c.remove(); }); res({ index: i, label, value: typeof opt === 'object' ? opt.value : undefined, el: b }); }, RM() ? 0 : 260);
          });
          box.append(b);
        });
      });
    };
    /* F.char's rules on the page itself: a saved character shows its card at once, with Change */
    ctx.charCard = (o) => {
      o = o || {};
      const card = h('div', { class: 'ffd-char' });
      (o.parent || root).append(card);
      const c = FFD.char, leave = () => frameElOf(ctx);
      if (!o.guest && !o.fresh && c && c.name) { wantMe(ctx); cardDone(card, c, def.id, leave); return Promise.resolve(c); }
      return new Promise((res) => charForm(card, o, def.id, (c2) => { if (!o.guest) { wantMe(ctx); cardDone(card, c2, def.id, leave); } res(c2); }, leave));
    };
    ctx.saveCard = (o) => {
      o = o || {};
      const btn = h('button', { type: 'button', class: 'ffd-btn' + (o.solid ? ' ffd-btn--solid' : ''), text: fmt(o.button || 'Save the card') });
      if (o.parent !== false) (o.parent || root).append(o.bare ? btn : h('div', { class: 'ffd-actions' }, btn));
      btn.addEventListener('click', () => FFD.showCard(o));
      return btn;
    };
    ctx.questLink = (o) => {
      o = o || {};
      /* a reader who took the Quest: the way back to the library (while it is published) and a quiet Quest link */
      if (took()) {
        const lib = def.id !== 'library' ? FFD.libraryHref() : null;
        const box = h('div', { class: 'ffd-quest-box is-taken' }, h('img', { class: 'ffd-quest-ic', src: FFD.symbol('other', 96), alt: '' }));
        if (lib) {
          const home = h('a', { class: 'ffd-btn ffd-btn--solid ffd-btn--big ffd-quest-home', href: lib, text: 'Back to Zhaunil’s library' });
          home.addEventListener('click', (e) => { if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); wake(); snd('tap'); FFD.leaveTo(lib, frameElOf(ctx)); });
          box.append(home);
        }
        const again = h('a', { class: 'ffd-btn ffd-btn--quiet ffd-quest-again', href: FFD.questHref(o.campaign || def.id, 'again'), target: o.target || FFD.questTarget || '_blank', rel: 'noopener', text: 'Play the Quest with another hero' });
        again.addEventListener('click', () => { wake(); snd('tap'); });
        box.append(h('p', { class: 'ffd-quest-small' }, again));
        const tb = h('section', { class: 'ffd-quest is-taken' }, o.takenLeadIn ? h('p', { class: 'ffd-quest-lead', text: fmt(o.takenLeadIn) }) : null, box);
        (o.parent || root).append(tb); return tb;
      }
      const c = FFD.char;
      const b = h('section', { class: 'ffd-quest' },
        o.leadIn ? h('p', { class: 'ffd-quest-lead', text: fmt(o.leadIn) }) : null,
        h('div', { class: 'ffd-quest-box' },
          h('img', { class: 'ffd-quest-ic', src: FFD.symbol('other', 96), alt: '' }),
          h('p', { class: 'ffd-quest-what', text: 'Roll real dice through a D&D adventure and find out who your character really is.' }),
          h('a', { class: 'ffd-btn ffd-btn--solid ffd-btn--big', href: FFD.questHref(o.campaign || def.id, o.medium || ctx.medium), target: o.target || FFD.questTarget || '_blank', rel: 'noopener', text: c && c.name ? 'Begin the Quest with ' + c.name : 'Begin the Quest' }),
          h('p', { class: 'ffd-quest-small', text: 'Free to play, no email to start.' })));
      (o.parent || root).append(b); return b;
    };
    ctx.faq = (items, o) => {
      o = o || {};
      const s = h('section', { class: 'ffd-faq' }, items.map((it) => h('details', null, h('summary', { text: fmt(it.q) }), h('div', { class: 'ffd-faq-a', html: fmtH(it.a) }))));
      (o.parent || root).append(s); return s;
    };
    ctx.sign = (o) => { const s = h('p', { class: 'ffd-sign', text: 'Jan' }); ((o && o.parent) || root).append(s); return s; };
    ctx.notes = (items, o) => {
      if (FFD.live) return h('span', { hidden: true });
      const s = h('details', { class: 'ffd-notes' }, h('summary', { text: 'Notes for Jan' }), h('ul', null, items.map((t) => h('li', { html: t }))));
      ((o && o.parent) || root).append(s); return s;
    };
    ctx.scene = (o) => legacyScene(ctx, o, cleanups, () => alive);
    ctx.frame = (o) => makeFrame(ctx, o, cleanups, () => alive);
    return ctx;
  }

  /* ---------- the character form (ctx.charCard, F.char's sheet, Someone else in the switch sheet) ----------
     o: { prompt, button, guest, prefill (a character to start from; FFD.char by default, none for a guest), notes }.
     It writes 'ffd-char' v2 with src 'typed' (setChar fires 'ffd:char'), unless guest, which only returns the character.
     The race list puts the Quest's TOP_RACES first; the shape follows the pronouns until the reader picks one. */
  const SHAPES = [['m', 'Masculine'], ['n', 'In between'], ['f', 'Feminine']];
  const SHAPE_SVG = {
    m: '<svg viewBox="0 0 24 30" aria-hidden="true"><circle cx="12" cy="5.6" r="3.5" fill="currentColor"/><path d="M4.6 13.6Q4.6 10.6 8 10.6h8q3.4 0 3.4 3l-1.8 7.6H6.4z" fill="currentColor"/><path d="M7.2 21.6h3.9V29H7.2zM12.9 21.6h3.9V29h-3.9z" fill="currentColor"/></svg>',
    n: '<svg viewBox="0 0 24 30" aria-hidden="true"><circle cx="12" cy="5.6" r="3.4" fill="currentColor"/><path d="M6 13.6Q6 10.6 9 10.6h6q3 0 3 3l-1.4 4.4 1 3.6H6.4l1-3.6z" fill="currentColor"/><path d="M7.4 22h3.8v7H7.4zM12.8 22h3.8v7h-3.8z" fill="currentColor"/></svg>',
    f: '<svg viewBox="0 0 24 30" aria-hidden="true"><circle cx="12" cy="5.6" r="3.3" fill="currentColor"/><path d="M7.2 13.4Q7.2 10.6 9.8 10.6h4.4q2.6 0 2.6 2.8l-1.3 3.8 2.6 5.4H5.9l2.6-5.4z" fill="currentColor"/><path d="M7.9 22.6h3.5V29H7.9zM12.6 22.6h3.5V29h-3.5z" fill="currentColor"/></svg>'
  };
  function charForm(card, o, pid, res, frameEl) {
    o = o || {};
    const guest = !!o.guest, p = guest ? null : o.prefill !== undefined ? o.prefill : FFD.char;
    const done = (c) => {
      if (!guest) setChar(c);
      card.classList.add('is-done');
      card.innerHTML = '';
      card.append(h('div', { class: 'ffd-char-done' }, h('img', { src: FFD.icon(c.cls, 64), alt: '' }),
        h('div', null, h('strong', { text: c.name }), h('span', { text: c.clsLabel }))));
      snd('pen');
      res(c);
    };
    card.innerHTML = '';
    let cls = p && p.name ? p.cls : null, pr = p && p.name && p.pr ? p.pr : 'they';
    let body = p && p.name && ['m', 'f', 'n'].includes(p.body) ? p.body : bodyOf(pr), shaped = !!(p && p.name && p.body && p.body !== bodyOf(pr));
    const name = h('input', { id: 'ffd-name-' + pid, class: 'ffd-input', maxlength: '24', autocomplete: 'off', placeholder: 'Your character’s name', value: p && p.name ? p.name : '' });
    const err = h('p', { class: 'ffd-err', hidden: true });
    const grid = h('div', { class: 'ffd-classes' });
    { const n = FFD.classes().length, cols = [7, 6, 5, 4].find((k) => n % k === 0) || 7; grid.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))'; }
    const picked = h('p', { class: 'ffd-class-picked', 'aria-live': 'polite', text: cls ? ((FFD.classes().find((c) => c.key === cls) || {}).label || '') : '' });
    FFD.classes().forEach((c) => {
      const b = h('button', { type: 'button', class: 'ffd-class' + (c.key === cls ? ' is-on' : ''), 'aria-pressed': c.key === cls ? 'true' : 'false', 'aria-label': c.label },
        h('img', { src: FFD.icon(c.key, 64), alt: '' }), h('span', { text: c.label }));
      b.addEventListener('click', () => { cls = c.key; picked.textContent = c.label; [...grid.children].forEach((x) => { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); }); b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); wake(); snd('tap'); });
      grid.append(b);
    });
    /* the race: a plain list, the Quest's most played first */
    let race = null;
    if (!guest) {
      race = h('select', { id: 'ffd-race-' + pid, class: 'ffd-input ffd-race' }, h('option', { value: '', text: 'Pick a race' }));
      const had = p && p.name ? words(p.race, 48) : '';
      if (had && !RACES.includes(had)) race.append(h('option', { value: had, text: had }));
      TOP_RACES.forEach((r) => race.append(h('option', { value: r, text: r })));
      race.append(h('optgroup', { label: 'More races' }, RACES.filter((r) => !TOP_RACES.includes(r)).map((r) => h('option', { value: r, text: r }))));
      race.value = had;
    }
    /* the shape the scenes draw: two small figures and one between them */
    let shapes = null;
    const paintShape = () => { if (shapes) [...shapes.children].forEach((x) => { const on = x.dataset.k === body; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); }); };
    if (!guest) {
      shapes = h('div', { class: 'ffd-shapes', role: 'group', 'aria-label': 'Shape' });
      SHAPES.forEach(([k, l]) => {
        const b = h('button', { type: 'button', class: 'ffd-shape', 'data-k': k, html: SHAPE_SVG[k] }, h('span', { text: l }));
        b.addEventListener('click', () => { body = k; shaped = true; paintShape(); wake(); snd('tap'); });
        shapes.append(b);
      });
      paintShape();
    }
    const other = h('input', { id: 'ffd-pr-' + pid, class: 'ffd-input ffd-input--sm', maxlength: '12', placeholder: 'Write it in', hidden: pr !== 'x', value: p && p.name && p.prText ? p.prText : '' });
    const prs = h('div', { class: 'ffd-prs' });
    [['he', 'He'], ['she', 'She'], ['they', 'They'], ['x', 'Write it in']].forEach(([k, l]) => {
      const b = h('button', { type: 'button', class: 'ffd-pr' + (k === pr ? ' is-on' : ''), text: l, 'aria-pressed': k === pr ? 'true' : 'false' });
      b.addEventListener('click', () => {
        pr = k; [...prs.children].forEach((x) => { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); }); b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); other.hidden = k !== 'x'; if (k === 'x') other.focus();
        if (!shaped) { body = bodyOf(k); paintShape(); }
      });
      prs.append(b);
    });
    const go = h('button', { type: 'button', class: 'ffd-btn ffd-btn--solid', text: fmt(o.button || 'That’s my character') });
    /* what's missing shows with the button, so a sheet's sticky foot never hides it */
    const foot = h('div', { class: 'ffd-actions' }, err, go);
    const submit = () => {
      wake();
      const n = name.value.trim().replace(/\s+/g, ' ');
      if (!n) { err.textContent = 'Give your character a name first.'; err.hidden = false; foot.classList.add('has-err'); fx.shake(name, 5); name.focus(); return; }
      if (!cls) { err.textContent = 'Pick a class. Close enough is fine.'; err.hidden = false; foot.classList.add('has-err'); fx.shake(grid, 4); return; }
      const lab = (FFD.classes().find((c) => c.key === cls) || {}).label || 'Adventurer', rv = race ? race.value : '';
      /* the same hero edited keeps the Quest's looks and its Hall id; anyone new starts plain */
      const keep = !!(p && p.name && n.toLowerCase() === String(p.name).toLowerCase() && p.cls === cls && keyOf(p.race) === keyOf(rv));
      const c = charV2({ name: n, cls, clsLabel: lab, pr, prText: pr === 'x' ? (other.value.trim() || '') : '', race: rv, body: guest ? undefined : body,
        look: keep ? p.look : null, heroId: keep ? p.heroId : '' }, 'typed');
      if (guest) c.guest = true;
      done(c);
    };
    go.addEventListener('click', submit);
    name.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); name.blur(); } });
    card.append(...[
      o.prompt ? h('p', { class: 'ffd-char-prompt', text: fmt(o.prompt) }) : null,
      h('label', { class: 'ffd-label', for: name.id, text: 'Name' }), name,
      h('p', { class: 'ffd-label', text: 'Class' }), grid, picked,
      race ? h('label', { class: 'ffd-label', for: race.id, text: 'Race' }) : null, race,
      h('p', { class: 'ffd-label', text: 'How should the story refer to them?' }), prs, other,
      shapes ? h('p', { class: 'ffd-label', text: 'Shape' }) : null, shapes,
      foot,
      o.notes !== false && !guest ? charNotes(pid, frameEl) : null].filter(Boolean));
  }

  /* a face for a character or a Hall hero: its public Hall thumb with the Hall's own framing, else its class icon */
  function faceOf(c) {
    if (c && c.thumb) return { thumb: c.thumb, frame: c.frame || null, cls: c.cls };
    if (!c || !c.name) return { cls: 'other' };
    const pool = [qcall('hero')].concat(qcall('heroes') || []).filter((e) => e && e.thumb);
    const m = pool.find((e) => (c.heroId && (e.heroId === c.heroId || e.id === c.heroId)) || (e.name === c.name && e.cls === c.cls));
    return m ? { thumb: m.thumb, frame: m.frame || null, cls: c.cls } : { cls: c.cls || 'other' };
  }
  function faceEl(c, cls) {
    const f = faceOf(c), wrap = h('span', { class: 'ffd-face' + (cls ? ' ' + cls : '') + (f.thumb ? '' : ' is-icon'), 'aria-hidden': 'true' });
    const icon = () => { wrap.classList.add('is-icon'); wrap.innerHTML = ''; wrap.append(h('img', { src: FFD.icon(f.cls || 'other', 64), alt: '' })); };
    if (!f.thumb) { icon(); return wrap; }
    const im = h('img', { src: f.thumb, alt: '', loading: 'lazy', decoding: 'async', referrerpolicy: 'no-referrer' });
    const fr = f.frame || { x: 50, y: 50, zoom: 100 }, pos = fr.x + '% ' + fr.y + '%';
    im.style.objectPosition = pos;
    if (fr.zoom > 100) { im.style.transform = 'scale(' + fr.zoom / 100 + ')'; im.style.transformOrigin = pos; }
    im.addEventListener('error', icon, { once: true });
    wrap.append(im);
    return wrap;
  }

  /* the quiet lines under a character form or the switch sheet: the Quest for a reader with no hero yet who never took
     it, and the library's ledger for a reader with no Quest hero on this device (scene pages only, while it is published).
     The ledger line promises a lookup, so it shows only once the library opens Zhaunil's ledger on arrival: LEDGER_DOOR
     (the store) or window.FFD_LEDGER_INTENT === true (a check page, or the review demo's hub). Its tap leaves a note in
     this tab, sessionStorage 'ffd-ledger-intent' (the time), which the library takes with FFD.ledgerIntent() */
  const LEDGER_DOOR = true;   /* library.js opens the ledger from FFD.ledgerIntent() on arrival (turned on 2026-10-08) */
  const K_INTENT = 'ffd-ledger-intent', INTENT_MS = 10 * 60e3;
  const ledgerDoor = () => LEDGER_DOOR || window.FFD_LEDGER_INTENT === true;
  const nowMs = () => (typeof FFD.now === 'function' ? FFD.now() : Date.now());
  /* the library, on arrival: true once when the reader came here by the ledger line in the last 10 minutes (the note is
     removed whatever its age, so a reload or Back never opens the ledger twice) */
  FFD.ledgerIntent = () => {
    let v = null;
    try { v = sessionStorage.getItem(K_INTENT); sessionStorage.removeItem(K_INTENT); } catch (e) { return false; }
    const t = Number(v), age = nowMs() - t;
    return !!(v && isFinite(t) && t > 0 && age >= -60e3 && age < INTENT_MS);
  };
  function charNotes(pid, frameEl) {
    const out = [], lib = pid !== 'library' ? FFD.libraryHref() : null;
    if (!(FFD.char && FFD.char.name) && !took()) {
      const a = h('a', { class: 'ffd-cs-a', href: FFD.questHref(pid, 'charsheet'), target: FFD.questTarget || '_blank', rel: 'noopener', text: 'Begin the Quest' });
      a.addEventListener('click', () => { wake(); snd('tap'); });
      out.push(h('p', { class: 'ffd-cs-note' }, h('span', { text: 'No hero yet? The Character Quest makes one with you.' }), ' ', a));
    }
    if (lib && !qcall('hero') && ledgerDoor()) {
      const a = h('a', { class: 'ffd-cs-a', href: lib, text: 'Played the Quest on another device? Zhaunil’s ledger finds your hero.' });
      a.addEventListener('click', (e) => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault(); wake(); snd('tap');
        try { sessionStorage.setItem(K_INTENT, String(nowMs())); } catch (er) { /* the library just opens as usual */ }
        FFD.leaveTo(lib, typeof frameEl === 'function' ? frameEl() : frameEl);
      });
      out.push(h('p', { class: 'ffd-cs-note' }, a));
    }
    return out.length ? h('div', { class: 'ffd-cs-notes' }, out) : null;
  }

  /* ---------- the switch sheet: the Quest hero, the Hall heroes, Someone else, "Not you?" ----------
     Built into any element (a frame's sheet, or ctx.charCard's card); close(char | null) ends it. A pick writes 'ffd-char'
     with src 'picked'. Hall heroes carry no pronouns, so a Hall hero that isn't the one on show asks for them once. */
  function switchSheet(body, close, o) {
    o = o || {};
    const view = h('div', { class: 'ffd-cs' });
    body.append(view);
    let shut = false;
    const end = (v) => { if (shut) return; shut = true; document.removeEventListener('keydown', onEsc, true); close(v); };
    const onEsc = (e) => {
      if (!view.isConnected) { document.removeEventListener('keydown', onEsc, true); return; }
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); end(null); }
    };
    document.addEventListener('keydown', onEsc, true);
    const pick = (c) => { if (!c || !c.name) return; setChar(c); snd('pen'); end(c); };
    const quiet = (label, fn) => { const b = h('button', { type: 'button', class: 'ffd-btn ffd-btn--quiet', text: label }); b.addEventListener('click', () => { wake(); snd('tap'); fn(); }); return b; };
    function foot(back) {
      const cur = FFD.char, row = h('div', { class: 'ffd-cs-foot' });
      if (back) row.append(quiet('Back', list));
      else if (Q() && cur && cur.name && (cur.src === 'quest' || cur.src === 'hall')) row.append(quiet('Not you?', () => { qcall('forget'); form(false); }));
      else row.append(h('span'));
      row.append(quiet('Close', () => end(null)));
      view.append(row);
    }
    /* the tags come from the data, not the place in the list: the hero this browser knows (its pronouns go with it, so
       quest: true picks it at once) is from the Quest unless it was picked in the ledger's Hall list from a row that
       isn't; each Hall row says it from its own fromQuest */
    const TAG_Q = 'From the Quest', TAG_H = 'In the Hall';
    function rows() {
      const hero = qcall('hero'), inf = qcall('info') || {}, list = qcall('heroes') || [], out = [];
      const hme = hero && hero.name ? { name: hero.name, cls: hero.cls, heroId: hero.heroId } : null;
      if (hme) {
        const twin = list.find((e) => e && e.name && sameHero(hme, { name: e.name, cls: e.cls, heroId: e.id }));
        out.push({ e: hero, me: hme, tag: inf.via !== 'hall' || (twin && twin.fromQuest === true) ? TAG_Q : TAG_H, quest: true });
      }
      list.forEach((e) => {
        if (!e || !e.name) return;
        const me = { name: e.name, cls: e.cls, heroId: e.id };
        if (hme && sameHero(me, hme)) return;
        out.push({ e, me, tag: e.fromQuest === true ? TAG_Q : TAG_H });
      });
      return out;
    }
    function list() {
      view.innerHTML = '';
      const rs = rows();
      if (!rs.length) { form(false); return; }
      const cur = FFD.char, box = h('div', { class: 'ffs-list ffd-cs-list' });
      rs.forEach((r, i) => {
        const now = sameHero(cur, r.me), sub = [r.e.race, r.e.clsLabel].filter(Boolean).join(' ');
        const b = h('button', { type: 'button', class: 'ffd-cs-row' + (now ? ' is-now' : ''), 'aria-pressed': now ? 'true' : 'false', style: '--i:' + i },
          faceEl(r.e), h('span', { class: 'ffd-cs-n' }, h('b', { text: r.e.name }), sub ? h('small', { text: sub }) : null), h('em', { class: 'ffd-cs-tag', text: now ? 'Playing now' : r.tag }));
        b.addEventListener('click', () => { wake(); snd('tap'); if (r.quest) pick(qcall('charOf', r.e, 'picked') || charV2(r.e, 'picked')); else hall(r.e); });
        box.append(b);
      });
      const other = h('button', { type: 'button', class: 'ffd-cs-row is-other', style: '--i:' + rs.length }, h('span', { class: 'ffd-face is-plus', 'aria-hidden': 'true' }), h('span', { class: 'ffd-cs-n' }, h('b', { text: 'Someone else' })));
      other.addEventListener('click', () => { wake(); snd('tap'); form(true); });
      box.append(other);
      view.append(box);
      const nt = charNotes(o.pid, o.frameEl); if (nt) view.append(nt);
      foot(false);
    }
    function hall(e) {
      const cur = FFD.char, mine = sameHero(cur, { name: e.name, cls: e.cls, heroId: e.id });
      const make = (pr, prText) => {
        const f = { name: e.name, cls: e.cls, clsLabel: e.clsLabel, race: e.race, pr, prText: prText || '', heroId: e.id, look: mine ? cur.look : null, body: mine && cur.body ? cur.body : undefined };
        return qcall('charOf', f, 'picked') || charV2(f, 'picked');
      };
      if (mine && cur.pr) { pick(make(cur.pr, cur.prText)); return; }
      view.innerHTML = '';
      view.append(h('p', { class: 'ffd-char-prompt', text: fmt('How should the story refer to {Name}?', { name: e.name, pr: 'they' }) }));
      const row = h('div', { class: 'ffd-prs ffd-cs-prs' });
      [['he', 'He'], ['she', 'She'], ['they', 'They']].forEach(([k, l]) => { const b = h('button', { type: 'button', class: 'ffd-pr', text: l }); b.addEventListener('click', () => { wake(); pick(make(k)); }); row.append(b); });
      view.append(row);
      foot(true);
    }
    function form(back) {
      view.innerHTML = '';
      const cur = FFD.char, card = h('div', { class: 'ffd-char ffd-char--sheet' });
      view.append(card);
      charForm(card, { button: 'That’s my character', prefill: cur && cur.name && cur.src === 'typed' ? cur : null }, o.pid, (c) => { if (!shut) setTimeout(() => end(c), RM() ? 0 : 380); }, o.frameEl);
      foot(back && rows().length > 0);
    }
    list();
  }
  /* ctx.charCard's done card, with Change opening the switch sheet in the card itself */
  function cardDone(card, c, pid, frameEl) {
    card.classList.add('is-done');
    card.innerHTML = '';
    const ch = h('button', { type: 'button', class: 'ffd-btn ffd-btn--quiet ffd-char-change', text: 'Change' });
    card.append(h('div', { class: 'ffd-char-done' }, faceEl(c, 'is-48'), h('div', null, h('strong', { text: c.name }), h('span', { text: c.clsLabel || '' }))), h('div', { class: 'ffd-actions' }, ch));
    ch.addEventListener('click', () => {
      wake(); snd('tap');
      card.classList.remove('is-done'); card.innerHTML = '';
      switchSheet(card, () => {
        const now = FFD.char;
        if (now && now.name) cardDone(card, now, pid, frameEl);
        else { card.innerHTML = ''; charForm(card, {}, pid, (c2) => cardDone(card, c2, pid, frameEl), frameEl); }
      }, { pid, frameEl });
    });
  }

  /* ---------- the save card: drawn on a canvas, shown large to press and hold (an Artifact blocks downloads) ---------- */
  FFD.showCard = async (o) => {
    wake(); snd('whoosh', { g: 0.08 });
    try { await document.fonts.load('600 60px Cinzel'); await document.fonts.load('400 40px Spectral'); await document.fonts.load('italic 500 40px "Cormorant Garamond"'); } catch (e) { /* fallbacks */ }
    const W = 1080, H = 1350, cv = h('canvas', { width: W, height: H }), g = cv.getContext('2d');
    if (o.draw) await o.draw(g, W, H, FFD.char); else FFD.drawCard(g, W, H, o);
    let url = '';
    try { url = cv.toDataURL('image/png'); } catch (e) { /* tainted: should not happen */ }
    const ov = h('div', { class: 'ffd-overlay', role: 'dialog', 'aria-label': fmt(o.alt || 'Your card') });
    const img = h('img', { class: 'ffd-card-img', src: url, alt: fmt(o.alt || 'Your card') });
    const close = h('button', { type: 'button', class: 'ffd-btn', text: 'Close' });
    ov.append(h('div', { class: 'ffd-overlay-in' }, img, h('p', { class: 'ffd-note', text: o.note || 'On your phone, press and hold the card to save it.' }), h('div', { class: 'ffd-actions' }, close)));
    const shut = () => { ov.classList.remove('is-in'); setTimeout(() => ov.remove(), 220); };
    close.addEventListener('click', shut); ov.addEventListener('click', (e) => { if (e.target === ov) shut(); });
    document.body.append(ov); requestAnimationFrame(() => ov.classList.add('is-in'));
    close.focus({ preventScroll: true });
  };
  FFD.drawCard = (g, W, H, o) => {
    const c = FFD.char;
    const grd = g.createLinearGradient(0, 0, 0, H); grd.addColorStop(0, '#221810'); grd.addColorStop(1, '#120c07');
    g.fillStyle = grd; g.fillRect(0, 0, W, H);
    g.strokeStyle = '#c8a45e'; g.lineWidth = 4; g.strokeRect(46, 46, W - 92, H - 92);
    g.strokeStyle = 'rgba(200,164,94,.35)'; g.lineWidth = 2; g.strokeRect(64, 64, W - 128, H - 128);
    g.textAlign = 'center'; g.fillStyle = '#efe7d6';
    let y = 240;
    if (c && c.cls && o.icon !== false) {
      const im = new Image(); im.src = FFD.icon(c.cls, 192);
      try { g.imageSmoothingEnabled = false; g.drawImage(im, W / 2 - 96, 120, 192, 192); } catch (e) { /* fine */ }
      y = 400;
    }
    g.font = '600 76px Cinzel, Georgia, serif'; wrapText(g, fmt(o.title || ''), W / 2, y, W - 220, 92);
    g.font = '400 42px Spectral, Georgia, serif'; g.fillStyle = '#d9cfbd';
    let yy = y + 150;
    (o.lines || []).forEach((ln) => { yy = wrapText(g, fmt(ln), W / 2, yy, W - 240, 60) + 34; });
    g.font = 'italic 500 36px "Cormorant Garamond", Georgia, serif'; g.fillStyle = '#c8a45e'; g.fillText('framedfantasy.com', W / 2, H - 110);
  };
  function wrapText(g, text, x, y, maxW, lh) {
    const words = String(text).split(/\s+/); let line = '', yy = y;
    for (const w of words) { const t = line ? line + ' ' + w : w; if (g.measureText(t).width > maxW && line) { g.fillText(line, x, yy); line = w; yy += lh; } else line = t; }
    if (line) g.fillText(line, x, yy);
    return yy;
  }
  FFD.wrapText = wrapText;

  /* ---------- the old framed plate (one scene, one button under it). New pages play in ctx.frame ---------- */
  function legacyScene(ctx, o, cleanups, alive) {
    const fig = h('figure', { class: 'ffd-scene' + (o.wide ? ' ffd-scene--wide' : '') });
    const stage = h('div', { class: 'ffd-stage', role: 'img', 'aria-label': fmt(o.alt || '') });
    if (o.aspect) stage.style.setProperty('--ffd-aspect', o.aspect);
    fig.append(stage);
    let btn = null;
    const waiters = [], handle = { el: fig, stage, key: o.key, mount: null, button: null };
    const fire = () => {
      wake();
      const act = (o.button && o.button.act) || o.tap || 'tap';
      if (o.beforeAct && o.beforeAct(act, handle) === false) return;
      handle.act(act);
      if (btn && o.button.after) btn.textContent = fmt(o.button.after);
      waiters.splice(0).forEach((w) => w(act));
    };
    if (o.button) { btn = h('button', { class: 'ffd-btn', type: 'button', text: fmt(o.button.label), onclick: fire }); fig.append(h('div', { class: 'ffd-actions' }, btn)); handle.button = btn; }
    if (o.caption) fig.append(h('figcaption', { text: fmt(o.caption) }));
    if (o.tap !== false) stage.addEventListener('click', fire);
    handle.act = (type, v) => { window.FFNoteScenes && FFNoteScenes.act(o.key, type, v); };
    handle.set = (n, v) => { window.FFNoteScenes && FFNoteScenes.set(o.key, n, v); };
    handle.get = (n) => (window.FFNoteScenes ? FFNoteScenes.get(o.key, n) : undefined);
    handle.press = () => new Promise((res) => waiters.push(res));
    (o.parent || ctx.root).append(fig);
    FFD.ready.then((api) => {
      if (!alive()) return;
      if (o.reset !== false) api._reset(o.key);
      if (o.set) Object.keys(o.set).forEach((k) => api.set(o.key, k, o.set[k]));
      handle.mount = api.mount(stage, o.key);
      sceneOwners[o.key] = (type, d) => { if (o.onEmit) o.onEmit(type, d); };
      listen(api, o.key);
      if (o.onReady) o.onReady(handle);
    }).catch(() => { stage.classList.add('is-failed'); });
    cleanups.push(() => { if (handle.mount) handle.mount.destroy(); delete sceneOwners[o.key]; });
    return handle;
  }

  /* =====================================================================================================================
     THE FRAME
     ===================================================================================================================== */
  const ICON_HINT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l1.7 5.6 5.8 1.9-5.8 1.9L12 17.5l-1.7-5.6-5.8-1.9 5.8-1.9z" fill="currentColor"/><path d="M19 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" fill="currentColor" opacity=".75"/></svg>';
  const ICON_ON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.2L12 5.6v12.8l-4.8-3.9H4z" fill="currentColor"/><path d="M15.2 9a4.3 4.3 0 0 1 0 6M17.6 6.6a7.6 7.6 0 0 1 0 10.8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  const ICON_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.2L12 5.6v12.8l-4.8-3.9H4z" fill="currentColor"/><path d="M15.5 9.5l5 5M20.5 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  const ICON_BOOK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6.4C10.2 5 7.6 4.6 3.5 4.8v13.1c4.1-.2 6.7.2 8.5 1.6 1.8-1.4 4.4-1.8 8.5-1.6V4.8C16.4 4.6 13.8 5 12 6.4z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M12 6.4v13.1" stroke="currentColor" stroke-width="1.4"/></svg>';

  /* ---- how words arrive (makeFrame's revealWords): the pace, in ms. cps letters a second; comma and stop, the beat
     after a comma (or ; :) and after a full stop (or ! ? …); fade, one word's fade in (core.css .ffs-w); cap, the
     length past which a line speeds up (the excess runs at a quarter of the time); lead, the moment a new speaker gets
     before their words; beat, between two lines of one page; tail, after the last word starts before the line counts
     as arrived; settle, how long the reading layer stays after a line's words are in while the story's next step comes
     (its tap to continue, its choices), so a tap aimed at the line never lands under it; run, how long after the
     reader's last tap through the text a choice waits before a pointer press counts ---- */
  const SAY = { cps: 44, word: 34, comma: 140, stop: 300, fade: 260, cap: 2200, lead: 200, beat: 260, tail: 150, settle: 450, run: 450 };
  /* each word of a node's text in a span (its trailing space with it); spaces before a word stay plain text */
  function splitWords(root) {
    const out = [], list = [];
    const walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let n = walk.nextNode(); n; n = walk.nextNode()) list.push(n);
    list.forEach((tn) => {
      const s = tn.nodeValue;
      if (!s || !/\S/.test(s)) return;
      const frag = document.createDocumentFragment();
      (s.match(/^\s+|\S+\s*/g) || []).forEach((pc) => {
        if (!/\S/.test(pc)) { frag.append(pc); return; }
        const sp = document.createElement('span');
        sp.className = 'ffs-w'; sp.textContent = pc;
        frag.append(sp); out.push(sp);
      });
      tn.replaceWith(frag);
    });
    return out;
  }
  /* the spans go and the text is whole again (words a page already replaced are left alone) */
  function unsplit(words) {
    const ps = new Set();
    words.forEach((w) => { const p = w.parentNode; if (!p) return; ps.add(p); w.replaceWith(...w.childNodes); });
    ps.forEach((p) => { try { p.normalize(); } catch (e) { /* fine */ } });
  }
  /* when each word starts, from the line's start: its letters at SAY.cps, the beats after punctuation (closing quotes
     and brackets don't count), and a long line pressed toward SAY.cap */
  function paceOf(words) {
    const at = [];
    let t = 0;
    words.forEach((w, i) => {
      at.push(t);
      const s = w.textContent, core = s.replace(/[\s"'“”‘’)\]»]+$/, '');
      t += Math.max(SAY.word, s.trim().length * 1000 / SAY.cps);
      if (i < words.length - 1) t += /[.!?…]$/.test(core) ? SAY.stop : /[,;:]$/.test(core) ? SAY.comma : 0;
    });
    if (t > SAY.cap) { const k = (SAY.cap + (t - SAY.cap) * 0.25) / t; for (let i = 0; i < at.length; i++) at[i] *= k; }
    return at;
  }

  /* the arrival itself: the words (spans from splitWords) fade in at the pace, one frame at a time (a hidden tab runs no
     frames, so a guard shows them after their time). finish() shows the rest at once, stop() leaves them where they
     are (their line is leaving). onEnd(shown) as it ends; o.after() once the last fade is over and the text is plain */
  function arriveCore(node, words, o, onEnd) {
    const at = paceOf(words), n = words.length;
    let k = 0, raf = 0, tDelay = 0, tTail = 0, tGuard = 0, t0 = 0, over = false, res = null;
    const done = new Promise((r) => { res = r; });
    const c = {
      done,
      finish() { if (over) return; node.classList.add('is-quick'); for (; k < n; k++) words[k].classList.add('is-on'); end(true); },
      stop() { end(false); }
    };
    function end(shown) {
      if (over) return;
      over = true;
      cancelAnimationFrame(raf); clearTimeout(tDelay); clearTimeout(tTail); clearTimeout(tGuard);
      if (onEnd) onEnd(shown);
      if (shown) setTimeout(() => { unsplit(words); node.classList.remove('is-quick'); if (o.after) o.after(); }, SAY.fade + 80);
      res(shown);
    }
    function tick(now) {
      raf = 0;
      if (over) return;
      if (!node.isConnected || (o.alive && !o.alive())) { end(false); return; }
      if (!t0) t0 = now;
      const e = now - t0;
      while (k < n && at[k] <= e) words[k++].classList.add('is-on');
      if (k >= n) { tTail = setTimeout(() => end(true), SAY.tail); return; }
      raf = requestAnimationFrame(tick);
    }
    const go = () => { if (!over) raf = requestAnimationFrame(tick); };
    if (o.delay) tDelay = setTimeout(go, o.delay); else go();
    tGuard = setTimeout(() => c.finish(), (o.delay || 0) + at[n - 1] + SAY.fade + 1600);
    return c;
  }
  /* FFD.arrive(el, text, { html, delay, tap }) -> { done: Promise, finish(), stop() }: the box's word by word arrival for
     a part's own element outside the box (the study's welcome, a fight's spoken line). It puts the text in el at once (so
     el takes its final height), its words clear, and fades them in at the box's pace; under reduced motion it simply
     shows them. html: true takes markup the caller trusts (FFD.fmtH's); tap: true lets a click on el show them whole.
     The text stays whole for screen readers all along: announce it from the part's own live region, as before */
  FFD.arrive = (el, text, ao) => {
    ao = ao || {};
    const none = { done: Promise.resolve(true), finish() {}, stop() {} };
    if (!el) return none;
    if (el.__ffdArrive) { const prev = el.__ffdArrive; el.__ffdArrive = null; prev.stop(); }
    if (text != null) { if (ao.html) el.innerHTML = String(text); else el.textContent = String(text); }
    if (RM() || !el.isConnected) return none;
    el.classList.add('ffd-arrive');
    const words = splitWords(el);
    if (!words.length) return none;
    const c = arriveCore(el, words, { delay: ao.delay }, () => { if (el.__ffdArrive === c) el.__ffdArrive = null; });
    el.__ffdArrive = c;
    if (ao.tap) { const f = () => c.finish(); el.addEventListener('click', f); c.done.then(() => el.removeEventListener('click', f)); }
    return c;
  };

  function makeFrame(ctx, o, cleanups, alive) {
    o = o || {};
    /* whose name the frame's lines carry: FFD.char, or the character F.as names (a guest from F.char({ guest: true })) */
    let asChar = null, meBtn = null, plate = null, switching = null;
    const fmt = (s) => fmtFor(s, asChar || undefined), fmtH = (s) => fmtHFor(s, asChar || undefined);
    const el = h('section', { class: 'ffs', 'aria-label': fmt(o.label || o.title || 'The scene') });
    const art = h('div', { class: 'ffs-art', role: 'img', 'aria-label': fmt(o.alt || '') });
    const hotsEl = h('div', { class: 'ffs-hots' });
    const fxEl = h('div', { class: 'ffs-fx', 'aria-hidden': 'true' });
    const tray = h('div', { class: 'ffs-tray' });
    const total = h('div', { class: 'ffs-total', 'aria-live': 'polite' });
    const resEl = h('div', { class: 'ffs-result', 'aria-live': 'polite' });
    const live = h('div', { class: 'ffs-sr', 'aria-live': 'polite' });
    const nameChip = h('div', { class: 'ffs-name', text: fmt(o.chip || o.title || '') });
    const hintBtn = h('button', { type: 'button', class: 'ffs-tool', 'aria-label': 'Show what you can touch', title: 'Show what you can touch', html: ICON_HINT });
    const muteBtn = h('button', { type: 'button', class: 'ffs-tool', 'aria-pressed': 'false', 'aria-label': 'Turn sound off', html: ICON_ON });
    const toolsEl = o.hint === false ? h('div', { class: 'ffs-tools' }, muteBtn) : h('div', { class: 'ffs-tools' }, hintBtn, muteBtn);
    const top = h('div', { class: 'ffs-top' }, nameChip, toolsEl);
    fxEl.append(tray, total);
    art.append(hotsEl, fxEl, resEl, top);
    const who = h('div', { class: 'ffs-who', hidden: true });
    const text = h('div', { class: 'ffs-text' });
    const acts = h('div', { class: 'ffs-acts' });
    const box = h('div', { class: 'ffs-box' }, who, text, acts);
    /* what is said, for screen readers: each page of lines once, whole (the words on screen arrive one by one) */
    const sayLive = h('div', { class: 'ffs-sr ffs-sr-say', 'aria-live': 'polite' });
    el.append(live, art, box, sayLive);
    (o.parent || ctx.root).append(el);
    if (!o.chip && !o.title) nameChip.hidden = true;
    /* the way home (FFD.libraryHref): a book left of the page's name, on every scene page but the library's own, and
       only when the scene is the whole page (not the coin played inside a blog post) */
    const homeHref = o.home === false || ctx.medium !== 'page' || (ctx.def && ctx.def.id === 'library') ? null : FFD.libraryHref();
    if (homeHref) {
      const hb = h('a', { class: 'ffs-tool ffs-home', href: homeHref, 'aria-label': 'Return to the library', title: 'Return to the library', html: ICON_BOOK });
      hb.addEventListener('click', (e) => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault(); e.stopPropagation(); wake(); snd('tap'); FFD.leaveTo(homeHref, el);
      });
      const lead = h('div', { class: 'ffs-lead' });
      top.replaceChild(lead, nameChip);
      lead.append(hb, nameChip);
    }

    const F = { el, art, box, text, acts, key: o.key, mount: null, api: null };
    let curKey = o.key, api = null, handlers = Object.assign({}, o.hots || {}), locked = false, isBusy = false;
    const emitFns = {}, waitHot = [], visited = {};
    let lastTouch = 0, hinted = false;

    /* ---- sound and the tools in the corner ---- */
    const paintMute = () => {
      const m = !!(S() && S().muted);
      muteBtn.setAttribute('aria-pressed', m ? 'true' : 'false'); muteBtn.setAttribute('aria-label', m ? 'Turn sound on' : 'Turn sound off');
      muteBtn.innerHTML = m ? ICON_OFF : ICON_ON;
    };
    muteBtn.addEventListener('click', (e) => { e.stopPropagation(); const s = S(); if (!s) return; s.wake(); s.setMuted(!s.muted); paintMute(); if (!s.muted) s.tap(); document.dispatchEvent(new CustomEvent('ffsound:mute', { detail: { muted: s.muted } })); });
    hintBtn.addEventListener('click', (e) => { e.stopPropagation(); wake(); F.hint(); });
    paintMute();
    const onMute = () => paintMute();
    document.addEventListener('ffsound:mute', onMute);
    cleanups.push(() => document.removeEventListener('ffsound:mute', onMute));

    /* ---- the scene ---- */
    F.ready = FFD.ready.then((a) => {
      if (!alive()) return F;
      api = F.api = a;
      if (o.reset !== false) a._reset(curKey);
      if (o.set) Object.keys(o.set).forEach((k) => a.set(curKey, k, o.set[k]));
      F.mount = a.mount(art, curKey);
      own(curKey);
      startSync();
      if (o.onReady) o.onReady(F);
      return F;
    }).catch((e) => { art.classList.add('is-failed'); throw e; });
    F.ready.catch(() => {});
    /* ---- the wings: on a window wider than the picture's widest shape (2.2 to 1), the picture keeps that shape in the
       middle and its own edge colours run out into the sides (core.css .has-wings). The colours are read from the
       canvas's two outer columns in six bands, top to bottom, a little darker toward the floor, on mount, after a resize
       and every few seconds while the wings show. A canvas that can't be read keeps plain ink wings ---- */
    let wingT = 0, wingRz = 0;
    const wingsWanted = () => WIDE() && el.clientWidth - art.clientWidth > 8;
    const paintWings = () => {
      if (!alive()) return;
      const on = wingsWanted();
      el.classList.toggle('has-wings', on);
      if (!on) return;
      const cv = canvas();
      if (!cv || !cv.width || !cv.height) return;
      let g = null;
      try { g = cv.getContext('2d'); } catch (e) { g = null; }
      if (!g) return;
      try {
        const W = cv.width, H = cv.height, bands = 6;
        const side = (x) => {
          const d = g.getImageData(x, 0, 2, H).data, stops = [];
          for (let b = 0; b < bands; b++) {
            const y0 = Math.floor(b * H / bands), y1 = Math.max(y0 + 1, Math.floor((b + 1) * H / bands));
            let r = 0, gg = 0, bl = 0, n = 0;
            for (let y = y0; y < y1; y++) for (let k = 0; k < 2; k++) { const i = (y * 2 + k) * 4; r += d[i]; gg += d[i + 1]; bl += d[i + 2]; n++; }
            const f = 0.86 - 0.2 * (b / (bands - 1));
            stops.push('rgb(' + Math.round(r / n * f) + ',' + Math.round(gg / n * f) + ',' + Math.round(bl / n * f) + ') ' + Math.round(b / (bands - 1) * 100) + '%');
          }
          return 'linear-gradient(180deg, ' + stops.join(', ') + ')';
        };
        el.style.setProperty('--ffs-wing-l', side(0));
        el.style.setProperty('--ffs-wing-r', side(Math.max(0, W - 2)));
      } catch (e) { /* plain ink wings */ }
    };
    F.ready.then(() => { setTimeout(paintWings, 700); }).catch(() => {});
    const onWingRz = () => { clearTimeout(wingRz); wingRz = setTimeout(paintWings, 520); };
    window.addEventListener('resize', onWingRz);
    wingT = setInterval(() => { if (el.classList.contains('has-wings') || wingsWanted()) paintWings(); }, 3000);
    cleanups.push(() => { window.removeEventListener('resize', onWingRz); clearTimeout(wingRz); clearInterval(wingT); });
    function own(key) {
      sceneOwners[key] = (type, d, k) => {
        (emitFns[type] || []).slice().forEach((fn) => { try { fn(d, k); } catch (e) { console.error(e); } });
        if (o.onEmit) o.onEmit(type, d, k);
      };
      listen(api, key);
    }
    F.scene = async (key, so) => {
      so = so || {};
      await F.ready;
      if (!alive() || !api) return;
      if (so.reset !== false) api._reset(key);
      if (so.set) Object.keys(so.set).forEach((k) => api.set(key, k, so.set[k]));
      if (curKey && curKey !== key) { try { api.set(curKey, 'hover', null); } catch (e) { /* fine */ } delete sceneOwners[curKey]; }
      curKey = F.key = key;
      F.hush(); beaconOff();
      pills.slice().forEach((p) => { p.el.classList.add('is-lost'); });
      own(key);
      if (so.alt) art.setAttribute('aria-label', fmt(so.alt));
      if (so.hots) handlers = Object.assign({}, so.hots);
      hv = -2; clearHots();
      F.mount.setKey(key);
      await ctx.wait(RM() ? 0 : 520);
    };
    F.act = (type, v) => { if (api) api.act(curKey, type, v); else F.ready.then(() => api && api.act(curKey, type, v)); };
    F.set = (n, v) => { if (api) api.set(curKey, n, v); else F.ready.then(() => api && api.set(curKey, n, v)); };
    F.get = (n) => (api ? api.get(curKey, n) : undefined);
    F.on = (type, fn) => { (emitFns[type] = emitFns[type] || []).push(fn); return () => { const a = emitFns[type]; const i = a ? a.indexOf(fn) : -1; if (i >= 0) a.splice(i, 1); }; };
    F.once = (type, ms) => new Promise((res) => {
      let off = null, t = 0;
      const done = (d) => { if (off) off(); clearTimeout(t); res(d || {}); };
      off = F.on(type, done);
      if (ms) t = setTimeout(() => done({ timeout: true }), RM() ? Math.min(ms, 400) : ms);
    });

    /* ---- hotspots: the scene publishes them, the frame lays a button over each ---- */
    const btns = {}, cssRects = {};
    let hv = -2, hg = '', rafId = 0, hoverId = null, tagEl = null;
    const canvas = () => { const cs = art.querySelectorAll('canvas.qo-scenes__cv'); return cs.length ? cs[cs.length - 1] : null; };
    function clearHots() { Object.keys(btns).forEach((id) => { btns[id].remove(); delete btns[id]; delete cssRects[id]; }); setHover(null); }
    function geo() {
      const cv = canvas(); if (!cv || !cv.style.width) return null;
      return { l: parseFloat(cv.style.left) || 0, t: parseFloat(cv.style.top) || 0, w: parseFloat(cv.style.width) || 0, hh: parseFloat(cv.style.height) || 0, key: cv.style.left + cv.style.top + cv.style.width + cv.style.height };
    }
    F.toCss = (gx, gy) => {
      const G = geo(), Hs = api && api.hot ? api.hot(curKey) : null;
      if (!G) return { x: art.clientWidth / 2, y: art.clientHeight / 2 };
      const W = (Hs && Hs.W) || (canvas() && canvas().width) || 1, Hh = (Hs && Hs.H) || (canvas() && canvas().height) || 1;
      return { x: G.l + gx * G.w / W, y: G.t + gy * G.hh / Hh };
    };
    F.spotCss = (id) => cssRects[id] || null;
    function layout(Hs, G) {
      const seen = {};
      if (Hs && Hs.W) {
        const kx = G.w / Hs.W, ky = G.hh / Hs.H;
        Object.keys(Hs.spots).forEach((id) => {
          const sp = Hs.spots[id], def = handlers[id];
          if (!def && !o.onHot) return;
          let x = G.l + sp.x * kx, y = G.t + sp.y * ky, w = sp.w * kx, hh = sp.h * ky;
          cssRects[id] = { x, y, w, h: hh, cx: x + w / 2, cy: y + hh / 2 };
          if (w < 44) { x -= (44 - w) / 2; w = 44; }
          if (hh < 44) { y -= (44 - hh) / 2; hh = 44; }
          x = Math.max(0, Math.min(art.clientWidth - w, x)); y = Math.max(0, Math.min(art.clientHeight - hh, y));
          seen[id] = 1;
          let b = btns[id];
          if (!b) {
            b = btns[id] = h('button', { type: 'button', class: 'ffs-hot', 'data-hot': id });
            b.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') setHover(id); });
            b.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && hoverId === id) setHover(null); });
            b.addEventListener('focus', () => { if (b.matches(':focus-visible')) setHover(id); });
            b.addEventListener('blur', () => { if (hoverId === id) setHover(null); });
            b.addEventListener('click', (e) => { e.stopPropagation(); tapHot(id); });
            hotsEl.append(b);
          }
          const lab = fmt((def && def.label) || id);
          if (b.getAttribute('aria-label') !== lab) b.setAttribute('aria-label', lab);
          b.style.cssText = `left:${x}px;top:${y}px;width:${w}px;height:${hh}px`;
          b.classList.toggle('is-locked', !!(locked || (def && def.off)));
        });
      }
      Object.keys(btns).forEach((id) => { if (!seen[id]) { btns[id].remove(); delete btns[id]; delete cssRects[id]; if (hoverId === id) setHover(null); } });
      placeBarks(); placeTag(); placeBeacons(); placePills();
    }
    function sync() {
      rafId = 0;
      if (!alive()) return;
      const G = geo();
      if (G && api) {
        const Hs = api.hot ? api.hot(curKey) : null, v = Hs ? Hs.v : -1;
        if (v !== hv || G.key !== hg) { hv = v; hg = G.key; layout(Hs, G); }
      }
      rafId = requestAnimationFrame(sync);
    }
    function startSync() { if (!rafId) rafId = requestAnimationFrame(sync); }
    cleanups.push(() => { if (rafId) cancelAnimationFrame(rafId); rafId = 0; });
    F.relayout = () => { hv = -2; };
    function setHover(id) {
      if (hoverId === id) return;
      hoverId = id;
      if (api) { try { api.set(curKey, 'hover', id); } catch (e) { /* fine */ } }
      placeTag();
    }
    /* the name of the thing under the pointer, over it (pointer devices only) */
    function placeTag() {
      if (!hoverId || !cssRects[hoverId] || !handlers[hoverId]) { if (tagEl) { tagEl.classList.remove('is-in'); } return; }
      if (!tagEl) { tagEl = h('div', { class: 'ffs-tag', 'aria-hidden': 'true' }); art.append(tagEl); }
      const r = cssRects[hoverId], lab = fmt(handlers[hoverId].label || '');
      if (tagEl.textContent !== lab) tagEl.textContent = lab;
      const x = Math.max(70, Math.min(art.clientWidth - 70, r.cx)), y = Math.max(28, r.y - 6);
      tagEl.style.left = x + 'px'; tagEl.style.top = y + 'px';
      tagEl.classList.add('is-in');
    }
    function ripple(x, y, cls) {
      if (RM()) return;
      const r = h('i', { class: 'ffs-ripple' + (cls ? ' ' + cls : ''), style: `left:${x}px;top:${y}px` });
      art.append(r);
      r.animate([{ transform: 'translate(-50%,-50%) scale(.3)', opacity: 0.9 }, { transform: 'translate(-50%,-50%) scale(1.6)', opacity: 0 }], { duration: 420, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = () => r.remove();
    }
    function tapHot(id) {
      wake(); lastTouch = Date.now();
      const def = handlers[id] || {}, r = cssRects[id];
      if (locked || def.off) { if (btns[id]) fx.shake(btns[id], 3); return; }
      if (r) ripple(r.cx, r.cy);
      visited[id] = 1;
      const pend = waitHot.filter((w) => w.ids.includes(id));
      if (pend.length) { pend.forEach((w) => { waitHot.splice(waitHot.indexOf(w), 1); w.fn(id); }); if (!def.always) return; }
      if (def.sound !== false) snd(def.sound || 'tap');
      if (typeof def.tap === 'function') { try { def.tap(id, F); } catch (e) { console.error(e); } }
      else if (o.onHot) { try { o.onHot(id, F); } catch (e) { console.error(e); } }
      else F.act('hot', id);
    }
    F.tapHot = tapHot;
    F.hots = (map, ho) => { handlers = (ho && ho.merge) ? Object.assign(handlers, map) : Object.assign({}, map); hv = -2; };
    F.hot = (id, def) => { if (def) handlers[id] = def; else delete handlers[id]; hv = -2; };
    F.lock = (on) => { locked = !!on; hv = -2; };
    F.visited = (id) => !!visited[id];
    /* a tap on the art away from anything clickable still answers, with a small ring where it landed */
    art.addEventListener('click', (e) => {
      if (e.target.closest('.ffs-hot, .ffs-tool, .ffs-bark, .ffs-pill')) return;
      wake(); lastTouch = Date.now();
      const r = art.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      ripple(x, y, 'is-soft');
      if (o.tapArt) { const G = geo(), Hs = api && api.hot ? api.hot(curKey) : null; if (G && Hs && Hs.W) o.tapArt((x - G.l) * Hs.W / G.w, (y - G.t) * Hs.H / G.hh, F); }
    });
    art.addEventListener('pointermove', () => { lastTouch = Date.now(); }, { passive: true });

    /* ---- the hint: everything that can be touched sparkles; once on its own if the reader hasn't touched anything ---- */
    F.hint = (ids) => {
      const list = (ids || Object.keys(cssRects).filter((id) => handlers[id] && !handlers[id].off));
      hinted = true;
      if (!list.length) { fx.shake(hintBtn, 3); return; }
      snd('chime');
      list.forEach((id, i) => {
        const r = cssRects[id]; if (!r) return;
        const g = h('i', { class: 'ffs-glint' + (visited[id] ? ' is-seen' : ''), style: `left:${r.cx}px;top:${r.cy}px;--d:${i * 70}ms` });
        art.append(g);
        setTimeout(() => g.remove(), 1500 + i * 70);
      });
      if (btns[list[0]] && !WIDE()) live.textContent = 'You can touch ' + list.map((id) => fmt(handlers[id].label || id)).slice(0, 6).join(', ') + '.';
    };
    /* ---- the beacon: a soft breathing ring on the thing the story is waiting for the reader to tap ---- */
    const beacons = {};
    function placeBeacons() {
      Object.keys(beacons).forEach((id) => {
        const r = cssRects[id], b = beacons[id];
        if (!r) { b.style.display = 'none'; return; }
        const w = Math.max(48, Math.min(170, r.w + 18)), hh = Math.max(48, Math.min(170, r.h + 18));
        b.style.cssText = `left:${r.cx}px;top:${r.cy}px;width:${w}px;height:${hh}px`;
      });
    }
    function beaconOn(ids) {
      [].concat(ids).map(String).forEach((id) => {
        if (beacons[id]) return;
        const b = h('i', { class: 'ffs-beacon', 'aria-hidden': 'true' });
        art.append(b); beacons[id] = b;
      });
      placeBeacons();
    }
    function beaconOff(ids) {
      (ids ? [].concat(ids).map(String) : Object.keys(beacons)).forEach((id) => {
        const b = beacons[id]; if (!b) return;
        delete beacons[id]; b.classList.add('is-out'); setTimeout(() => b.remove(), 260);
      });
    }
    F.beacon = (ids, on) => { if (on === false) beaconOff(ids); else beaconOn(ids); };
    const idle = setInterval(() => {
      if (!alive() || hinted || isBusy || !Object.keys(cssRects).length) return;
      if (Date.now() - lastTouch > 6500 && el.getBoundingClientRect().top < innerHeight * 0.5 && el.getBoundingClientRect().bottom > 0) F.hint();
    }, 1000);
    lastTouch = Date.now();
    cleanups.push(() => clearInterval(idle));

    /* ---- speech bubbles over the art ---- */
    const barks = [];
    /* the corner bar (the page's name, the tools): bubbles never sit on it */
    function cornerBoxes() {
      const ar = art.getBoundingClientRect(), out = [];
      [nameChip, ...top.querySelectorAll('.ffs-tool'), plate].forEach((n) => {
        if (!n || n.hidden || n.classList.contains('is-hid') || !n.offsetWidth) return;
        const r = n.getBoundingClientRect();
        out.push({ l: r.left - ar.left - 6, r: r.right - ar.left + 6, b: r.bottom - ar.top + 6 });
      });
      return out;
    }
    function placeBarks() {
      const corners = barks.length ? cornerBoxes() : [];
      barks.forEach((b) => {
        let x, y;
        if (b.id && cssRects[b.id]) { x = cssRects[b.id].cx; y = cssRects[b.id].y; }
        else if (b.pt) { const p = F.toCss(b.pt.x, b.pt.y); x = p.x; y = p.y; }
        else { x = art.clientWidth / 2; y = art.clientHeight * 0.32; }
        const bw = b.el.offsetWidth || 200, aw = art.clientWidth, bh = b.el.offsetHeight || 40;
        const left = Math.max(8 + bw / 2, Math.min(aw - 8 - bw / 2, x));
        /* how far down the corner bar reaches over this bubble's width */
        let ceil = 8;
        corners.forEach((cb) => { if (cb.r > left - bw / 2 && cb.l < left + bw / 2) ceil = Math.max(ceil, cb.b); });
        const topIfAbove = y - 6 - bh - 8;
        if (b.below || topIfAbove < ceil) {
          let yb = y;
          if (b.id && cssRects[b.id]) yb = cssRects[b.id].y + cssRects[b.id].h;
          const room = art.clientHeight - bh - 8;
          /* no room under its target: hang it just under the corner bar instead */
          let topB = yb + 8;
          if (topB > room) topB = Math.max(ceil, Math.min(room, y - bh - 14));
          if (topB < ceil) topB = ceil;
          const below = topB >= y - 4;
          b.el.classList.toggle('is-below', below);
          b.el.style.top = (below ? topB : topB + bh + 8) + 'px';
        } else { b.el.classList.remove('is-below'); b.el.style.top = (y - 6) + 'px'; }
        b.el.style.left = left + 'px';
        b.el.style.setProperty('--tail', Math.max(14, Math.min(bw - 14, bw / 2 + (x - left))) + 'px');
      });
    }
    F.bark = (target, msg, bo) => {
      bo = bo || {};
      const id = typeof target === 'string' ? target : null, pt = target && typeof target === 'object' ? target : null;
      const old = barks.find((b) => (id && b.id === id) || (!id && !pt && !b.id && !b.pt));
      if (old) dropBark(old, true);
      while (barks.length >= 2) dropBark(barks[0], true);
      const t = fmtH(msg);
      const said = h('span', { class: 'ffs-bark-t', html: t });
      const bel = h('div', { class: 'ffs-bark' + (bo.tone ? ' is-' + bo.tone : '') },
        bo.who ? h('b', { text: fmt(bo.who.name || bo.who) }) : null, said);
      art.append(bel);
      const b = { id, pt, el: bel, t: 0, below: !!bo.below, at: Date.now() };
      barks.push(b);
      placeBarks();
      requestAnimationFrame(() => bel.classList.add('is-in'));
      /* the speaker's name once, then the words (the bubble's own name element is not read twice) */
      live.textContent = (bo.who ? fmt(bo.who.name || bo.who) + ': ' : '') + said.textContent;
      /* the bubble has its full size from the start; its words follow it (and the name) in */
      if (!RM()) revealWords(said, { bark: b, delay: bo.who ? 170 : 110 });
      /* no timer: it stays until the reader's next tap (Jan: "you can't read what they are saying") */
      if (gateRes) placeCue();
      if (bo.sound !== false) snd(bo.sound || 'pop');
      return new Promise((res) => { b.res = res; });
    };
    function dropBark(b, fast) {
      const i = barks.indexOf(b); if (i < 0) return;
      barks.splice(i, 1); clearTimeout(b.t);
      [...reveals].forEach((r) => { if (r.bark === b) r.stop(); });
      b.el.classList.remove('is-in'); b.el.classList.add('is-out');
      setTimeout(() => b.el.remove(), fast ? 120 : 260);
      if (b.res) b.res();
    }
    F.hush = () => barks.slice().forEach((b) => dropBark(b, true));

    /* ---- the box: the speaker, the lines, the actions ---- */
    /* the speaker: a new one's face and name settle in (core.css .ffs-who.is-new); the same one speaking on stays still.
       Returns true when the speaker changed, so the words wait a moment for them */
    let whoKey = '', whoT = 0;
    function setWho(w) {
      const key = w ? fmt(w.name || '') + '|' + (w.img || '') + '|' + (w.icon || '') : '';
      if (key === whoKey && (!w || !who.hidden)) return false;
      whoKey = key;
      who.classList.remove('is-new');
      if (!w) { who.hidden = true; who.innerHTML = ''; return true; }
      who.hidden = false; who.innerHTML = '';
      if (w.img) who.append(h('img', { class: 'ffs-who-img', src: w.img, alt: '' }));
      else if (w.icon) who.append(h('img', { class: 'ffs-who-ic', src: FFD.icon(w.icon, 64), alt: '' }));
      who.append(h('span', { text: fmt(w.name || '') }));
      if (!RM()) { void who.offsetWidth; who.classList.add('is-new'); clearTimeout(whoT); whoT = setTimeout(() => who.classList.remove('is-new'), 520); }
      return true;
    }

    /* ---- words arriving (Jan, 2026-10-09: "make the general text coming in and when someone talks more intuitive and
       better designed for ux, right now the text comes in like kind of all at once and it feels buggy").
       A page of lines goes into the box whole, each word in its own span and clear (core.css .ffs-w), so it takes its
       final place and height before anything shows; then each line's words fade in one after another, line by line. The
       pace (SAY) is a calm read: about 44 letters a second, a beat after a comma and a longer one after a full stop, and a
       line longer than SAY.cap ms goes faster so it never drags. One tap (finishWords) shows them all. Once a line has arrived its spans go and it is
       plain text again, so a screen reader's swipe reads it in one piece. Nothing here runs under reduced motion ---- */
    const reveals = new Set();      /* words on their way in: { box, bark, finish(), stop() } */
    let sayRun = 0, rush = false, ate = 0, passAt = 0, holdT = 0;
    const waits = [];               /* [test, resolve]: F.read, F.ask and F.cont waiting for the words */
    const boxBusy = () => !!sayRun || [...reveals].some((r) => r.box);
    const idleAll = () => !sayRun && !reveals.size, idleBox = () => !boxBusy();
    function flushWaits() { waits.slice().forEach((w) => { if (w[0]()) { waits.splice(waits.indexOf(w), 1); w[1](); } }); }
    function syncReading() {
      el.classList.toggle('is-reading', boxBusy());
      /* a macrotask later: the say that owned these words has had its turn by then (it marks them unread) */
      if (waits.length) setTimeout(flushWaits, 0);
    }
    const whenRead = () => (idleAll() ? Promise.resolve() : new Promise((res) => waits.push([idleAll, res])));
    const whenSaid = () => (idleBox() ? Promise.resolve() : new Promise((res) => waits.push([idleBox, res])));
    /* while a bubble's words are on their way in, the box's next words wait for them (one voice at a time) */
    const barkBusy = () => [...reveals].some((r) => r.bark);
    const whenBarks = () => (!barkBusy() ? Promise.resolve() : new Promise((res) => waits.push([() => !barkBusy(), res])));
    F.read = whenRead;
    /* settling (the words critic, 2026-10-09: a tap that came just as a line finished went through to the room, to a thing
       under the finger, because the layer dropped as the last word began and nothing took taps until the story's next
       step was up). After a line's words are in, the layer stays (.ffs.is-settle) until that next step comes (its tap
       to continue, its choices, its button), or SAY.settle ms at most for a page that lets the reader roam. A tap on it
       then is spent like a tap that shows the words: it shows nothing new, marks nothing read and presses nothing */
    let settleT = 0;
    const settling = () => !!settleT;
    function settle(on) {
      clearTimeout(settleT); settleT = 0;
      if (on) settleT = setTimeout(() => { settleT = 0; el.classList.remove('is-settle'); }, SAY.settle);
      el.classList.toggle('is-settle', !!on);
    }
    /* the reader's run of taps through the text is the last pointer press on the layer, on the box's words or on the
       art around them, or one a choice refused. A choice counts a pointer press only SAY.run ms after it (tooSoon) */
    let runAt = -1e9;
    cleanups.push(() => { waits.splice(0).forEach((w) => w[1]()); [...reveals].forEach((r) => r.stop()); clearTimeout(holdT); clearTimeout(settleT); });
    /* a wait between beats that ends early when the reader taps the rest in */
    const pause = (ms) => new Promise((res) => {
      const t0 = Date.now();
      const f = () => { if (rush || !alive() || Date.now() - t0 >= ms) res(); else setTimeout(f, 40); };
      setTimeout(f, Math.min(40, ms));
    });
    function revealWords(node, ro) {
      ro = ro || {};
      if (!node || !node.isConnected) return Promise.resolve();
      const words = ro.words || splitWords(node);
      if (!words.length) return Promise.resolve();
      const r = { box: !!ro.box, bark: ro.bark || null, finish() {}, stop() {} };
      const c = arriveCore(node, words, { delay: ro.delay, alive,
        /* a line that has arrived goes back to the committed classes */
        after: () => { if (node.classList.contains('is-rev')) { node.classList.add('is-in'); node.classList.remove('is-rev'); } } },
        () => { reveals.delete(r); syncReading(); });
      r.finish = c.finish; r.stop = c.stop;
      reveals.add(r); syncReading();
      return c.done.then(() => {});
    }
    /* a line of the page shown whole at once (a tap came first, or reduced motion): its clear words come in quickly */
    function showNow(p) {
      const ws = p.__ffsWords;
      p.__ffsWords = null;
      if (ws && ws.length && !RM()) {
        p.classList.add('is-quick'); ws.forEach((w) => w.classList.add('is-on'));
        setTimeout(() => { unsplit(ws); p.classList.remove('is-quick', 'is-rev'); p.classList.add('is-in'); }, SAY.fade + 80);
        return;
      }
      if (ws && ws.length) unsplit(ws);
      p.classList.remove('is-rev'); p.classList.add('is-in');
      if (!RM()) { p.classList.add('is-quick'); setTimeout(() => p.classList.remove('is-quick'), 260); }
    }
    /* every word on its way in shows now (a tap, Enter or Space). The barks it finished stay for one more tap */
    function finishWords(tap) {
      const kept = [];
      let any = !!sayRun;
      if (sayRun) rush = true;
      [...reveals].forEach((r) => { any = true; if (r.bark) kept.push(r.bark); r.finish(); });
      /* a tap while the line settles answers too: its words are whole, the soft paper sound says the tap was heard */
      if (tap && (any || settling())) snd('leaf');
      return kept;
    }
    const unhold = () => { clearTimeout(holdT); el.classList.remove('is-hold'); };
    /* the layer stays for this tap's own click (whatever its press changed meanwhile), then goes */
    const hold = () => { el.classList.add('is-hold'); clearTimeout(holdT); holdT = setTimeout(() => { ate = 0; passAt = 0; unhold(); }, 900); };
    /* the box's height glides when its contents change (a new page of lines, chips coming or going), so the words never
       jump: on a wide screen the box grows up from its foot. Measured in two steps around the change */
    let glideA = null;
    function glideFrom() {
      const on = !RM() && !!box.animate && box.isConnected && box.offsetHeight > 0 && !box.classList.contains('is-empty');
      const h0 = on ? box.getBoundingClientRect().height : 0;
      if (glideA) { const a = glideA; glideA = null; a.cancel(); }
      box.classList.remove('is-glide');
      return { on, h0 };
    }
    function glideTo(g) {
      if (!g.on || !alive() || !box.isConnected) return;
      const h1 = box.getBoundingClientRect().height;
      if (!h1 || Math.abs(h1 - g.h0) < 3) return;
      box.classList.add('is-glide');
      const a = glideA = box.animate([{ height: g.h0 + 'px' }, { height: h1 + 'px' }], { duration: Math.round(Math.min(300, 170 + Math.abs(h1 - g.h0) * 0.6)), easing: 'cubic-bezier(.2, .8, .2, 1)' });
      const fin = () => { if (glideA === a) { glideA = null; box.classList.remove('is-glide'); } };
      a.onfinish = fin; a.oncancel = fin;
    }
    const glide = (fn) => { const g = glideFrom(); try { fn(); } finally { glideTo(g); } };
    /* a page of lines, for screen readers: the speaker's name where it changes, then the words, all at once */
    function announce(page) {
      let name = '';
      const parts = page.map(([p, it]) => {
        const w = it.who ? fmt(it.who.name || '') : (who.hidden ? '' : who.textContent);
        const pre = w && w !== name ? w + ': ' : '';
        if (w) name = w;
        return pre + p.textContent.trim();
      });
      sayLive.textContent = parts.join(' ');
    }
    /* ---- tap to continue (Jan, 2026-10-04: "the text is going to fast, you can't read what they are saying, so do like
       tap to continue for the dialogue"). No timer takes words away before they can be read: box lines stay until a tap
       moves the story on, and speech bubbles stay until the next tap. While the story waits, a clear layer over the frame
       takes the tap (so it can't also press something under it) and a small pixel ▾ blinks where the words end. */
    let unread = false, gateRes = null, gateP = null, sayAt = 0;
    const cue = h('i', { class: 'ffs-cue', 'aria-hidden': 'true' });
    const gateEl = h('button', { type: 'button', class: 'ffs-gate', 'aria-label': 'Continue', tabindex: '-1' });
    el.append(gateEl);
    /* the ▾ goes where the newest words are: just after the last word of the last line in the box, or of a bubble that
       came after it. It is set there by hand, out of the flow of the words, so it never moves one (the words critic,
       2026-10-09: as a little word of its own it pushed the greeting's last word onto a new line on a 390 px phone and
       the box jumped 23 px; a bubble grew 16 px and slid aside; and any thing at the end of a line changes where the
       browser's pretty wrapping breaks it). In the box it hangs from the box itself, so a line that runs to the edge of
       the text keeps it in the box's own margin; a bubble has no such margin, so when its last line runs to its edge the
       ▾ sits on the bubble's frame, at the foot's right corner (.is-corner) */
    function placeCue() {
      const ln = text.querySelector('.ffs-ln:last-child'), lb = barks.length ? barks[barks.length - 1] : null, bk = lb ? lb.el.querySelector('.ffs-bark-t') : null;
      const at = bk && (!ln || (lb.at || 0) > sayAt) ? bk : (ln || bk);
      if (!at) { cue.remove(); return; }
      const inBark = at === bk, host = inBark ? lb.el : box;
      let last = null;
      const tw = document.createTreeWalker(at, NodeFilter.SHOW_TEXT);
      for (let n = tw.nextNode(); n; n = tw.nextNode()) if (/\S/.test(n.nodeValue)) last = n;
      if (!last && !inBark) { cue.remove(); return; }
      if (cue.parentNode !== host) host.append(cue);
      /* in the host's own pixels (a bubble may still be scaling in), from the top of its scrolled contents */
      const hr = host.getBoundingClientRect(), k = host.offsetWidth ? hr.width / host.offsetWidth : 1;
      const ox = hr.left + host.clientLeft * k, oy = hr.top + host.clientTop * k;
      let x = -1, y = 0;
      if (last) {
        const rg = document.createRange();
        rg.selectNodeContents(last);
        const rs = rg.getClientRects(), r = rs[rs.length - 1];
        if (r) { x = Math.round((r.right - ox) / k + 6); y = Math.round((r.bottom - oy) / k - 10 + host.scrollTop); }
      }
      let corner = false;
      if (inBark && (x < 0 || x + 10 > host.clientWidth)) { corner = true; x = host.clientWidth - 12; y = host.clientHeight - 2; }
      else if (!inBark) x = Math.max(0, Math.min(x, host.clientWidth - 12));
      cue.classList.toggle('is-corner', corner);
      cue.style.left = x + 'px'; cue.style.top = y + 'px';
    }
    /* the words rewrap when the frame changes size (a phone turned), and the lines can scroll: the ▾ follows them */
    let cueRz = 0;
    const onCueRz = () => { if (cueRz) return; cueRz = requestAnimationFrame(() => { cueRz = 0; if (cue.isConnected && gateRes) placeCue(); }); };
    window.addEventListener('resize', onCueRz);
    text.addEventListener('scroll', onCueRz, { passive: true });
    cleanups.push(() => { window.removeEventListener('resize', onCueRz); cancelAnimationFrame(cueRz); });
    function gate() {
      if (!alive() || sheetOpen) return Promise.resolve();
      if (gateP) return gateP;
      gateP = new Promise((res) => { gateRes = res; });
      el.classList.add('is-gate'); settle(false); placeCue();
      return gateP;
    }
    function openGate() {
      if (!gateRes) return;
      const r = gateRes; gateRes = null; gateP = null; unread = false;
      el.classList.remove('is-gate'); cue.remove(); snd('tap'); dropPlate(); r();
    }
    /* tap-through (opt in, ctx.frame({ tapThrough })): the topmost thing under the layer, when the tap lands inside a
       hotspot's drawn shape (not its padded 44 px button) and the story isn't waiting on it */
    function hotUnder(top, x, y) {
      const b = top && top.closest ? top.closest('.ffs-hot') : null;
      if (!b || !hotsEl.contains(b)) return null;
      const id = b.getAttribute('data-hot'), r = cssRects[id], ar = art.getBoundingClientRect();
      if (!id || !r) return null;
      const lx = x - ar.left, ly = y - ar.top;
      if (lx < r.x || lx > r.x + r.w || ly < r.y || ly > r.y + r.h) return null;
      return waitHot.some((w) => w.ids.includes(id)) ? null : id;
    }
    const topUnder = (e) => { try { return document.elementsFromPoint(e.clientX, e.clientY).find((n) => n !== gateEl) || null; } catch (er) { return null; } };
    const meHit = (e) => {
      if (!meBtn || !meBtn.isConnected || e.clientX == null) return false;
      const r = meBtn.getBoundingClientRect();
      return e.clientX >= r.left - 4 && e.clientX <= r.right + 4 && e.clientY >= r.top - 4 && e.clientY <= r.bottom + 4;
    };
    gateEl.addEventListener('click', (e) => {
      e.stopPropagation(); wake();
      /* this tap already showed the words whole on its way down (readOn): it is spent. A page's own tapThrough function
         still hears it, as it hears every tap on this layer */
      const mine = e.detail > 0 && !!ate && Date.now() - ate < 1500, thru = e.detail > 0 && !!passAt && Date.now() - passAt < 1500;
      if (ate || passAt) { ate = 0; passAt = 0; unhold(); }
      if (mine) {
        if (typeof o.tapThrough === 'function') { const top = topUnder(e); if (top) { try { o.tapThrough(top, e); } catch (er) { console.error(er); } } }
        return;
      }
      /* the "playing as" chip sits under this layer: it still opens the switch sheet, and the story keeps waiting */
      if (e.detail > 0 && meHit(e)) { snd('tap'); openSwitch(); return; }
      /* a thing squarely under the layer gets the tap, also when its press already made the page give way (thru) */
      if (o.tapThrough && e.detail > 0 && (gateRes || !idleAll() || thru)) {
        const top = topUnder(e), id = hotUnder(top, e.clientX, e.clientY);
        if (id) tapHot(id);
        else if (top && typeof o.tapThrough === 'function') { try { o.tapThrough(top, e); } catch (er) { console.error(er); } }
        /* the page gave way to what was tapped: the dialogue is gone, nothing to continue */
        if (!gateRes && idleAll()) return;
      }
      /* words still arriving (a click with no press first, or a thing tapped through that left them): show them whole */
      if (!idleAll()) { finishWords(true); return; }
      openGate();
    });
    /* every pointer press in the frame, before anything else hears it. A choice's press is judged here: too new, or the
       reader still tapping through the text (within SAY.run ms of their last such tap), it is refused and keeps the run
       going. A press on the layer, on the box's words or on the art around them is a tap through the text */
    function pressRun(e) {
      const t = e.target, now = performance.now();
      if (!t || !t.closest) return;
      const c = t.closest('.ffs-chip, .ffs-pill, .ffd-choice');
      if (c) { const no = now < (c.__liveAt || 0) || now < runAt + SAY.run; c.__press = { at: now, no }; if (no) runAt = now; return; }
      if (t === gateEl || !t.closest('button, a, input, textarea, select, label, [contenteditable], .ffs-sheet')) runAt = now;
    }
    /* any touch of the frame reads on: the box's lines count as read, and the bubbles go */
    const readOn = (e) => {
      if (e && e.type === 'pointerdown') pressRun(e);
      if (e && e.target && e.target.closest && e.target.closest('.ffs-sheet')) return;
      /* words still arriving, or the line just in and settling: this touch shows them whole. On the reading layer, or on
         the box's words (the box sits over the layer meanwhile, core.css), it does nothing else: a click on the layer is
         swallowed, and a page's own capture listeners on the frame never hear it (so the library's aside stays to be
         read). A thing squarely under the layer (tapThrough) and the "playing as" chip keep their tap; so does a chip
         already in the box (a lasting row such as the coin's calls: the words show whole and the chip works). The bubbles
         it finished stay one more tap */
      if (e && e.type === 'pointerdown' && (!idleAll() || settling())) {
        const onLayer = e.target === gateEl, t = e.target;
        if (onLayer && (meHit(e) || (o.tapThrough && hotUnder(topUnder(e), e.clientX, e.clientY)))) { passAt = Date.now(); hold(); return; }
        const kept = finishWords(true);
        const spent = onLayer || (box.contains(t) && !(t.closest && t.closest('button, a, input, textarea, select, [contenteditable]')));
        if (spent) {
          if (onLayer) { ate = Date.now(); hold(); }
          if (o.tapThrough) e.stopImmediatePropagation();
          return;
        }
        unread = false;
        barks.slice().forEach((b) => { if (!kept.includes(b)) dropBark(b); });
        if (plate && !(e.target && e.target.closest && e.target.closest('.ffs-me'))) dropPlate();
        return;
      }
      unread = false;
      if (barks.length) barks.slice().forEach((b) => dropBark(b));
      /* the "Playing as" plate, like a bubble, goes on the reader's next tap (not one on the plate itself) */
      if (plate && !(e && e.target && e.target.closest && e.target.closest('.ffs-me'))) dropPlate();
    };
    el.addEventListener('pointerdown', readOn, true);
    const onKey = (e) => {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'ArrowRight') return;
      const ae = document.activeElement;
      if (ae && ae.closest && (ae.closest('input, textarea, select, [contenteditable]') || ae.closest('.ffs-sheet'))) return;
      /* a key pressed on something outside the frame (a page's own dialog or button) is that thing's */
      if (ae && ae !== document.body && ae !== document.documentElement && !el.contains(ae)) return;
      /* words still arriving in the box (or in a bubble while the story waits), or the line settling: the key shows them
         whole, nothing else */
      if (!idleBox() || settling() || (gateRes && !idleAll())) { const r = el.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) { e.preventDefault(); e.stopPropagation(); finishWords(true); } return; }
      if (!idleAll()) finishWords(false);
      if (gateRes) { const r = el.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) { e.preventDefault(); e.stopPropagation(); openGate(); } return; }
      if (ae && el.contains(ae)) readOn(e);
    };
    document.addEventListener('keydown', onKey, true);
    cleanups.push(() => { document.removeEventListener('keydown', onKey, true); if (gateRes) { const r = gateRes; gateRes = null; r(); } });
    F.cont = async (co) => {
      co = co || {};
      /* a line still arriving: its words first (one tap shows them), then the wait for the next tap */
      if (!idleBox()) await whenSaid();
      if (!alive()) return;
      if (!co.always && !unread && !barks.length) return;
      return gate();
    };
    /* the lines' own area is full (a new line's 5 px rise is allowed for). Only the lines count: on a phone the box also
       holds the chips and scrolls as a whole, and turning a page there cost a tap on nearly every two-line beat */
    const overfull = () => text.scrollHeight > text.clientHeight + 8;
    let sayN = 0;
    /* F.cancel's count, and the waits it can drop (each F.ask and F.next registers one while it waits) */
    let cancelN = 0;
    const pend = new Set();
    /* a click on the box itself (no layer over it, or a keyboard's click) shows the words whole too */
    box.addEventListener('click', (e) => { if (!e.target.closest('button, a, input') && !idleAll()) finishWords(true); });
    F.say = async (lines, so) => {
      so = so || {};
      if (!so.add) el.classList.remove('is-ending');
      const my = ++sayN;
      if (!Array.isArray(lines)) lines = [lines];
      const items = lines.filter((x) => x != null && x !== false).map((raw) => (typeof raw === 'string' ? { text: raw } : raw));
      /* the box still holds lines nobody has tapped past: wait for the tap before taking them away */
      if (!so.add && !so.now && unread && text.querySelector('.ffs-ln')) { await gate(); if (!alive() || my !== sayN) return; }
      /* words an earlier say still brings in: added to, they show whole; replaced, they stop where they are and go */
      [...reveals].forEach((r) => { if (r.box) { if (so.add) r.finish(); else r.stop(); } });
      sayRun = my; rush = RM(); settle(false); syncReading();
      const done = () => { if (sayRun === my) { sayRun = 0; syncReading(); } };
      let old = [];
      if (!so.add) {
        old = [...text.children];
        if (old.length) { old.forEach((e2) => e2.classList.add('is-out')); await ctx.wait(rush ? 0 : 170); }
        if (my !== sayN) { old.forEach((e2) => e2.remove()); done(); return; }
      }
      let i = 0, first = true, rushed = rush;
      while (first || i < items.length) {
        if (!alive() || my !== sayN) { done(); return; }
        const page = [];
        let fresh = false;
        /* the page: as many lines as the box holds (at least one), laid out whole and clear, in one glide */
        glide(() => {
          if (!first || !so.add) { old.forEach((e2) => e2.remove()); [...text.children].forEach((c) => c.remove()); }
          else [...text.children].forEach((c) => { if (c.__ffsWait) c.remove(); });   /* lines a cut-short say never showed */
          if (first) {
            if (!so.add) { fresh = setWho(so.who || null); nameChip.classList.remove('is-hid'); }
            else if (so.who) fresh = setWho(so.who);
          }
          for (; i < items.length; i++) {
            const it = items[i];
            const p = h('p', { class: 'ffs-ln' + (it.cls ? ' ' + it.cls.split(' ').map((c) => 'is-' + c).join(' ') : ''), html: fmtH(it.text) });
            p.__ffsWait = true;
            text.append(p);
            /* a full box turns its page: the reader taps, the old lines go, and this one starts the next page */
            if (text.children.length > 1 && overfull()) { p.remove(); break; }
            page.push([p, it]);
          }
          /* the page's lines stand in place from the start, whole and readable to a screen reader, their words clear */
          if (!rush) page.forEach(([p]) => { p.classList.add('is-rev'); p.__ffsWords = splitWords(p); });
        });
        first = false;
        if (page.length) announce(page);
        for (let j = 0; j < page.length; j++) {
          const [p, it] = page[j];
          if (!alive() || my !== sayN) { done(); return; }
          /* the speaker changes with their line, never before the page has turned */
          if (it.who && setWho(it.who)) fresh = true;
          p.__ffsWait = false;
          sayAt = Date.now();
          keepInView(p);
          if (it.sound) snd(it.sound);
          /* a new speaker settles in before their words */
          if (fresh && !rush) { fresh = false; await pause(SAY.lead); if (!alive() || my !== sayN) { done(); return; } }
          fresh = false;
          /* one voice at a time (the words critic, 2026-10-09: a bubble and the box typing at once sent the eyes back and
             forth between two half sentences): a bubble still arriving, a remark said just before this line, finishes
             first, then a short beat. The line already stands in place, clear; a tap shows both whole */
          if (!rush && barkBusy()) {
            await whenBarks();
            if (!alive() || my !== sayN) { done(); return; }
            if (!rush) await pause(SAY.beat - SAY.tail);
            if (!alive() || my !== sayN) { done(); return; }
          }
          if (rush) { showNow(p); rushed = true; continue; }
          const ws = p.__ffsWords; p.__ffsWords = null;
          await revealWords(p, { box: true, words: ws });
          if (rush) rushed = true;
          if (j < page.length - 1 && !rush) await pause(so.gap ? Math.min(so.gap, 1200) : SAY.beat);
        }
        if (i < items.length) {
          /* more lines than the box holds: the next page waits for a tap */
          unread = true; done();
          await gate();
          if (!alive() || my !== sayN) return;
          sayRun = my; rush = RM(); rushed = rush; syncReading();
        }
      }
      /* the words are in: the layer stays while they settle, until the story's next step is up (settle) */
      if (my === sayN && items.length) { unread = true; settle(true); }
      done();
      await ctx.wait(rushed ? 110 : 140);
    };
    F.title = (title, line) => {
      text.innerHTML = '';
      nameChip.classList.add('is-hid');
      setWho(null);
      text.append(h('h1', { class: 'ffs-h1', text: fmt(title) }));
      if (line) text.append(h('p', { class: 'ffs-ln is-in is-lead', text: fmt(line) }));
    };
    function keepInView(node) {
      const sc = text.scrollHeight > text.clientHeight + 2 ? text : box;
      if (sc.scrollHeight <= sc.clientHeight + 2) return;
      const target = Math.max(0, node.offsetTop - (sc === text ? text.offsetTop : 0) + node.offsetHeight - sc.clientHeight + 12);
      if (target > sc.scrollTop) sc.scrollTo({ top: target, behavior: RM() ? 'auto' : 'smooth' });
    }
    F.clear = () => { [...reveals].forEach((r) => { if (r.box) r.stop(); }); settle(false); glide(() => { text.innerHTML = ''; acts.innerHTML = ''; setWho(null); }); unread = false; };
    /* ---- quiet (Jan, 2026-10-05: "try to not have a text panel constantly be showing we need it to feel immersive"):
       F.quiet() (or ctx.frame({ quiet: true })) shows the box only while it holds lines or actions and fades it out
       whenever it empties, after a 160 ms grace so one line giving way to the next never blinks. On a phone the art then
       fills the frame, one screen tall, and the box floats over its foot as on a wide screen (core.css .is-quiet).
       F.talk(lines, so) says the lines, waits for the reader's tap, then clears the box (so a quiet box goes). ---- */
    let quietMo = null, emptyT = 0;
    /* words F.cancel is fading out (marked __ffsGone) already count as gone, so the box fades as one */
    const isEmpty = () => ![...text.children].some((n) => !n.__ffsGone) && ![...acts.children].some((n) => !n.__ffsGone);
    const syncEmpty = (now) => {
      clearTimeout(emptyT);
      if (!isEmpty()) { box.classList.remove('is-empty'); return; }
      if (now) box.classList.add('is-empty');
      else emptyT = setTimeout(() => { if (alive() && isEmpty()) box.classList.add('is-empty'); }, 160);
    };
    F.quiet = (on) => {
      on = on !== false;
      el.classList.toggle('is-quiet', on);
      if (!on) { clearTimeout(emptyT); box.classList.remove('is-empty'); if (quietMo) { quietMo.disconnect(); quietMo = null; } return; }
      if (!quietMo) {
        quietMo = new MutationObserver(() => syncEmpty(false));
        quietMo.observe(text, { childList: true }); quietMo.observe(acts, { childList: true });
        cleanups.push(() => { clearTimeout(emptyT); if (quietMo) quietMo.disconnect(); });
      }
      syncEmpty(true);
    };
    F.talk = async (lines, so) => {
      const n = cancelN;
      await F.say(lines, so);
      if (!alive() || n !== cancelN) return;
      await F.cont({ always: true });
      /* a cancel while it waited took the words away already: never wipe what came next */
      if (alive() && n === cancelN) F.clear();
    };
    /* ---- giving way (opt in, F.cancel): the box drops what it waits on and its words fade, so whatever the reader
       touched next can open. Only the nodes on show now go; words that arrive during the fade stay ---- */
    F.cancel = () => {
      cancelN++; sayN++; unread = false;
      [...reveals].forEach((r) => r.stop()); rush = true; sayRun = 0; settle(false); syncReading();
      if (gateRes) { const r = gateRes; gateRes = null; gateP = null; el.classList.remove('is-gate'); cue.remove(); r(); }
      [...pend].forEach((p) => { try { p.cancel(); } catch (er) { console.error(er); } });
      if (sheetOpen) sheetOpen.close(null);
      F.hush(); dropAskBeacon();
      const old = [...text.children, ...acts.children];
      old.forEach((n) => { n.__ffsGone = true; n.classList.add('is-out'); });
      if (el.classList.contains('is-quiet') && old.length) { clearTimeout(emptyT); box.classList.add('is-empty'); }
      return ctx.wait(RM() ? 0 : 180).then(() => {
        old.forEach((n) => n.remove());
        if (!text.childElementCount) setWho(null);
      });
    };
    F.epoch = () => cancelN;
    let askBeacon = null;   /* { t, ids }: the ring an unanswered F.ask will light; cleared with its chips */
    const dropAskBeacon = () => { if (!askBeacon) return; clearTimeout(askBeacon.t); beaconOff(askBeacon.ids); askBeacon = null; };
    const clearActs = async () => {
      dropAskBeacon();
      const old = [...acts.children];
      if (!old.length) return;
      old.forEach((e2) => e2.classList.add('is-out'));
      await ctx.wait(RM() ? 0 : 150);
      glide(() => old.forEach((e2) => e2.remove()));
    };
    /* a choice answers a pointer tap only once it can be read (chip() sets __liveAt, about 170 ms after it rises, faster
       than anyone reacts to something new) and once the reader has stopped tapping through the text (SAY.run ms after
       their last tap that showed words, went on, or that a choice refused: pressRun judged the press on its way down).
       So a run of quick taps never lands on a choice that rose under the finger (the words critic, 2026-10-09: a third
       tap 300 ms apart picked "Something else"), and a deliberate tap after a glance at the choices always counts.
       A keyboard's click (detail 0) always counts */
    const tooSoon = (e, b) => {
      if (!b || !(e.detail > 0)) return false;
      const p = b.__press, now = performance.now();
      b.__press = null;
      if (p && now - p.at < 1500) return p.no;
      /* a click whose press went unseen: judged as it lands */
      const no = now < (b.__liveAt || 0) || now < runAt + SAY.run;
      if (no) runAt = now;
      return no;
    };
    acts.addEventListener('click', (e) => {
      const b = e.target && e.target.closest ? e.target.closest('.ffs-chip') : null;
      if (tooSoon(e, b)) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    const liveAt = (i) => performance.now() + (RM() ? 80 : 170 + (i || 0) * 40);
    F.clearActs = clearActs;
    /* chips always sit in even rows (Jan's rule): a phone takes two columns, a wide screen up to four; a short last row
       stretches its last chip over the gap. Runs whenever chips come, go, show or hide, whoever added them. */
    function layoutActs() {
      if (acts.classList.contains('is-end') || acts.classList.contains('is-one')) { acts.style.gridTemplateColumns = ''; return; }
      const vis = [...acts.children].filter((c) => c.classList.contains('ffs-chip') && !c.hidden && !c.classList.contains('is-out') && !c.classList.contains('is-gone'));
      [...acts.children].forEach((c) => { if (c.style) c.style.gridColumn = ''; });
      vis.forEach((c) => { c.style.gridColumn = 'auto'; });
      const n = vis.length;
      if (!n) { acts.style.gridTemplateColumns = ''; return; }
      let cols = WIDE() ? (n <= 4 ? n : n <= 6 ? 3 : 4) : (n === 1 ? 1 : 2);
      const cap = +acts.dataset.cols || 0;
      if (cap > 0) cols = Math.max(1, Math.min(cols, cap));
      acts.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
      const r = n % cols;
      if (r) vis[n - 1].style.gridColumn = 'span ' + (cols - r + 1);
    }
    F.layoutActs = layoutActs;
    if (window.MutationObserver) {
      let lq = 0;
      const mo = new MutationObserver(() => { if (lq) return; lq = requestAnimationFrame(() => { lq = 0; layoutActs(); }); });
      mo.observe(acts, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      cleanups.push(() => mo.disconnect());
    }
    const onWide = () => layoutActs();
    try { matchMedia('(min-width: 720px)').addEventListener('change', onWide); cleanups.push(() => matchMedia('(min-width: 720px)').removeEventListener('change', onWide)); } catch (e) { /* old browsers */ }
    /* ---- used options: a picked option stays, greyed with a small tick, and still works ---- */
    const usedKeys = new Set();
    const useKey = (x, label) => (x && typeof x === 'object' && x.key != null ? 'k:' + x.key : 'l:' + label);
    const canUse = (x, row) => (x && typeof x === 'object' && x.used != null ? !!x.used : !!row);
    function chip(label, co) {
      co = co || {};
      const b = h('button', { type: 'button', class: 'ffs-chip' + (co.solid ? ' is-solid' : '') + (co.quiet ? ' is-quiet' : '') + (co.wide ? ' is-wide' : ''), style: '--i:' + (co.i || 0) },
        co.icon ? h('img', { class: 'ffs-chip-ic', src: co.icon, alt: '' }) : null, h('span', { text: fmt(label) }));
      b.__liveAt = liveAt(co.i);
      return b;
    }
    F.chip = chip;
    function waitFor(ids, fn) { const w = { ids: [].concat(ids).map(String), fn }; waitHot.push(w); return () => { const i = waitHot.indexOf(w); if (i >= 0) waitHot.splice(i, 1); }; }
    /* ---- action pills: when the story waits on a thing in the picture, its button is written on the thing itself ---- */
    const pills = [];
    function artFloor() {
      if (!WIDE()) return art.clientHeight - 30;
      const ar = art.getBoundingClientRect(), br = box.getBoundingClientRect();
      return br.top > ar.top && br.top < ar.bottom ? br.top - ar.top - 8 : art.clientHeight - 8;
    }
    function placePills() {
      if (!pills.length) return;
      const corners = cornerBoxes(), floor = artFloor(), aw = art.clientWidth;
      pills.forEach((p) => {
        const id = p.ids.find((x) => cssRects[x]), r = id && cssRects[id];
        if (!r) { p.el.classList.add('is-lost'); return; }
        p.el.classList.remove('is-lost');
        const pw = p.el.offsetWidth || 140, ph = p.el.offsetHeight || 44;
        const x = Math.max(10 + pw / 2, Math.min(aw - 10 - pw / 2, r.cx));
        let ceil = 8;
        corners.forEach((cb) => { if (cb.r > x - pw / 2 && cb.l < x + pw / 2) ceil = Math.max(ceil, cb.b); });
        let y = r.y + r.h + 10, below = true;
        if (y + ph > floor) { y = r.y - ph - 10; below = false; }
        if (y < ceil) { y = Math.max(ceil, Math.min(floor - ph, r.cy - ph / 2)); below = true; }
        p.el.classList.toggle('is-above', !below);
        p.el.style.left = x + 'px'; p.el.style.top = y + 'px';
        p.el.style.setProperty('--tip', Math.max(16, Math.min(pw - 16, pw / 2 + (r.cx - x))) + 'px');
      });
    }
    let diceAt = 0;
    const settleDice = () => {
      if (!tray.classList.contains('is-in')) return;
      const age = Date.now() - diceAt;
      if (age > 900) F.clearDice(); else setTimeout(() => { if (Date.now() - diceAt >= 880) F.clearDice(); }, 900 - age);
    };
    F.next = async (label, no) => {
      no = no || {};
      el.classList.remove('is-ending');
      settleDice();
      /* the button comes once the box's words have all arrived (and a bubble's, below) */
      const c0 = cancelN;
      await whenSaid();
      if (c0 !== cancelN) return 'cancel';
      await clearActs();
      if (c0 !== cancelN) return 'cancel';
      return new Promise((res) => {
        const ids = no.hot ? [].concat(no.hot).map(String) : [];
        let un = null, bt = 0, fb = 0, b = null, pill = null, finished = false;
        /* F.cancel: resolves 'cancel'; its pill fades (a chip in the box fades with the box) */
        const me = {
          cancel() {
            if (finished) return; finished = true; pend.delete(me);
            if (un) un(); clearTimeout(bt); clearTimeout(fb);
            if (ids.length) beaconOff(ids);
            if (pill) { const i = pills.indexOf(pill); if (i >= 0) pills.splice(i, 1); pill.el.classList.add('is-out'); setTimeout(() => pill.el.remove(), 220); }
            res('cancel');
          }
        };
        pend.add(me);
        const done = (via) => {
          if (finished) return; finished = true; pend.delete(me);
          if (un) un(); clearTimeout(bt); clearTimeout(fb);
          if (ids.length) beaconOff(ids);
          if (pill) { const i = pills.indexOf(pill); if (i >= 0) pills.splice(i, 1); pill.el.classList.add('is-picked'); setTimeout(() => { pill.el.classList.add('is-out'); setTimeout(() => pill.el.remove(), 220); }, RM() ? 0 : 120); }
          if (b) { b.classList.add('is-picked'); setTimeout(() => { b.classList.add('is-out'); setTimeout(() => b.remove(), 150); }, RM() ? 0 : 140); }
          res(via || 'chip');
        };
        const showChip = () => {
          if (finished || b) return;
          acts.dataset.cols = '';
          b = chip(label, { solid: no.solid !== false && !no.quiet, quiet: no.quiet, wide: true });
          b.addEventListener('click', () => { wake(); snd(no.sound || 'tap'); done('chip'); });
          acts.className = 'ffs-acts';
          glide(() => { acts.append(b); layoutActs(); });
        };
        /* the thing in the picture answers at once (a tap on it while a bubble still arrives goes on) */
        if (ids.length) un = waitFor(ids, (id) => done(id));
        /* the button itself comes once every word on its way in has arrived, a bubble's too (the coin's "Walk to the
           Hollow Stump" says what Yost's bubble is still saying) */
        whenRead().then(() => {
          if (finished || c0 !== cancelN || !alive()) return;
          settle(false);
          if (ids.length && no.chip !== true) {
            pill = { ids, el: h('button', { type: 'button', class: 'ffs-pill' + (no.quiet ? ' is-quiet' : ''), 'aria-label': fmt(label) }, h('i', { class: 'ffs-pill-dot', 'aria-hidden': 'true' }), h('span', { text: fmt(label) })) };
            pill.el.__liveAt = liveAt(0);
            pill.el.addEventListener('click', (e) => { e.stopPropagation(); if (tooSoon(e, pill.el)) return; wake(); snd(no.sound || 'tap'); done('pill'); });
            art.append(pill.el); pills.push(pill); placePills();
            requestAnimationFrame(() => { placePills(); pill.el.classList.add('is-in'); });
            /* the thing isn't in the picture (yet): the button waits in the box instead */
            fb = setTimeout(() => { if (!finished && !ids.some((id) => cssRects[id])) { pill.el.classList.add('is-lost'); showChip(); } }, 500);
          } else showChip();
          /* a pill already points at the thing: the glow only comes when the button had to wait in the box */
          if (ids.length && no.beacon !== false) bt = setTimeout(() => { if (!finished && alive() && (!pill || pill.el.classList.contains('is-lost'))) beaconOn(ids); }, no.beaconAfter != null ? no.beaconAfter : 1800);
          if (ids.length && no.hint !== false) setTimeout(() => { if (!finished && alive()) F.hint(ids.filter((id) => cssRects[id])); }, no.hintAfter || 5200);
        });
      });
    };
    F.ask = async (options, ao) => {
      ao = ao || {};
      el.classList.remove('is-ending');
      settleDice();
      /* the choices come once every word on its way in has arrived, the box's and a bubble's, so a reader picks only
         what they've read */
      const c0 = cancelN, gone = { index: -1, label: '', value: undefined, cancelled: true };
      await whenRead();
      if (c0 !== cancelN) return gone;
      const labels = options.map((x) => fmt(typeof x === 'string' ? x : x.label));
      const long = labels.some((l) => l.length > (WIDE() ? 60 : 40));
      if (ao.sheet || (ao.sheet !== false && (options.length > 6 || (options.length > 4 && long)))) return askSheet(options, labels, ao);
      await clearActs();
      if (c0 !== cancelN) return gone;
      acts.dataset.cols = ao.cols ? String(ao.cols) : '';
      return new Promise((res) => {
        const unhots = [];
        settle(false);
        acts.className = 'ffs-acts' + ((ao.cols === 1 || long) ? ' is-one' : '');
        const g = glideFrom();
        const bs = options.map((x, i) => {
          const b = chip(labels[i], { i, icon: typeof x === 'object' ? x.icon : null });
          if (canUse(x, ao.used) && usedKeys.has(useKey(x, labels[i]))) b.classList.add('is-used');
          b.addEventListener('click', () => { wake(); snd('tap'); pick(i); });
          acts.append(b);
          if (typeof x === 'object' && x.hot) unhots.push(waitFor(x.hot, () => pick(i)));
          return b;
        });
        layoutActs(); glideTo(g);
        const hotIds = options.filter((x) => typeof x === 'object' && x.hot).map((x) => x.hot);
        dropAskBeacon();
        const at = hotIds.length && ao.beacon !== false ? setTimeout(() => { if (!bs.some((b) => b.dataset.done) && bs.some((b) => b.isConnected) && alive()) beaconOn(hotIds); }, ao.beaconAfter != null ? ao.beaconAfter : 2600) : 0;
        if (at) askBeacon = { t: at, ids: hotIds };
        /* F.cancel: resolves { index: -1, cancelled: true } and its hotspots stop picking (the chips fade with the box) */
        const me = {
          cancel() {
            if (bs.some((b) => b.dataset.done)) return;
            bs.forEach((b) => { b.dataset.done = '1'; });
            pend.delete(me);
            clearTimeout(at); if (hotIds.length) beaconOff(hotIds); if (askBeacon && askBeacon.t === at) askBeacon = null;
            unhots.forEach((u) => u());
            res({ index: -1, label: '', value: undefined, cancelled: true });
          }
        };
        pend.add(me);
        function pick(i) {
          if (bs.some((b) => b.dataset.done)) return;
          pend.delete(me);
          bs[i].dataset.done = '1';
          if (canUse(options[i], ao.used)) usedKeys.add(useKey(options[i], labels[i]));
          clearTimeout(at); if (hotIds.length) beaconOff(hotIds); if (askBeacon && askBeacon.t === at) askBeacon = null;
          unhots.forEach((u) => u());
          bs[i].classList.add('is-picked');
          bs.forEach((b, j) => { if (j !== i) b.classList.add('is-gone'); });
          setTimeout(() => { bs.forEach((b) => b.classList.add('is-out')); setTimeout(() => glide(() => bs.forEach((b) => b.remove())), 150); res({ index: i, label: labels[i], value: typeof options[i] === 'object' ? options[i].value : undefined }); }, RM() ? 0 : 240);
        }
      });
    };
    function askSheet(options, labels, ao) {
      return F.sheet((body, close) => {
        const list = h('div', { class: 'ffs-list' });
        options.forEach((x, i) => {
          const b = h('button', { type: 'button', class: 'ffd-choice', style: '--i:' + i },
            typeof x === 'object' && x.icon ? h('img', { src: x.icon, alt: '', class: 'ffd-choice-ic' }) : null, h('span', { text: labels[i] }));
          const k = useKey(x, labels[i]), can = canUse(x, ao.used);
          if (can && usedKeys.has(k)) b.classList.add('is-used');
          /* the sheet slides up and its choices rise one after another: a pointer tap counts once a choice can be read,
             and once the reader has stopped tapping through the text (tooSoon) */
          b.__liveAt = performance.now() + (RM() ? 80 : 200 + i * 50);
          b.addEventListener('click', (e) => { if (tooSoon(e, b)) return; if (can) usedKeys.add(k); wake(); snd('tap'); b.classList.add('is-picked'); setTimeout(() => close({ index: i, label: labels[i], value: typeof x === 'object' ? x.value : undefined }), RM() ? 0 : 200); });
          list.append(b);
        });
        if (ao.extra) list.append(ao.extra(close));
        body.append(list);
      }, { title: ao.prompt });
    }
    F.actions = (list, ao) => {
      ao = ao || {};
      acts.dataset.cols = ao.cols ? String(ao.cols) : '';
      if (ao.hint) setTimeout(() => { if (alive() && acts.isConnected) F.hint([].concat(ao.hint).filter((id) => cssRects[id])); }, ao.hintAfter || 5200);
      const g = glideFrom();
      acts.innerHTML = '';
      acts.className = 'ffs-acts';
      const bs = list.map((x, i) => {
        const b = chip(x.label, { solid: x.solid, quiet: x.quiet, wide: x.wide, i });
        if (x.hidden) b.hidden = true;
        const k = useKey(x, fmt(x.label)), can = canUse(x, ao.used);
        if (can && usedKeys.has(k)) b.classList.add('is-used');
        b.addEventListener('click', () => { wake(); if (can) { usedKeys.add(k); b.classList.add('is-used'); } if (x.sound !== false) snd(x.sound || 'tap'); x.onClick && x.onClick(b, i); });
        acts.append(b);
        return b;
      });
      layoutActs(); glideTo(g);
      /* words still arriving (the box's or a bubble's, also words that start in this same moment: a page that sets out
         its row and then says its line, as the coin does): the row waits, still and untouchable, and rises once they
         have all come. Judged a microtask later, before anything is painted */
      if (bs.length) {
        settle(false);
        acts.classList.add('is-held');
        Promise.resolve().then(() => {
          if (!bs[0].isConnected) return;
          if (idleAll()) { acts.classList.remove('is-held'); return; }
          whenRead().then(() => {
            if (!bs[0].isConnected) return;
            acts.classList.remove('is-held');
            bs.forEach((b, i) => { b.__liveAt = liveAt(i); });
          });
        });
      }
      let off = false;
      return {
        el: acts, btn: (i) => bs[i],
        show(i, on) { const b = bs[i]; if (!b) return; const was = !b.hidden; b.hidden = !on; if (on && !was && !RM()) { b.classList.remove('is-new'); void b.offsetWidth; b.classList.add('is-new'); } },
        label(i, t) { if (bs[i]) bs[i].querySelector('span').textContent = fmt(t); },
        /* a row switched off and on again (the coin's calls while the coin is in the air) comes back once the words
           arriving with it are in, the result line and its punchline, never under them (the words critic, 2026-10-09) */
        disable(on) {
          off = !!on;
          if (off || !bs.length) { bs.forEach((b) => { b.disabled = off; }); return; }
          Promise.resolve().then(() => {
            if (off) return;
            if (idleAll()) { bs.forEach((b) => { b.disabled = false; }); return; }
            whenRead().then(() => { if (off || !alive()) return; bs.forEach((b, i) => { b.disabled = false; b.__liveAt = liveAt(i); }); });
          });
        },
        used(i, on) { const b = bs[i], x = list[i]; if (!b) return; const k = useKey(x, fmt(x.label)); if (on === false) usedKeys.delete(k); else usedKeys.add(k); b.classList.toggle('is-used', on !== false); },
        remove() { acts.innerHTML = ''; }
      };
    };

    /* ---- sheets over the art: the character card, long lists, an item card ---- */
    let sheetOpen = null;
    F.sheet = (build, so) => {
      so = so || {};
      if (sheetOpen) sheetOpen.close(null);
      dropPlate(true);
      return new Promise((res) => {
        const body = h('div', { class: 'ffs-sheet-in' });
        const sh = h('div', { class: 'ffs-sheet' + (so.cls ? ' ' + so.cls : ''), role: 'dialog', 'aria-modal': 'false', 'aria-label': fmt(so.title || 'Choose') },
          so.title ? h('p', { class: 'ffs-sheet-t', text: fmt(so.title) }) : null, body);
        const close = (v) => {
          if (!sh.isConnected) return;
          sheetOpen = null; el.classList.remove('has-sheet');
          sh.classList.remove('is-in'); sh.classList.add('is-out');
          setTimeout(() => sh.remove(), RM() ? 0 : 260);
          res(v);
        };
        sheetOpen = { close };
        build(body, close);
        settle(false);
        el.append(sh); el.classList.add('has-sheet');
        requestAnimationFrame(() => sh.classList.add('is-in'));
        const first = sh.querySelector('input, button'); if (first && WIDE()) setTimeout(() => first.focus({ preventScroll: true }), 280);
      });
    };
    /* ---- who's playing (F.char): no question when a character is saved. A plate says who, a chip in the corner stays,
       and either opens the switch sheet ---- */
    const formSheet = (co, guest) => F.sheet((body, close) => {
      const card = h('div', { class: 'ffd-char ffd-char--sheet' });
      body.append(card);
      charForm(card, Object.assign({}, co, { fresh: true, prompt: null, guest }), ctx.def.id, (c) => setTimeout(() => close(c), RM() ? 0 : 380), () => el);
    }, { title: co.prompt || 'Who is it?', cls: 'is-char' });
    F.char = async (co) => {
      co = co || {};
      if (co.guest) { const g = await formSheet(co, true); if (g && g.name) asChar = g; return g; }
      asChar = null;
      const c = FFD.char;
      if (c && c.name && !co.fresh) { wantMe(ctx); showPlate(c); snd('pen'); return c; }
      const r = await formSheet(co, false);
      if (r && r.name) wantMe(ctx);
      return r;
    };
    F.as = (c) => { asChar = c && c.name ? c : null; };
    /* the corner chip: the reader's face (class icon, or their public Hall picture), and their name on a wide screen */
    function paintMe() {
      if (!meBtn) return;
      const c = FFD.char, lab = c && c.name ? 'Playing as ' + c.name + '. Change' : 'Choose who you’re playing';
      meBtn.innerHTML = '';
      meBtn.append(faceEl(c && c.name ? c : null, 'is-chip'), h('span', { class: 'ffs-me-n', text: c && c.name ? c.name : '' }));
      meBtn.setAttribute('aria-label', lab); meBtn.title = lab;
    }
    function meChip() {
      if (!meBtn) {
        meBtn = h('button', { type: 'button', class: 'ffs-tool ffs-me-tool' });
        meBtn.addEventListener('click', (e) => { e.stopPropagation(); wake(); snd('tap'); openSwitch(); });
        toolsEl.insertBefore(meBtn, muteBtn);
      }
      paintMe();
    }
    F._me = meChip;
    function showPlate(c) {
      dropPlate(true);
      if (!c || !c.name || !alive()) return;
      const go = h('button', { type: 'button', class: 'ffs-me-go', text: 'Change' });
      go.addEventListener('click', (e) => { e.stopPropagation(); wake(); snd('tap'); openSwitch(); });
      const p = h('div', { class: 'ffs-me' }, faceEl(c, 'is-plate'), h('span', { class: 'ffs-me-t' }, 'Playing as ', h('b', { text: c.name })), go);
      el.append(p); plate = p;
      requestAnimationFrame(() => { if (plate === p) p.classList.add('is-in'); });
      live.textContent = 'Playing as ' + c.name + '.';
    }
    function dropPlate(fast) {
      if (!plate) return;
      const p = plate; plate = null;
      p.classList.remove('is-in'); p.classList.add('is-out');
      setTimeout(() => p.remove(), fast || RM() ? 0 : 240);
    }
    /* one sheet at a time: while the page's own sheet is open the chip only shakes, so the page's choice is never lost */
    function openSwitch() {
      if (switching) return switching;
      if (sheetOpen) { if (meBtn) fx.shake(meBtn, 3); return Promise.resolve(null); }
      dropPlate(true);
      switching = F.sheet((body, close) => switchSheet(body, close, { pid: ctx.def.id, frameEl: () => el }), { title: 'Who’s playing?', cls: 'is-char is-switch' })
        .then((c) => { switching = null; if (c && c.name && alive()) showPlate(c); return c; });
      return switching;
    }
    F.change = openSwitch;
    const onChar = () => {
      paintMe();
      if (plate) { const c = FFD.char; if (c && c.name) { const b = plate.querySelector('.ffs-me-t b'); if (b) b.textContent = c.name; } else dropPlate(true); }
    };
    document.addEventListener('ffd:char', onChar);
    cleanups.push(() => { document.removeEventListener('ffd:char', onChar); dropPlate(true); });

    /* ---- dice over the art ---- */
    let rollN = 0;
    F.roll = async (ro) => {
      ro = ro || {};
      const my = ++rollN;
      if (ro.stakes) await F.say([{ text: ro.stakes, cls: 'gold' }], { add: !!ro.add, who: ro.who });
      if (!ro.now && (await F.next(ro.label || 'Roll', { hot: ro.hot, sound: 'tap' })) === 'cancel') return null;
      if (!alive()) return null;
      if (ro.onThrow) { try { ro.onThrow(); } catch (e) { console.error(e); } }
      const sp = ro.dice || [{ sides: 20 }], vals = sp.map((d) => FFD.rand(d.sides));
      F.busy(true);
      snd('dice', { n: sp.length });
      total.className = 'ffs-total'; total.innerHTML = '';
      /* a tray emptied while its dice were still cached (a roll that came within the clear's 300 ms) starts clean */
      if (!tray.firstElementChild && tray.__qodMany) { try { QODice.clear(tray); } catch (e) { /* fine */ } }
      tray.classList.add('is-in');
      const aw = art.clientWidth, ah = art.clientHeight;
      const size = Math.round(Math.max(56, Math.min(112, Math.min(aw / (sp.length + 1.2), ah * 0.34))));
      try {
        await window.QODice.rollMany(tray, sp.map((d, i) => ({ sides: d.sides, result: vals[i], skin: d.skin || (d.sides === 20 ? 'gold' : 'obsidian') })),
          { size, reduced: RM(), stagger: 90, onImpact: () => snd('land') });
      } catch (e) { /* the numbers still count */ }
      if (!alive() || my !== rollN) return null;
      const sum = vals.reduce((a, b) => a + b, 0) + (ro.bonus || 0);
      const i20 = sp.findIndex((d) => d.sides === 20), nat = i20 >= 0 ? vals[i20] : null;
      const crit = nat === 20, fumble = nat === 1, pass = ro.dc != null ? (crit || (!fumble && sum >= ro.dc)) : null;
      const parts = vals.join(' + ') + (ro.bonus ? ' + ' + ro.bonus : '');
      total.innerHTML = `<span class="ffs-total-n">${sum}</span>${sp.length > 1 || ro.bonus ? `<span class="ffs-total-p">${parts}</span>` : ''}`;
      diceAt = Date.now();
      total.classList.add('is-in', crit ? 'is-crit' : fumble ? 'is-fumble' : pass === true ? 'is-pass' : pass === false ? 'is-miss' : 'is-plain');
      if (crit) { snd('crit'); fx.flash('rgba(244,214,138,.32)', el); fx.sparks(total, { n: 26, spread: 120 }); buzz([20, 40, 20]); }
      else if (fumble) { snd('fumble'); fx.flash('rgba(140,26,34,.32)', el); fx.shake(art, 7); buzz(60); }
      else if (pass === true) { snd('pass'); fx.sparks(total, { n: 12, spread: 70 }); }
      else if (pass === false) { snd('miss'); fx.shake(total, 4); }
      F.busy(false);
      const res = { total: sum, rolls: vals, nat, pass, crit, fumble };
      const hold = ro.hold != null ? ro.hold : 1800;
      if (!ro.keep) setTimeout(() => { if (my === rollN) F.clearDice(); }, RM() ? hold + 600 : hold);
      return res;
    };
    /* clearing disposes the dice (QODice.clear destroys them, disconnects their observers and drops the tray's cache), so
       the next roll builds a fresh, visible die: emptying the tray alone left the cache pointing at dice no longer on the
       page, and every roll after the first showed only its number */
    const dropDice = () => { try { if (window.QODice && QODice.clear) QODice.clear(tray); } catch (e) { /* fine */ } tray.innerHTML = ''; };
    F.clearDice = () => { tray.classList.remove('is-in'); total.classList.remove('is-in'); setTimeout(() => { if (!tray.classList.contains('is-in')) dropDice(); }, 300); };
    cleanups.push(() => { try { if (window.QODice && QODice.clear) QODice.clear(tray); } catch (e) { /* fine */ } });

    /* ---- captions over the art ---- */
    let resT = 0;
    F.result = (t, small) => {
      clearTimeout(resT);
      resEl.classList.remove('is-in', 'is-gone'); void resEl.offsetWidth;
      resEl.innerHTML = ''; resEl.append(document.createTextNode(fmt(t))); if (small) resEl.append(h('small', { text: fmt(small) }));
      resEl.classList.add('is-in');
    };
    F.hideResult = () => { if (!resEl.classList.contains('is-in')) return; resEl.classList.add('is-gone'); resT = setTimeout(() => resEl.classList.remove('is-in', 'is-gone'), 320); };

    /* ---- the ending: the last lines, one Quest button, play again ---- */
    F.end = async (eo) => {
      eo = eo || {};
      settleDice();
      el.classList.add('is-ending');
      if (eo.lines) await F.say(eo.lines, { who: eo.who });
      await whenRead();
      await clearActs();
      settle(false);
      const g = glideFrom();
      const c = FFD.char;
      /* a reader who took the Quest (Jan: the scenes no longer sell it to them): back to the library, and the Quest quietly.
         Everyone else keeps the Quest button exactly as it was */
      const taken = took(), lib = taken && ctx.def.id !== 'library' ? FFD.libraryHref() : null;
      let cta = null, home = null;
      if (taken) {
        if (lib) {
          home = h('a', { class: 'ffs-chip is-solid is-wide is-quest is-home', href: lib }, h('span', { text: 'Back to Zhaunil’s library' }));
          home.addEventListener('click', (e) => { if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); wake(); snd('tap'); FFD.leaveTo(lib, el); });
        }
        cta = h('a', { class: 'ffs-chip is-quiet is-again' + (lib ? '' : ' is-quest'), href: FFD.questHref(eo.campaign || ctx.def.id, 'again'), target: eo.target || FFD.questTarget || '_blank', rel: 'noopener' },
          h('span', { text: 'Play the Quest with another hero' }));
      } else {
        cta = h('a', { class: 'ffs-chip is-solid is-wide is-quest', href: FFD.questHref(eo.campaign || ctx.def.id, eo.medium || ctx.medium), target: eo.target || FFD.questTarget || '_blank', rel: 'noopener' },
          h('span', { text: eo.button ? fmt(eo.button) : (c && c.name && eo.named !== false ? 'Begin the Quest with ' + c.name : 'Begin the Quest') }));
      }
      cta.addEventListener('click', () => { wake(); snd('tap'); });
      acts.className = 'ffs-acts is-end';
      /* what every player has done so far: eo.shared is a list of { n, text } ('{n}' is the number) or plain strings */
      if (eo.shared && eo.shared.length) {
        const row = h('p', { class: 'ffs-shared' });
        eo.shared.forEach((it, i) => {
          if (i) row.append(h('span', { class: 'ffs-shared-dot', 'aria-hidden': 'true', text: '·' }));
          if (typeof it === 'string') { row.append(h('span', { text: fmt(it) })); return; }
          const n = Math.max(0, Math.floor(it.n || 0)), from = it.from != null ? it.from : Math.max(0, n - (it.plus != null ? it.plus : 1));
          const parts = fmt(it.text || '{n}').split('{n}'), num = h('b', { class: 'ffs-shared-n', text: from.toLocaleString('en-US') });
          num.dataset.n = String(from);
          row.append(h('span', null, parts[0] || '', num, parts.slice(1).join('{n}')));
          setTimeout(() => FFD.countUp(num, n), RM() ? 0 : 450);
        });
        acts.append(row);
      }
      const lead = taken ? eo.takenLeadIn : eo.leadIn;
      if (lead) acts.append(h('p', { class: 'ffs-lead', text: fmt(lead) }));
      if (home) acts.append(home);
      acts.append(cta);
      if (eo.save) { const sb = chip(eo.save.button || 'Save the card', { i: 1, quiet: true }); sb.addEventListener('click', () => FFD.showCard(eo.save)); acts.append(sb); }
      /* the totals, the lead and the buttons rise in turn after the words (core.css staggers them by place), and a link
         answers a pointer tap once it can be read */
      [home, cta].forEach((a, k) => { if (a) a.__liveAt = liveAt(k + 2); });
      const ended = new Promise((res) => {
        if (eo.again === false) return;
        const ag = chip(eo.again || 'Play again', { quiet: true, i: 2 });
        ag.addEventListener('click', () => { wake(); snd('tap'); res('again'); });
        acts.append(ag);
      });
      glideTo(g);
      return ended;
    };

    /* an extra tool in the art's corner (a clue book, a clock): a 44 px round button left of the hint (or of the sound) */
    F.tool = (to) => {
      to = to || {};
      const b = h('button', { type: 'button', class: 'ffs-tool' + (to.cls ? ' ' + to.cls : ''), 'aria-label': fmt(to.label || ''), title: fmt(to.label || ''), html: to.html || '' });
      if (to.text != null) b.append(h('span', { class: 'ffs-tool-t', text: fmt(to.text) }));
      b.addEventListener('click', (e) => { e.stopPropagation(); wake(); if (to.onClick) to.onClick(b); });
      toolsEl.insertBefore(b, hintBtn.parentNode === toolsEl ? hintBtn : meBtn && meBtn.parentNode === toolsEl ? meBtn : muteBtn);
      return b;
    };
    F.busy = (on) => { isBusy = !!on; el.classList.toggle('is-busy', isBusy); };
    if (o.title) F.title(o.title, o.line);
    if (o.quiet) F.quiet(true);
    cleanups.push(() => { F.hush(); Object.keys(btns).forEach((id) => btns[id].remove()); if (F.mount) F.mount.destroy(); if (sceneOwners[curKey]) delete sceneOwners[curKey]; });
    /* the frames of this page. One that already showed who is playing (ctx.charCard) gets the chip here too */
    const cs = CTXS.get(ctx);
    if (cs) { cs.frames.push(F); if (cs.me) meChip(); }
    return F;
  }

  /* ---------- shared results: what every player's runs add up to ----------
     Jan (2026-10-03): "each game should all be shared like the results should somehow be kept across everyone so that
     people can see them affecting the total somehow".
       FFD.tally.add(page, key, n)        one more for this player (n defaults to 1): calls lost, candles lit, items mended
       FFD.tally.pick(page, key, choice)  this player's latest pick, one per player: who they accused, which idea they want
       FFD.tally.total(page, key)         everyone's total so far, plus the page's story base
       FFD.tally.picks(page, key)         { choice: players } for a pick, everyone included
       FFD.tally.mine(page, key)          this player's own count
       FFD.tally.players(page)            how many players have a result on that page
       FFD.tally.base(page, key, n)       the number the story starts from (the coin had lost 212 calls before anyone played)
       FFD.tally.cap(page, key, n)        the most one player's record may add to that key (default 500; gold sums need more)
       FFD.tally.on(fn) -> off            fn() whenever totals change, including another player's run arriving live
       FFD.tally.shared                   true once totals come from every player; false while only this browser counts
     In the review Artifact the store is the db capability: collection 'plays', one document per player (plays/<their id>)
     holding { c: { 'coin.lost': 12 }, p: { 'mystery.accused': 'zerros' }, at }. Everyone reads every document, each player
     writes only their own (rules: plays read view write owner; plays/{self} write interact), and a total is the sum over
     the documents. Other players' documents are untrusted: keys, numbers and picks are checked and clamped. A viewer who
     can't write still sees everyone's totals and counts their own plays on top, in this browser. With no store at all
     (a saved copy, file://) everything counts in this browser only. On the store, FFD.tally.useStore({ load, save, watch })
     plugs in the live backend instead (see docs/scene-pages/demo2/research/SHARED-RESULTS-PLAN.md). */
  FFD.tally = (() => {
    const KEY_RE = /^[a-z0-9-]{1,24}\.[a-z0-9-]{1,32}$/, PICK_RE = /^[a-z0-9-]{1,40}$/;
    const mine = { c: {}, p: {} }, bases = {}, caps = {}, fns = [];
    const CAP = 500;   /* the most one player's record may add to any key, unless a page raises it with FFD.tally.cap() */
    const capOf = (k) => caps[k] || CAP;
    let others = { c: {}, p: {}, players: {} }, ref = null, canWrite = false, dirty = false, wT = 0, chain = Promise.resolve(), store = null;
    const T = { shared: false };
    try { const sv = JSON.parse(localStorage.getItem('ffd-tally') || 'null'); if (sv && sv.c) { clean(sv, mine); } } catch (e) { /* fine */ }
    function clean(src, into) {
      into = into || { c: {}, p: {} };
      if (src && src.c && typeof src.c === 'object') Object.keys(src.c).forEach((k) => { const n = src.c[k]; if (KEY_RE.test(k) && typeof n === 'number' && isFinite(n) && n > 0) into.c[k] = Math.min(capOf(k), Math.floor(n)); });
      if (src && src.p && typeof src.p === 'object') Object.keys(src.p).forEach((k) => { const v = src.p[k]; if (KEY_RE.test(k) && typeof v === 'string' && PICK_RE.test(v)) into.p[k] = v; });
      return into;
    }
    const k2 = (page, key) => String(page) + '.' + String(key);
    const emit = () => fns.slice().forEach((f) => { try { f(); } catch (e) { /* a listener must not break the others */ } });
    const keepLocal = () => { try { localStorage.setItem('ffd-tally', JSON.stringify(mine)); } catch (e) { /* fine */ } };
    function flush() {
      if (!dirty) return;
      dirty = false;
      const body = { c: Object.assign({}, mine.c), p: Object.assign({}, mine.p), at: Date.now() };
      if (store && store.save) { chain = chain.then(() => store.save(body)).catch(() => {}); return; }
      if (!ref || !canWrite) return;
      chain = chain.then(() => ref.set(body)).catch((e) => { if (e && e.code === 'invalid_argument') canWrite = false; });
    }
    function changed() { keepLocal(); dirty = true; clearTimeout(wT); wT = setTimeout(flush, 600); emit(); }
    function sumDocs(docs, skip) {
      const sum = { c: {}, p: {}, players: {} };
      docs.forEach((d) => {
        if (!d || d.id === skip) return;
        const b = clean(d.body);
        const pages = {};
        Object.keys(b.c).forEach((k) => { sum.c[k] = (sum.c[k] || 0) + b.c[k]; pages[k.split('.')[0]] = 1; });
        Object.keys(b.p).forEach((k) => { const v = b.p[k]; (sum.p[k] = sum.p[k] || {})[v] = (sum.p[k][v] || 0) + 1; pages[k.split('.')[0]] = 1; });
        Object.keys(pages).forEach((pg) => { sum.players[pg] = (sum.players[pg] || 0) + 1; });
      });
      return sum;
    }
    async function connect() {
      if (store) return;
      const cl = window.claude;
      if (!cl || typeof cl.use !== 'function') return;
      try {
        const [db, user] = await Promise.all([cl.use('db'), cl.use('user')]);
        if (!db) return;
        const uid = user ? await user.id() : null;
        const cw = user && user.can ? await user.can('data.write') : null;
        canWrite = !!uid && cw !== false;
        if (uid) {
          ref = db.collection('plays').doc(uid);
          try {
            const snap = await ref.get();
            if (snap.exists) {   /* the same player on another device: keep the larger count of each */
              const b = clean(snap.data());
              Object.keys(b.c).forEach((k) => { mine.c[k] = Math.max(mine.c[k] || 0, b.c[k]); });
              Object.keys(b.p).forEach((k) => { if (!mine.p[k]) mine.p[k] = b.p[k]; });
              keepLocal();
            }
          } catch (e) { /* reads can wait */ }
        }
        db.collection('plays').limit(1000).onSnapshot((qs) => {
          others = sumDocs(qs.docs.map((d) => ({ id: d.id, body: d.data() })), uid);
          T.shared = true; emit();
        }, () => { /* a dead subscription leaves the last totals on show */ });
        if (Object.keys(mine.c).length || Object.keys(mine.p).length) { dirty = true; flush(); }
      } catch (e) { /* stays in this browser */ }
    }
    T.useStore = (st) => {
      store = st;
      try {
        if (st.load) Promise.resolve(st.load()).then((b) => { if (b) { const c2 = clean(b); Object.keys(c2.c).forEach((k) => { mine.c[k] = Math.max(mine.c[k] || 0, c2.c[k]); }); emit(); } }).catch(() => {});
        if (st.watch) st.watch((totals) => { if (totals) { others = { c: totals.c || {}, p: totals.p || {}, players: totals.players || {} }; T.shared = true; emit(); } });
      } catch (e) { /* fine */ }
    };
    T.add = (page, key, n) => { const k = k2(page, key); if (!KEY_RE.test(k)) return; mine.c[k] = Math.min(capOf(k), (mine.c[k] || 0) + Math.max(1, Math.floor(n || 1))); changed(); };
    /* a page that raises a key's limit gets back the count this browser saved past the default limit, which the load
       above had to cut (bounty's gold: two big posters pass 500) */
    T.cap = (page, key, n) => {
      const k = k2(page, key);
      caps[k] = Math.max(1, Math.floor(n || CAP));
      try {
        const sv = JSON.parse(localStorage.getItem('ffd-tally') || 'null'), v = sv && sv.c ? sv.c[k] : null;
        if (KEY_RE.test(k) && typeof v === 'number' && isFinite(v) && v > (mine.c[k] || 0)) { mine.c[k] = Math.min(caps[k], Math.floor(v)); emit(); }
      } catch (e) { /* fine */ }
    };
    T.pick = (page, key, choice) => { const k = k2(page, key), v = String(choice || ''); if (!KEY_RE.test(k) || !PICK_RE.test(v)) return; if (mine.p[k] === v) return; mine.p[k] = v; changed(); };
    T.base = (page, key, n) => { bases[k2(page, key)] = Math.max(0, Math.floor(n || 0)); };
    T.mine = (page, key) => mine.c[k2(page, key)] || 0;
    T.minePick = (page, key) => mine.p[k2(page, key)] || null;
    T.total = (page, key) => { const k = k2(page, key); return (bases[k] || 0) + (others.c[k] || 0) + (mine.c[k] || 0); };
    T.picks = (page, key) => {
      const k = k2(page, key), out = Object.assign({}, others.p[k] || {});
      if (mine.p[k]) out[mine.p[k]] = (out[mine.p[k]] || 0) + 1;
      return out;
    };
    T.players = (page) => (others.players[page] || 0) + (Object.keys(mine.c).concat(Object.keys(mine.p)).some((k) => k.split('.')[0] === page) ? 1 : 0);
    T.on = (fn) => { fns.push(fn); return () => { const i = fns.indexOf(fn); if (i >= 0) fns.splice(i, 1); }; };
    T.ready = new Promise((res) => { const go = () => connect().then(res, res); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go, { once: true }); else setTimeout(go, 0); });
    try { window.addEventListener('pagehide', flush); } catch (e) { /* fine */ }
    return T;
  })();
  /* a number that counts up to its new value (the totals on the page grow in front of the reader) */
  FFD.countUp = (el, to, o) => {
    o = o || {};
    if (!el) return;
    const from = Number(el.dataset.n || el.textContent.replace(/[^0-9]/g, '') || 0), fmtN = o.format || ((n) => n.toLocaleString('en-US'));
    el.dataset.n = String(to);
    if (RM() || from === to || !isFinite(from)) { el.textContent = fmtN(to); return; }
    const t0 = performance.now(), dur = o.ms || Math.min(1200, 400 + Math.abs(to - from) * 40);
    const step = (t) => { const u = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - u, 3); el.textContent = fmtN(Math.round(from + (to - from) * e)); if (u < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
    if (to > from && !o.quiet) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
  };

  /* ---------- the way home, and leaving with a fade ----------
     Zhaunil's library holds every scene (Jan, 2026-10-05: "you can walk out and then it naturally transitions into the
     scenes"). Every other scene page gets a book in its corner back to the library whenever the library can be reached:
     the store's section prints window.FFD_LIBRARY = { url } only while the library's page is published, and the review
     demo's hub sets it to '#library'. FFD.leaveTo(href, frameEl) fades the frame out (about 300 ms, none under reduced
     motion), then goes: a '#id' changes the hash, anything else loads in this tab. On the store both pages opt into the
     browser's cross-page fade (core.css @view-transition), so the walk reads as one move where browsers support it. */
  FFD.libraryHref = () => { const L = window.FFD_LIBRARY; return L && typeof L.url === 'string' && L.url ? L.url : null; };
  FFD.leaveTo = (href, el) => {
    if (!href) return;
    const go = () => { if (/^#/.test(href)) { location.hash = href; if (el) setTimeout(() => { if (el.isConnected) el.classList.remove('is-leaving'); }, 1200); } else location.href = href; };
    if (!el || RM()) { go(); return; }
    el.classList.add('is-leaving');
    setTimeout(go, 300);
  };
  /* Back restores a page from the browser's cache exactly as it was left, mid-fade: show it again */
  window.addEventListener('pageshow', (e) => { if (e.persisted) document.querySelectorAll('.ffs.is-leaving').forEach((f) => f.classList.remove('is-leaving')); });
  /* the cross-page fade (core.css @view-transition) plays only when the next page opts in too. Only scene pages do (the
     library and the scenes it lists), so toward any other page (the Quest, the product, the Hall) skip it here, or Chrome
     reports "Transition was aborted" */
  /* a fade that the browser aborts (a phone's address bar resizing the viewport mid-fade) rejects its promises: hold
     them on both sides so an aborted fade is never an uncaught error */
  const hush = (vt) => { try { vt.ready.catch(() => {}); vt.finished.catch(() => {}); if (vt.updateCallbackDone) vt.updateCallbackDone.catch(() => {}); } catch (er) { /* fine */ } };
  window.addEventListener('pagereveal', (e) => { if (e && e.viewTransition) hush(e.viewTransition); });
  window.addEventListener('pageswap', (e) => {
    const vt = e && e.viewTransition; if (!vt) return;
    hush(vt);
    const path = (u) => { try { const x = new URL(u, location.href); return x.origin === location.origin ? x.pathname.replace(/\/$/, '') : null; } catch (er) { return null; } };
    let to = null;
    try { to = e.activation && e.activation.entry ? path(e.activation.entry.url) : null; } catch (er) { to = null; }
    const site = window.FFD_SITE, lib = FFD.libraryHref();
    const scenes = [lib].concat(site && site.scenes ? Object.values(site.scenes) : []).filter((u) => typeof u === 'string' && !/^#/.test(u)).map(path);
    if (to && scenes.includes(to)) return;
    try { vt.ready.catch(() => {}); vt.finished.catch(() => {}); vt.skipTransition(); } catch (er) { /* fine */ }
  });

  /* ---------- registry and mounting ---------- */
  FFD.page = (def) => {
    if (FFD.pages.some((p) => p.id === def.id)) return;
    FFD.pages.push(def); FFD.pages.sort((a, b) => (a.order || 99) - (b.order || 99));
    try { document.dispatchEvent(new CustomEvent('ffd:page', { detail: def })); } catch (e) { /* fine */ }
  };
  FFD.mount = (def, el, opts) => {
    /* the egg kit's visit days count before the page renders, so its eggs see today's visit */
    try { markVisit(def && def.id); } catch (e) { /* fine */ }
    const ctx = makeCtx(def, el, opts);
    el.classList.add('ffd-page', 'ffd-page--' + def.id);
    try { const r = def.render(ctx); if (r && r.catch) r.catch((e) => console.error(def.id, e)); }
    catch (e) { console.error(def.id, e); el.append(h('p', { class: 'ffd-err', text: 'This page failed to build: ' + e.message })); }
    bed(ctx, el, def);
    return ctx;
  };

  /* ---------- background music (Jan, 2026-10-07: "all the scenes in background music too") ----------
     A page whose section names one of Jan's records (data-ffd-music, the section's Background music setting) plays it
     softly under its own sounds through the shared player (FFD.music, music.js). Where music.js can try it
     (music.tryStart), the record starts on arrival when the browser allows sound; when it doesn't, the reader's first
     tap, click or key on the page wakes it (music.kick, inside that gesture, the way iPhones need it). With an older
     music.js the first tap starts it, as before. The corner's sound button mutes it with everything else, and a reader
     who arrives muted starts it by turning sound on. Data saver skips it. The library (data-ffd-full) runs its own
     jukebox instead. ctx.music(id, fadeSec) crosses to another record (coin: the road, then Tailspin's table). */
  function bed(ctx, el, def) {
    const id = el.getAttribute && el.getAttribute('data-ffd-music');
    if (!id || el.hasAttribute('data-ffd-full') || typeof FFD.music !== 'function' || !FFD.music.TRACKS || !FFD.music.TRACKS[id]) return;
    try { const c = navigator.connection; if (c && c.saveData) return; } catch (e) { /* fine */ }
    const cs = CTXS.get(ctx), b = cs ? cs.bed : { want: null, cue: null };
    let m = null, started = false, want = b.want || id;
    const KEYS = /^(Enter| |Spacebar|Tab|Arrow\w+)$/;
    const make = () => {
      if (m) return m;
      m = FFD.music({ level: 0.55, album: def.title || 'FramedFantasy' });
      ctx.onKill(() => { try { m.close(); } catch (e) { /* fine */ } });
      return m;
    };
    /* another record: cross to it once one plays; before that, it is the one that starts */
    b.cue = (nid, fadeSec) => {
      want = nid;
      if (!m || !started) return true;
      try {
        if (m.on) { if (m.id !== nid) m.play(nid, fadeSec); }
        /* refused before any voice began (music.js keeps it waiting): this record waits instead */
        else if (m.blocked && typeof m.tryStart === 'function') m.tryStart(nid);
      } catch (e) { /* fine */ }
      return true;
    };
    /* inside a tap, click or key: the music starts (or, after a refused try, wakes) here */
    const go = () => {
      if (!ctx.alive()) return;
      const sd = S(); if (sd && sd.muted) return;
      off();
      make();
      if (!started) { started = true; m.start(want); return; }
      try { if (typeof m.kick === 'function') m.kick(); else m.start(want); } catch (e) { /* fine */ }
      if (m.id && m.id !== want) { try { m.play(want, 1.2); } catch (e) { /* fine */ } }
    };
    const onTap = () => go();
    const onKey = (e) => { if (e && KEYS.test(e.key || '')) go(); };
    const onMute = (e) => { if (e && e.detail && e.detail.muted === false) go(); };
    function off() {
      el.removeEventListener('click', onTap, true); el.removeEventListener('touchend', onTap, true); el.removeEventListener('keydown', onKey, true);
      document.removeEventListener('ffsound:mute', onMute);
    }
    el.addEventListener('click', onTap, true); el.addEventListener('touchend', onTap, true); el.addEventListener('keydown', onKey, true);
    document.addEventListener('ffsound:mute', onMute);
    ctx.onKill(off);
    /* the try on arrival: never for a reader who arrived muted (their sound button starts it). The listeners above wait
       for a gesture in case the browser says no (and a tap before the answer wakes it all the same) */
    const sd = S();
    if (sd && sd.muted) return;
    let probe = null;
    /* an older music.js has no tryStart: then the player waits for the first tap, as before */
    try { probe = typeof make().tryStart === 'function' ? m.tryStart(want) : null; } catch (e) { probe = null; }
    if (!probe) return;
    started = true;
    Promise.resolve(probe).then((ok) => {
      if (!ctx.alive()) return;
      if (ok === true) { off(); if (m.id && m.id !== want) { try { m.play(want, 1.2); } catch (e) { /* fine */ } } }
    }, () => { /* refused: the first gesture wakes it */ });
  }
})();

/* quest-id.js: who the reader is, read from this browser only (src/scene-pages/quest-id.js). Every scene page runs it,
   right after core.js and before any page mounts (harness/build-scene-pages.cjs puts it in ff-scene-page.js). It makes
   no network call and reads nothing but this browser’s storage. The review demo copies core.js alone, so every caller
   checks that FFD.quest exists first.

   THE PROOF that the Character Quest was taken on this browser, in order:
     a. the library’s own saved copy, localStorage 'ffd-quest-hero' (written the first time a proof is seen, so "Start a
        new quest" in the Quest never loses the hero);
     b. the Quest’s run, localStorage 'qo2:run' ({t, phase, bp, fired, ai}, assets/quest-one-v2.js saveRun), counted
        only when bp.claimed === true. An unfinished run never counts;
     c. the Quest’s lead flags, localStorage 'qo2:lead', when Lead === 1. That proves the Quest but carries no hero.
   The run can be hundreds of KB (the uploaded picture rides in it), so the leading "t" is read with a regex first, and
   the whole run is parsed only when that t is new and the text holds "claimed":true.

   WHAT IS COPIED from a claimed run, once: the hero’s name, class (label and key: lowercase, no spaces, so Blood
   Hunter is bloodhunter, checked against FFD.classes(), else 'other'), race (label and key), level, pronouns (he/him
   to he, she/her to she, they/them to they, anything else to x with the words cut to 12 characters), a body shape
   (he gives m, she gives f, everything else n), the looks the Quest offers (skin, hair, hairStyle, build, age, a beard
   from the marks, and the features as keys horns, tail, wings, pointedears, tusks, scales, fur, or none), the
   archetype title, three Quest choices (approach, coinCall, coinWon) and the Hall hero id (hallIn.id or hallT.heroId).
   NEVER read or copied: the email (or the run’s '(kept private)' stand-in), the phone, the player’s own name (alias),
   the private memory, the uploaded picture, the story, quest_meta, the PDF and share-card links, sid and leadToken.
   Every value is checked against a list or cut to length, and the copy is rebuilt key by key from a whitelist.

   'ffd-quest-hero' v1: { v, took, via ('run' | 'lead' | 'hall' | 'email'), at, runT, rk, name, cls, clsLabel, race,
   raceKey, pr, prText, body, look: { skin, hair, hairStyle, build, age, beard, feats[] }, level, title, quest: {
   approach, coinCall, coinWon }, heroId, slug, thumb, frame: { x, y, zoom }, public, heroes: [up to 6 { id, slug, name,
   race, cls, clsLabel, public, fromQuest, thumb, frame }], checkedDay, noHall }, or after "Not you?" { v, forgot: {
   runT, rk, hall } }. via 'email' is the ledger's email door (the Quest's email, no PIN). thumb and frame are kept only
   for a public hero (approved and not hidden). rk is a short hash of the run hero’s name, class and race (no words of
   theirs), so a run the Quest saves again later is known as the same run. noHall (true, or absent) says the Hall
   session on this browser isn't this reader's: it is set by "Not you?" and kept by every hero that comes after it (an
   email pick, a newer run), until the reader signs Zhaunil's ledger with a Hall PIN themselves (set(hero, 'hall')).

   FFD.char (core.js reads 'ffd-char' first) takes the quest hero when 'ffd-char' is empty, or came from the quest or
   the Hall (src 'quest' or 'hall'), or when a newly seen claimed run is newer than it (run t later than ffd-char.at;
   an old record without at counts as 0). A character the reader typed or picked after that is never overwritten.
   'ffd-char' v2: { v: 2, src: 'quest' | 'hall' | 'typed' | 'picked', name, cls, clsLabel, pr, prText, race, raceKey,
   body, look, heroId, at }. The five old fields keep their names and meanings.

   FFD.quest
     took() -> boolean           hero() -> the hero or null       heroes() -> the Hall heroes the ledger saved (max 6)
     scan() -> { took, hero, fresh }   reads storage again. fresh is true only the first time this run or Hall pick
                                       is seen on this device, and scan() hands it out once per page (a hero first
                                       seen while the page loaded is fresh for the first scan() call)
     set(hero, via, o) -> { took, hero, fresh }   the ledger’s pick (via 'hall', or 'email' from the email door). hero
                                       null keeps the hero, and only a null via keeps how it came (an unknown one is
                                       'hall'). o: { heroes, took, checkedDay, silent } (silent: never over a typed or
                                       picked FFD.char)
     forget()                    "Not you?": the copy goes, { v: 1, forgot: { runT, rk, hall: false } } stays, so the
                                 same run and the lead flag are not taken up again (a newer claimed run is) and the
                                 ledger stops its silent refresh. 'ffd-char' is cleared only when it came from the
                                 quest or the Hall. qo2:* and hoh-* keys are never touched
     info() -> { took, via, at, checkedDay, forgot, noHall }   charOf(hero, src) -> an 'ffd-char' v2 record (not saved)
     norm: { cls(label), race(label), pr(text) -> { pr, prText }, body(pr) }
   Events on document: 'ffd:quest' { took, hero, fresh } on every change, and 'ffd:char' { char, prev, by } whenever
   this file changes FFD.char. A storage change from another tab and a back/forward-cache return read again. */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  if (FFD.quest && FFD.quest.v === 1) return;
  const K_COPY = 'ffd-quest-hero', K_CHAR = 'ffd-char', K_RUN = 'qo2:run', K_LEAD = 'qo2:lead';
  const RESUME_MS = 72 * 3600e3;   /* the Quest resumes a run this young (quest-one-v2.js loadRun) */
  const now = () => Date.now();

  /* ---------- storage, every access guarded (a private window or blocked storage throws) ---------- */
  const store = () => { try { return window.localStorage || null; } catch (e) { return null; } };
  const get = (k) => { try { const s = store(); return s ? s.getItem(k) : null; } catch (e) { return null; } };
  const put = (k, v) => { try { const s = store(); if (!s) return false; s.setItem(k, v); return true; } catch (e) { return false; } };
  const del = (k) => { try { const s = store(); if (s) s.removeItem(k); } catch (e) { /* fine */ } };
  const readJSON = (k) => { const s = get(k); if (!s) return null; try { return JSON.parse(s); } catch (e) { return null; } };
  const emit = (type, detail) => { try { document.dispatchEvent(new CustomEvent(type, { detail })); } catch (e) { /* fine */ } };

  /* ---------- values: checked against a list or cut to length ---------- */
  const str = (v, n) => (typeof v === 'string' ? v.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, n) : '');
  const keyOf = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 40);
  const QUEST_CLASSES = ['Barbarian', 'Bard', 'Cleric', 'Druid', 'Fighter', 'Monk', 'Paladin', 'Ranger', 'Rogue', 'Sorcerer', 'Warlock', 'Wizard', 'Artificer', 'Blood Hunter'];
  function classList() {
    try { if (typeof FFD.classes === 'function') { const l = FFD.classes(); if (Array.isArray(l) && l.length) return l.filter((c) => c && c.key); } } catch (e) { /* fall through */ }
    return QUEST_CLASSES.map((l) => ({ key: keyOf(l), label: l }));
  }
  /* the class key the icons know: the label’s own key, else the first known class named in it ("Oath of Vengeance
     Paladin"), else 'other' (the generic icon) */
  function clsKey(label) {
    const known = classList().map((c) => c.key), k = keyOf(label);
    if (!k) return 'other';
    if (known.includes(k)) return k;
    const words = String(label).toLowerCase().split(/[^a-z]+/);
    for (const w of words) if (w && known.includes(w)) return w;
    return 'other';
  }
  const clsLabelOf = (key) => { const c = classList().find((x) => x.key === key); return c ? c.label : 'Adventurer'; };
  function prOf(v) {
    const t = str(v, 24), k = t.toLowerCase().replace(/\s+/g, '');
    if (!t) return { pr: 'they', prText: '' };
    if (k === 'he/him' || k === 'he') return { pr: 'he', prText: '' };
    if (k === 'she/her' || k === 'she') return { pr: 'she', prText: '' };
    if (k === 'they/them' || k === 'they') return { pr: 'they', prText: '' };
    return { pr: 'x', prText: t.slice(0, 12) };
  }
  const bodyOf = (pr) => (pr === 'he' ? 'm' : pr === 'she' ? 'f' : 'n');
  /* the Quest’s own look lists (assets/quest-one-v2-data.js LOOK); anything else, the Quest’s free words included, is left out */
  const LOOK = {
    skin: ['Warm brown', 'Pale', 'Sun-tanned', 'Deep umber', 'Ashen grey', 'Crimson', 'Green'],
    hair: ['Black', 'Dark brown', 'Copper red', 'Blonde', 'Silver-white', 'No hair', 'Dyed'],
    hairStyle: ['Long and loose', 'Braided', 'Short crop', 'Tied back', 'Shaved sides', 'Wild'],
    build: ['Tall and lean', 'Broad and strong', 'Short and quick', 'Average build', 'Heavy set', 'Wiry'],
    age: ['Young', 'In their prime', 'Seasoned', 'Old', 'Ageless']
  };
  const FEATS = { 'Horns': 'horns', 'A tail': 'tail', 'Wings': 'wings', 'Pointed ears': 'pointedears', 'Tusks': 'tusks', 'Scales': 'scales', 'Fur': 'fur', 'None of these': 'none' };
  const FEAT_KEYS = Object.keys(FEATS).map((k) => FEATS[k]);
  const PRS = ['he', 'she', 'they', 'x'], BODIES = ['m', 'f', 'n'], VIAS = ['run', 'lead', 'hall', 'email'], SRCS = ['quest', 'hall', 'typed', 'picked'];
  const oneOf = (list, v) => (list.includes(v) ? v : '');
  const idOf = (v) => { const s = typeof v === 'number' && isFinite(v) ? String(v) : typeof v === 'string' ? v.trim() : ''; return /^[A-Za-z0-9-]{1,64}$/.test(s) ? s : ''; };
  const slugOf = (v) => (typeof v === 'string' && /^[a-z0-9-]{1,80}$/.test(v) ? v : '');
  /* a picture link: https, or this site’s own path (a fixture’s stand-in), never a data: or script link */
  const picOf = (v) => (typeof v === 'string' && v.length <= 600 && (/^https:\/\/[^\s\x22\x27<>]+$/.test(v) || /^\/(?!\/)[^\s\x22\x27<>]*$/.test(v)) ? v : '');
  const num = (v, lo, hi, d) => (typeof v === 'number' && isFinite(v) && v >= lo && v <= hi ? v : d);
  const intIn = (v, lo, hi) => { const n = Math.round(Number(v)); return isFinite(n) && n >= lo && n <= hi ? n : null; };
  const dayOf = (v) => (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v : '');
  const timeOf = (v) => (typeof v === 'number' && isFinite(v) && v > 0 ? Math.round(v) : 0);
  function frameOf(f) { if (!f || typeof f !== 'object') return null; return { x: num(f.x, 0, 100, 50), y: num(f.y, 0, 100, 50), zoom: num(f.zoom, 100, 200, 100) }; }
  function lookOf(l) {
    l = l && typeof l === 'object' ? l : {};
    const feats = Array.isArray(l.feats) ? [...new Set(l.feats.filter((f) => FEAT_KEYS.includes(f)))].slice(0, 8) : [];
    return { skin: oneOf(LOOK.skin, l.skin), hair: oneOf(LOOK.hair, l.hair), hairStyle: oneOf(LOOK.hairStyle, l.hairStyle), build: oneOf(LOOK.build, l.build), age: oneOf(LOOK.age, l.age), beard: l.beard === true, feats };
  }
  /* a short hash of who the run hero is (name, class, race), never their words */
  function fp(h) {
    if (!h || !h.name) return '';
    const s = keyOf(h.name) + '|' + (h.cls || '') + '|' + keyOf(h.race);
    let x = 0x811c9dc5;
    for (let i = 0; i < s.length; i++) { x ^= s.charCodeAt(i); x = Math.imul(x, 0x01000193) >>> 0; }
    return x.toString(36);
  }

  /* ---------- the hero fields, rebuilt from a whitelist ---------- */
  function heroFields(h) {
    h = h && typeof h === 'object' ? h : {};
    const name = str(h.name, 40);
    const clsLabel = str(h.clsLabel, 48), cls = h.cls && /^[a-z0-9]{1,24}$/.test(h.cls) ? h.cls : clsKey(clsLabel);
    const race = str(h.race, 48), p = PRS.includes(h.pr) ? { pr: h.pr, prText: h.pr === 'x' ? str(h.prText, 12) : '' } : prOf(h.prText || '');
    const pub = h.public === true;
    const o = {
      name, cls, clsLabel: clsLabel || clsLabelOf(cls), race, raceKey: keyOf(race), pr: p.pr, prText: p.prText,
      body: BODIES.includes(h.body) ? h.body : bodyOf(p.pr), look: lookOf(h.look), level: intIn(h.level, 1, 20), title: str(h.title, 60),
      quest: { approach: typeof (h.quest && h.quest.approach) === 'string' && /^[a-z0-9-]{1,24}$/.test(h.quest.approach) ? h.quest.approach : '',
        coinCall: oneOf(['heads', 'tails'], h.quest && h.quest.coinCall), coinWon: !!(h.quest && h.quest.coinWon === true) },
      heroId: idOf(h.heroId), slug: slugOf(h.slug), public: pub
    };
    if (pub) { const t = picOf(h.thumb), f = frameOf(h.frame); if (t) o.thumb = t; if (f) o.frame = f; }
    return o;
  }
  function hallEntry(e) {
    e = e && typeof e === 'object' ? e : {};
    const name = str(e.name, 40); if (!name) return null;
    const clsLabel = str(e.clsLabel, 48), cls = e.cls && /^[a-z0-9]{1,24}$/.test(e.cls) ? e.cls : clsKey(clsLabel);
    const o = { id: idOf(e.id), slug: slugOf(e.slug), name, race: str(e.race, 48), cls, clsLabel: clsLabel || clsLabelOf(cls), public: e.public === true, fromQuest: e.fromQuest === true };
    if (o.public) { const t = picOf(e.thumb), f = frameOf(e.frame); if (t) o.thumb = t; if (f) o.frame = f; }
    return o;
  }
  const HERO_KEYS = ['name', 'cls', 'clsLabel', 'race', 'raceKey', 'pr', 'prText', 'body', 'look', 'level', 'title', 'quest', 'heroId', 'slug', 'thumb', 'frame', 'public'];
  /* the whole copy, key by key: anything not named here never reaches storage */
  function clean(c) {
    if (!c || typeof c !== 'object') return null;
    if (c.forgot && typeof c.forgot === 'object') return { v: 1, forgot: { runT: timeOf(c.forgot.runT), rk: /^[0-9a-z]{1,8}$/.test(c.forgot.rk || '') ? c.forgot.rk : '', hall: false } };
    const o = { v: 1, took: c.took === true, via: oneOf(VIAS, c.via) || 'run', at: timeOf(c.at) || now(), runT: timeOf(c.runT), rk: /^[0-9a-z]{1,8}$/.test(c.rk || '') ? c.rk : '' };
    if (str(c.name, 40)) { const h = heroFields(c); HERO_KEYS.forEach((k) => { if (h[k] !== undefined) o[k] = h[k]; }); }
    const heroes = Array.isArray(c.heroes) ? c.heroes.map(hallEntry).filter(Boolean).slice(0, 6) : [];
    if (heroes.length) o.heroes = heroes;
    const d = dayOf(c.checkedDay); if (d) o.checkedDay = d;
    if (c.noHall === true) o.noHall = true;
    return o;
  }
  const heroOut = (c) => { if (!c || c.forgot || !c.name) return null; const o = {}; HERO_KEYS.forEach((k) => { if (c[k] !== undefined) o[k] = JSON.parse(JSON.stringify(c[k])); }); return o; };

  /* ---------- the Quest’s run ---------- */
  /* the run’s leading "t" without parsing it (saveRun writes {"t":...,"phase":...}) */
  function runHead() {
    const raw = get(K_RUN);
    if (!raw) return null;
    const m = /^\s*\{\s*"t"\s*:\s*(\d{1,16})\s*[,}]/.exec(raw.slice(0, 64));
    return { raw, t: m ? +m[1] : null };
  }
  function fromRun(r) {
    const b = r && r.bp;
    if (!b || typeof b !== 'object' || b.claimed !== true) return null;
    const clsLabel = str(b.charClass, 48), cls = clsKey(clsLabel), p = prOf(b.pronouns);
    const feats = Array.isArray(b.features) ? b.features.map((f) => FEATS[f]).filter(Boolean) : [];
    const a = r.ai && r.ai.archetype && typeof r.ai.archetype === 'object' ? r.ai.archetype : null;
    return heroFields({
      name: b.name, cls, clsLabel: clsLabel || clsLabelOf(cls), race: b.race, pr: p.pr, prText: p.prText, body: bodyOf(p.pr),
      look: { skin: b.skin, hair: b.hair, hairStyle: b.hairStyle, build: b.build, age: b.age, beard: Array.isArray(b.marks) && b.marks.includes('A beard'), feats },
      level: b.level, title: a ? a.title : '', quest: { approach: b.approach, coinCall: b.coinCall, coinWon: b.coinWon === true },
      heroId: (b.hallIn && b.hallIn.id) || (b.hallT && b.hallT.heroId) || ''
    });
  }

  /* ---------- 'ffd-char' ---------- */
  function charOf(h, src) {
    h = heroFields(h);
    return { v: 2, src: oneOf(SRCS, src) || 'quest', name: h.name, cls: h.cls, clsLabel: h.clsLabel, pr: h.pr, prText: h.prText, race: h.race, raceKey: h.raceKey, body: h.body, look: h.look, heroId: h.heroId, at: now() };
  }
  const sameChar = (a, b) => !!(a && b && a.name === b.name && a.cls === b.cls && a.clsLabel === b.clsLabel && a.pr === b.pr && (a.prText || '') === (b.prText || '') &&
    (a.race || '') === (b.race || '') && (a.heroId || '') === (b.heroId || '') && a.body === b.body && JSON.stringify(a.look || null) === JSON.stringify(b.look || null));
  function writeChar(next) {
    const prev = FFD.char || null;
    if (next) { if (!put(K_CHAR, JSON.stringify(next))) { /* storage full or blocked: this page still uses it */ } } else del(K_CHAR);
    FFD.char = next;
    emit('ffd:char', { char: next, prev, by: 'quest-id' });
  }
  /* the quest or Hall hero into FFD.char, by the newest-wins rule (always when the reader picked it in the ledger) */
  function adopt(copy, o) {
    if (!copy || !copy.name) return;
    const cur = readJSON(K_CHAR) || FFD.char || null;
    const src = copy.via === 'hall' ? 'hall' : 'quest';
    const mine = !cur || !cur.name || cur.src === 'quest' || cur.src === 'hall';
    let take = false;
    if (o.always) take = true;
    else if (mine) take = true;
    else if (o.newRun && (+copy.runT || 0) > (+cur.at || 0)) take = true;
    if (!take) return;
    const next = charOf(heroOut(copy), src);
    if (cur && sameChar(cur, next) && cur.src === src && cur.v === 2) { FFD.char = cur; return; }
    writeChar(next);
  }

  /* ---------- reading storage ---------- */
  let state = { took: false, hero: null, heroes: [], info: { took: false, via: '', at: 0, checkedDay: '', forgot: false, noHall: false } }, pending = false;
  function remember(c) {
    const ok = c && !c.forgot;
    state = { took: !!(ok && c.took), hero: ok ? heroOut(c) : null, heroes: ok && c.heroes ? c.heroes.slice() : [],
      info: { took: !!(ok && c.took), via: ok ? c.via : '', at: ok ? c.at : 0, checkedDay: ok ? c.checkedDay || '' : '', forgot: !!(c && c.forgot), noHall: !!(ok && c.noHall) } };
  }
  function writeCopy(c) { const x = clean(c); if (x) put(K_COPY, JSON.stringify(x)); return x; }
  function sync() {
    const raw = readJSON(K_COPY), prev = clean(raw);
    let copy = prev ? Object.assign({}, prev) : null, fresh = false, changed = false, newRun = false;
    const forgot = copy && copy.forgot ? copy.forgot : null;
    /* the run: skipped while its t is the one already seen; parsed only when it says "claimed":true */
    const head = runHead();
    if (head) {
      const seenT = forgot ? forgot.runT : copy ? copy.runT : 0;
      if (head.t == null || head.t !== seenT) {
        if (/"claimed"\s*:\s*true/.test(head.raw)) {
          let run = null; try { run = JSON.parse(head.raw); } catch (e) { run = null; }
          const h = fromRun(run);
          if (h) {
            const rk = fp(h), t = timeOf(run && run.t) || now();
            if (forgot && rk && rk === forgot.rk && Math.abs(t - forgot.runT) < RESUME_MS) { copy.forgot = { runT: t, rk, hall: false }; changed = true; }
            else if (copy && !forgot && rk && rk === copy.rk) {
              /* the same run, saved again by the Quest: the hero id, title and level may have filled in since. Only a
                 copy whose hero is the run's own takes them (an email or Hall pick of someone else keeps its fields) */
              copy.runT = t; changed = true;
              if (copy.via === 'run' && fp(copy) === rk) ['heroId', 'title', 'level', 'quest', 'look'].forEach((k) => { if (h[k] !== '' && h[k] !== null && h[k] !== undefined) copy[k] = h[k]; });
            } else {
              const keep = copy && !forgot ? copy : {};
              copy = Object.assign({ v: 1, took: true, via: 'run', at: now(), runT: t, rk }, h, { heroes: keep.heroes, checkedDay: keep.checkedDay }, forgot || keep.noHall ? { noHall: true } : {});
              fresh = true; changed = true; newRun = true;
            }
          }
        }
      }
    }
    /* the lead flag: proof without a hero (never after "Not you?") */
    if (!(copy && copy.forgot) && !(copy && copy.took)) {
      const lead = readJSON(K_LEAD);
      if (lead && typeof lead === 'object' && lead.Lead === 1) {
        copy = Object.assign({}, copy || {}, { v: 1, took: true, via: copy && (copy.via === 'hall' || copy.via === 'email') ? copy.via : 'lead', at: (copy && copy.at) || now() });
        fresh = true; changed = true;
      }
    }
    if (changed) copy = writeCopy(copy);
    const before = state;
    remember(copy);
    /* another tab’s typed character reaches this page too */
    const stored = readJSON(K_CHAR);
    if (stored && stored.name && !sameChar(stored, FFD.char)) { const p = FFD.char || null; FFD.char = stored; emit('ffd:char', { char: stored, prev: p, by: 'storage' }); }
    if (copy && !copy.forgot) adopt(copy, { newRun });
    if (fresh) pending = true;
    if (changed || before.took !== state.took || JSON.stringify(before.hero) !== JSON.stringify(state.hero)) emit('ffd:quest', { took: state.took, hero: heroOut(state.hero), fresh });
    return fresh;
  }

  /* ---------- the ledger’s pick, and "Not you?" ---------- */
  function set(hero, via, o) {
    o = o || {};
    const prev = clean(readJSON(K_COPY));
    const base = prev && !prev.forgot ? prev : {};
    /* only a null via keeps how the hero came: an email pick is never stored as the run's (sync() would pour a re-saved
       run's fields onto it) */
    const next = { v: 1, via: oneOf(VIAS, via) || (via == null ? base.via : '') || 'hall', at: now(),
      runT: base.runT || (prev && prev.forgot ? prev.forgot.runT : 0), rk: base.rk || (prev && prev.forgot ? prev.forgot.rk : ''),
      checkedDay: dayOf(o.checkedDay) || base.checkedDay };
    /* after "Not you?" the Hall session here is someone else's, until the reader signs the ledger with a PIN (via 'hall') */
    if (((prev && prev.forgot) || base.noHall) && next.via !== 'hall') next.noHall = true;
    let h = null;
    if (hero && typeof hero === 'object' && str(hero.name, 40)) { h = heroFields(hero); Object.assign(next, h); }
    else if (base.name) HERO_KEYS.forEach((k) => { if (base[k] !== undefined) next[k] = base[k]; });
    /* only a new hero moves at; the daily refresh keeps when the proof was first written */
    if ((!h || fp(h) === fp(base)) && base.at) next.at = base.at;
    next.heroes = Array.isArray(o.heroes) ? o.heroes : base.heroes;
    const list = (Array.isArray(next.heroes) ? next.heroes : []).map(hallEntry).filter(Boolean);
    next.took = o.took != null ? !!o.took || !!base.took : !!(base.took || (hero && hero.fromQuest === true) || list.some((e) => e.fromQuest));
    const fresh = !!((next.took && !base.took) || (h && h.name && fp(h) !== fp(base)));
    const copy = writeCopy(next);
    remember(copy);
    if (h) {
      const cur = readJSON(K_CHAR) || FFD.char || null;
      if (!o.silent || !cur || !cur.name || cur.src === 'quest' || cur.src === 'hall') adopt(copy, { always: true });
    }
    const r = { took: state.took, hero: heroOut(state.hero), fresh };
    emit('ffd:quest', r);
    return { took: r.took, hero: heroOut(state.hero), fresh };
  }
  function forget() {
    const prev = clean(readJSON(K_COPY)), head = runHead();
    let rk = prev && !prev.forgot ? prev.rk : prev && prev.forgot ? prev.forgot.rk : '';
    if (head && /"claimed"\s*:\s*true/.test(head.raw)) { try { const h = fromRun(JSON.parse(head.raw)); if (h) rk = fp(h) || rk; } catch (e) { /* fine */ } }
    const runT = head && head.t != null ? head.t : prev && !prev.forgot ? prev.runT : prev && prev.forgot ? prev.forgot.runT : 0;
    remember(writeCopy({ forgot: { runT, rk, hall: false } }));
    pending = false;
    const cur = readJSON(K_CHAR) || FFD.char || null;
    if (cur && (cur.src === 'quest' || cur.src === 'hall')) writeChar(null);
    emit('ffd:quest', { took: false, hero: null, fresh: false });
  }

  FFD.quest = {
    v: 1,
    took: () => state.took,
    hero: () => heroOut(state.hero),
    heroes: () => state.heroes.map((e) => JSON.parse(JSON.stringify(e))),
    scan() { const f = sync(); const fresh = pending || f; pending = false; return { took: state.took, hero: heroOut(state.hero), fresh }; },
    set, forget,
    info: () => Object.assign({}, state.info),
    charOf: (hero, src) => charOf(hero, src),
    norm: { cls: clsKey, race: keyOf, pr: prOf, body: bodyOf }
  };

  sync();
  try {
    window.addEventListener('storage', (e) => { if (!e || e.key == null || [K_RUN, K_LEAD, K_COPY, K_CHAR].includes(e.key)) sync(); });
    window.addEventListener('pageshow', (e) => { if (e && e.persisted) sync(); });
  } catch (e) { /* fine */ }
})();

/* The shared totals on the live store: FFD.tally on the Hall of Heroes Supabase project.
   Jan (2026-10-03): "each game should all be shared like the results should somehow be kept across everyone so that people
   can see them affecting the total somehow". The design is docs/scene-pages/demo2/research/SHARED-RESULTS-PLAN.md, the tables
   and doors are sql/SCENE-TALLY-01-SHARED-RESULTS.sql, and harness/scene-tally.test.cjs proves the two together.

   harness/build-scene-pages.cjs appends this file after core.js in assets/ff-scene-page.js. The review demo never loads it
   (docs/scene-pages/demo2 keeps the Artifact's db). It does anything only on the live store (window.FFD.live, set by
   sections/ff-scene-page.liquid) when that section printed the Hall's address and public key (window.FFD_HALL).

   Before the SQL is installed it is harmless. The first read of the totals answers 404, and the adapter goes quiet for the
   rest of the visit (no polling, no sending). FFD.tally.shared stays false, so the pages keep their own-browser wording, and
   every count waits in this browser (core's localStorage 'ffd-tally') to be sent on a later visit.

   Once it's installed:
     load   nothing (core already keeps this browser's own counts in localStorage)
     save   sends only what this browser hasn't delivered yet (localStorage 'ffd-tally-sent'). A count that grew by 1 is one
            scene_tally_add, gold that grew by 2,000 goes as 820, 820 and 360, a changed pick is one scene_tally_pick naming
            the old pick, and once per page per browser '<page>.players' is added, so FFD.tally.players counts browsers that
            have played and never guesses. At most 12 calls a save (the doors take 30 a minute from one address), every
            call with keepalive. Nothing is sent before the first read has shown the doors exist. A call that fails stays
            owed for the next save, and a key the allow list doesn't have is skipped for the rest of the visit.
     watch  reads everyone's totals when the page opens, every 45 s while the tab is showing, when the reader comes back to
            the tab, and after each save. It hands core everyone's totals minus what this browser has sent, because core
            adds this browser's own counts on top (a reader's own +1 shows at once and never twice).
   What leaves the browser: page keys and numbers ('coin.lost', 1) and a pick ('parcel.sender', 'owed'). No names, emails,
   ids, cookies or referrer. A page key ending in '.players' is the adapter's own, so no page may use 'players' as a key. */
(function () {
  'use strict';
  try {
    const W = window, F = W.FFD, HALL = W.FFD_HALL;
    if (!F || F.live !== true || !F.tally || typeof F.tally.useStore !== 'function' || F.tally.store) return;
    if (!HALL || typeof HALL.url !== 'string' || !HALL.url || typeof HALL.key !== 'string' || !HALL.key || typeof W.fetch !== 'function') return;
    /* the shared totals weren't there a little while ago: count in this browser this visit, ask again later */
    try { const slept = Number(W.localStorage.getItem('ffd-tally-none')) || 0; if (slept && Date.now() - slept < 6 * 3600 * 1000) return; } catch (e) { /* fine */ }
    const BASE = HALL.url.replace(/\/+$/, '') + '/rest/v1/';
    const KEY_RE = /^[a-z0-9-]{1,24}\.[a-z0-9-]{1,32}$/, PICK_RE = /^[a-z0-9-]{1,40}$/, PAGE_RE = /^[a-z0-9-]{1,24}$/;
    /* the most one call may add: each key's max_step in the SQL (every other key adds 1 a call) */
    const STEP = { 'bounty.gold': 820, 'sellsword.gold': 12, 'library.study': 15 };
    const MOST = 12, POLL = 45000, SOON = 10000, SENT = 'ffd-tally-sent', ASLEEP = 'ffd-tally-none', NAP = 6 * 3600 * 1000;
    const HEAD = { apikey: HALL.key, Authorization: 'Bearer ' + HALL.key };
    let watcher = null, on = false, quiet = false, mute = false, timer = 0, lastRead = 0, reading = false, queue = Promise.resolve();
    const refused = {};
    const obj = (x) => (x && typeof x === 'object' ? x : {});
    const get = (k) => { try { return JSON.parse(W.localStorage.getItem(k) || 'null'); } catch (e) { return null; } };
    function clean(s) {
      s = obj(s);
      const o = { c: {}, p: {}, pl: {} };
      Object.keys(obj(s.c)).forEach((k) => { const n = s.c[k]; if (KEY_RE.test(k) && typeof n === 'number' && isFinite(n) && n >= 1) o.c[k] = Math.floor(n); });
      Object.keys(obj(s.p)).forEach((k) => { const v = s.p[k]; if (KEY_RE.test(k) && typeof v === 'string' && PICK_RE.test(v)) o.p[k] = v; });
      Object.keys(obj(s.pl)).forEach((pg) => { if (PAGE_RE.test(pg) && s.pl[pg]) o.pl[pg] = 1; });
      return o;
    }
    const sent = clean(get(SENT));
    const keep = () => { try { W.localStorage.setItem(SENT, JSON.stringify(sent)); } catch (e) { /* this visit keeps it in memory */ } };
    /* one thing at a time: a read never lands while a call is in the air, and two saves never send the same count */
    const later = (fn) => { const p = queue.then(() => fn().catch(() => {})); queue = p; return p; };

    function call(name, args) {
      return W.fetch(BASE + 'rpc/' + name, {
        method: 'POST', keepalive: true, credentials: 'omit', referrerPolicy: 'no-referrer',
        headers: { apikey: HALL.key, Authorization: 'Bearer ' + HALL.key, 'Content-Type': 'application/json' }, body: JSON.stringify(args)
      }).then((r) => (r.ok ? { ok: true } : r.json().then((b) => ({ ok: false, status: r.status, code: b && b.code ? String(b.code) : '' }), () => ({ ok: false, status: r.status, code: '' }))),
        () => ({ ok: false, status: 0, code: '' }));
    }
    /* true: skip this key and go on; false: stop this save (whatever is left stays owed) */
    function failed(r, key) {
      if (r.status === 400 && r.code === '22023') { refused[key] = 1; return true; }   /* not on the allow list, or switched off */
      if (r.status === 401 || r.status === 403) { stop(); return false; }              /* the key isn't let in: quiet for the visit */
      if (r.status === 404) { mute = true; return false; }                             /* the doors aren't there: no more sends this visit */
      return false;                                                                     /* too many (429), offline or a hiccup */
    }
    function send(body) {
      return later(async () => {
        if (quiet || mute || !on) return;
        const b = clean(body), pages = {};
        let calls = 0, r;
        Object.keys(b.c).concat(Object.keys(b.p)).forEach((k) => { pages[k.slice(0, k.indexOf('.'))] = 1; });
        const done = () => { if (calls) read(true); };
        /* one more player, once per page per browser */
        for (const pg of Object.keys(pages)) {
          const pk = pg + '.players';
          if (sent.pl[pg] || refused[pk]) continue;
          if (calls >= MOST) return done();
          sent.pl[pg] = 1; keep(); calls++;
          r = await call('scene_tally_add', { p_page_key: pk, p_n: 1 });
          if (!r.ok) { delete sent.pl[pg]; keep(); if (!failed(r, pk)) return done(); }
        }
        for (const k of Object.keys(b.c)) {
          if (refused[k] || /\.players$/.test(k)) continue;
          let have = sent.c[k] || 0;
          /* a lower count here is a page that hasn't raised the key's limit yet (core cuts a saved count to the default
             limit until the page that owns the key says otherwise): never lower what was sent, or it would go twice */
          if (b.c[k] <= have) continue;
          while (b.c[k] > have) {
            if (calls >= MOST) return done();
            const n = Math.min(b.c[k] - have, STEP[k] || 1);
            /* marked first, so a call still in the air as the page closes is never sent again; put back if it fails */
            sent.c[k] = have + n; keep(); calls++;
            r = await call('scene_tally_add', { p_page_key: k, p_n: n });
            if (!r.ok) { if (have) sent.c[k] = have; else delete sent.c[k]; keep(); if (failed(r, k)) break; return done(); }
            have += n;
          }
        }
        for (const k of Object.keys(b.p)) {
          const v = b.p[k], was = sent.p[k] || null;
          if (was === v || refused[k + '=' + v]) continue;
          if (calls >= MOST) return done();
          sent.p[k] = v; keep(); calls++;
          r = await call('scene_tally_pick', { p_page_key: k, p_choice: v, p_prev: was });
          if (!r.ok) { if (was) sent.p[k] = was; else delete sent.p[k]; keep(); if (!failed(r, k + '=' + v)) return done(); }
        }
        done();
      });
    }
    /* everyone's totals, less what this browser has sent (core adds this browser's own on top) */
    function totals(rows) {
      const t = { c: {}, p: {}, players: {} };
      rows.forEach((row) => {
        if (!row || typeof row.page_key !== 'string') return;
        const k = row.page_key, n = Math.max(0, Math.floor(Number(row.n) || 0)), at = k.indexOf('=');
        if (at > 0) {
          const key = k.slice(0, at), v = k.slice(at + 1);
          if (KEY_RE.test(key) && PICK_RE.test(v)) (t.p[key] = t.p[key] || {})[v] = Math.max(0, n - (sent.p[key] === v ? 1 : 0));
          return;
        }
        if (!KEY_RE.test(k)) return;
        const pg = k.slice(0, k.indexOf('.'));
        if (k === pg + '.players') t.players[pg] = Math.max(0, n - (sent.pl[pg] ? 1 : 0));
        else t.c[k] = Math.max(0, n - (sent.c[k] || 0));
      });
      return t;
    }
    function read(now) {
      if (quiet || !watcher || reading) return;
      const t = Date.now();
      if (!now && t - lastRead < SOON) return;
      lastRead = t; reading = true;
      later(async () => {
        try {
          if (quiet) return;
          let r;
          try { r = await W.fetch(BASE + 'scene_tally_public?select=page_key,n', { headers: HEAD, credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store' }); }
          catch (e) { return; }   /* offline: the last totals stay on show and the next poll tries again */
          /* not installed, or not let in: quiet, and quiet for the next six hours of visits too, so a store without the
             SQL doesn't ask on every page view */
          if (r.status === 404 || r.status === 401 || r.status === 403) { try { W.localStorage.setItem(ASLEEP, String(Date.now())); } catch (e) { /* fine */ } stop(); return; }
          if (!r.ok) return;
          let rows;
          try { rows = await r.json(); } catch (e) { return; }
          if (!Array.isArray(rows)) return;
          const first = !on;
          on = true;
          try { W.localStorage.removeItem(ASLEEP); } catch (e) { /* fine */ }
          watcher(totals(rows));
          /* anything an earlier visit still owes (a call that failed, a tab closed offline, plays before the SQL) goes now */
          if (first) { const own = get('ffd-tally'); if (own) send(own); }
        } finally { reading = false; }
      });
    }
    const onShow = () => { if (!document.hidden) read(false); };
    function stop() {
      quiet = true;
      if (timer) clearInterval(timer);
      timer = 0;
      try { document.removeEventListener('visibilitychange', onShow); } catch (e) { /* fine */ }
    }
    F.tally.store = 'hall';
    F.tally.useStore({
      load: () => null,
      save: send,
      watch: (cb) => {
        watcher = cb;
        read(true);
        if (quiet) return;
        timer = setInterval(() => { if (!document.hidden) read(true); }, POLL);
        document.addEventListener('visibilitychange', onShow);
      }
    });
  } catch (e) { /* the pages count in this browser, as before */ }
})();
